webpackJsonp([22],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Enum = function () {
  function Enum(value) {
    _classCallCheck(this, Enum);

    if (this.constructor.isLocked) {
      throw new Error('You attempted to add a property to an Enum after it was locked: ' + String(value));
    }

    if (typeof value === 'undefined') {
      throw new Error('Cannot define an Enum type with no value');
    }

    this.value = value;
  }

  _createClass(Enum, [{
    key: 'toString',
    value: function toString() {
      return String(this.value);
    }
  }], [{
    key: 'fromValue',
    value: function fromValue(value) {
      var _this = this;

      if (value === undefined) return undefined;
      var found = void 0;

      Object.keys(this).forEach(function (key) {
        if (_this[key].value === value) {
          found = _this[key];
        }
      });

      return found;
    }
  }, {
    key: 'values',
    get: function get() {
      var _this2 = this;

      return Object.keys(this).reduce(function (acc, key) {
        return _this2[key] instanceof _this2 ? [].concat(_toConsumableArray(acc), [_this2[key]]) : acc;
      }, []);
    }
  }]);

  return Enum;
}();

/* harmony default export */ __webpack_exports__["a"] = (Enum);

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(888);
__webpack_require__(903);
__webpack_require__(461);
__webpack_require__(284);
__webpack_require__(1255);
__webpack_require__(904);
__webpack_require__(1256);
__webpack_require__(889);
__webpack_require__(1257);
__webpack_require__(643);
__webpack_require__(906);
__webpack_require__(644);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(1258);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(912);
__webpack_require__(1276);
__webpack_require__(913);
__webpack_require__(1277);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(580);
__webpack_require__(1280);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(1281);
__webpack_require__(1282);
module.exports = __webpack_require__(1283);


/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(14);

var _underscore2 = _interopRequireDefault(_underscore);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _conversation = __webpack_require__(284);

var _conversation2 = _interopRequireDefault(_conversation);

var _requestable = __webpack_require__(461);

var _requestable2 = _interopRequireDefault(_requestable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Rover2.default.models.RecurringBillingModel = _requestable2.default.extend({
  isRecurring: true,
  initialize: function initialize() {
    var _this = this;

    this.on('change:days change:start_date', function () {
      _this.trigger('datesChanged');
    });
  },
  getOpk: function getOpk() {
    return this.getActiveConversation().getOpk();
  },
  getActiveConversation: function getActiveConversation() {
    return new _conversation2.default(this.get('active_conversation'));
  },
  getServiceType: function getServiceType() {
    return this.getActiveConversation().getServiceType();
  },
  getRelationship: function getRelationship() {
    return this.getActiveConversation().getRelationship();
  },
  getState: function getState() {
    return this.getActiveConversation().getState();
  },
  getDatesData: function getDatesData() {
    return {
      start_date: this.get('start_date'),
      days: this.get('days')
    };
  },
  unitsAndDatesAsSentence: function unitsAndDatesAsSentence() {
    var out = '';
    var numUnitsPerDay = void 0;
    var days = _Rover2.default.utils.syndeticJoin(this.daysListMap(function (day) {
      return day;
    }));
    if (this.getActiveConversation().supportsNumUnitsPerDay()) {
      numUnitsPerDay = this.getNumUnitsPerDay();
      out += numUnitsPerDay;
      if (numUnitsPerDay > 1) {
        out += ' times ';
      } else {
        out += ' time ';
      }
      out += 'per day ';
    }

    return out + ' weekly on ' + days;
  },
  daysMap: function daysMap(func) {
    return _underscore2.default.map(this.get('days'), func);
  },
  daysListMap: function daysListMap(func) {
    return this.daysMap(function (day) {
      return _Rover2.default.utils.capitalizeFirstLetter(day.day).slice(0, 3);
    });
  },
  daysList: function daysList() {
    return this.daysListMap(function (day) {
      return day.slice(0, 3);
    });
  },
  getNumUnitsPerDay: function getNumUnitsPerDay() {
    var days = this.get('days');

    if (days.length === 0) {
      return 1;
    }

    return days[0].num_units;
  },
  saveNumUnitsPerDay: function saveNumUnitsPerDay(numUnitsPerDay, optimisticAttrUpdate) {
    var newDays = this.daysMap(function (day) {
      return {
        day: day.day,
        num_units: numUnitsPerDay
      };
    });

    return this.saveDraftPricing({ days: newDays }, optimisticAttrUpdate);
  },
  shadowSave: function shadowSave(attributes) {
    var _this2 = this;

    // For some operations (i.e. create request, cancel request) the API
    // expects the client to set some model attributes to specific values,
    // call PUT, then it will return the model with updated attributes.
    //
    // There may be many Views listening to attributes on this model. If
    // we have to change one of those attributes to facilitate the the
    // specific API operation (like 'request') then some listeners may
    // be triggered even though we didn't set that attribute to a normal
    // state.
    //
    // To work around this trouble, we're creating a copy of the model
    // which includes all of that model's attributes, saving it, and
    // when that save succeeds, updating the original with the new
    // attributes.
    //
    // Alternatives to this approach include:
    // 1. Use this.set(attributes, {silent: true}) which will suppress
    //    triggers. If the subsequent save fails, however, the model
    //    could be left in an invalid state. Also, the Backbone docs
    //    say that you should probably never use {silent: True}
    // 2. Put a property on the Conversation model so that it can track
    //    when this save is in flight. All listeners on request should
    //    ignore changes while it is in flight. Once the save completes,
    //    disable the flag.
    var shadowAttributes = _extends({}, this.attributes, attributes);
    var shadow = new _Rover2.default.models.RecurringBillingModel(shadowAttributes);
    shadow.set('booking_add_ons', shadow.getActiveBookingAddOns());
    return shadow.save().then(function (data, responseStatus, xhr) {
      _this2.set(data);
    }, function (err) {
      var confirmation = void 0;
      var non_field_errors = err.responseJSON.non_field_errors || [];
      if (err.status === 409 && err.statusText === 'CONFLICT') {
        confirmation = confirm('This request has been updated since you loaded this page. Press OK to see up-to-date details.');
      } else if (err.status === 400 && non_field_errors.includes('start_date cannot be in the past')) {
        confirmation = confirm('This request has a start date in the past. It will need to be changed before it can be booked.');
      }

      if (confirmation) {
        location.reload();
      }
    });
  },
  getDraftPricing: function getDraftPricing(options) {
    var uri = this.get('urls').pricing;
    var request = _extends({
      service: this.get('service'),
      requester: this.get('requester').url,
      pets: _underscore2.default.pluck(this.get('pets'), 'url'),
      days: this.get('days'),
      start_date: this.get('start_date')
    }, options);

    return _jquery2.default.ajax({
      method: 'POST',
      url: uri,
      data: JSON.stringify(request),
      contentType: 'application/json'
    });
  },
  savePricingDataPostBooking: function savePricingDataPostBooking(data) {
    var _this3 = this;

    var requestSet = false;
    if (this.get('request') === null) {
      this.set('request', true);
      requestSet = true;
    }

    return this.savePricingData(data).fail(function () {
      if (requestSet) _this3.set('request', null);
    });
  }
});

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

var _moment = __webpack_require__(20);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function ISOFormat(dateStr) {
    return (0, _moment2.default)(dateStr, [_datetime2.default.DATE_SHORT, _datetime2.default.DATE_ISO]).format(_datetime2.default.DATE_ISO);
  }

  Rover.models.DateRange = Backbone.Model.extend({
    defaults: {
      start_date: '',
      end_date: ''
    },

    iso_start_date: function iso_start_date() {
      var date = this.get('start_date');
      return date ? ISOFormat(date) : date;
    },
    iso_end_date: function iso_end_date() {
      var date = this.get('end_date');
      return date ? ISOFormat(date) : date;
    },
    toJSON: function toJSON() {
      var data = Backbone.Model.prototype.toJSON.call(this);
      // Make sure the end date is always greater than or equal to
      // the start date
      if (this.iso_end_date() < this.iso_start_date()) {
        data.end_date = data.start_date;
      }
      return data;
    }
  });

  Rover.models.MultiDate = Backbone.Model.extend({
    defaults: {
      dates: []
    },

    iso_dates: function iso_dates() {
      return _.map(this.get('dates'), ISOFormat);
    },
    setDays: function setDays(days) {
      var dates = _.uniq(_.map(days, _.bind(this._dateFromDayStr, this)));
      dates.sort();
      this.set('dates', dates);
    },
    _dateFromDayStr: function _dateFromDayStr(day) {
      // Find the moment.js day number for 'day'
      var dayNumber = _.reduce([/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i], function (prev, current, index) {
        return day.search(current) > -1 ? index : prev;
      }, -1);
      // Make sure we don't return days in the past
      if (dayNumber < (0, _moment2.default)().day()) {
        dayNumber += 7;
      }
      return (0, _moment2.default)().day(dayNumber).format(_datetime2.default.DATE_SHORT);
    }
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

var _rover_modal = __webpack_require__(100);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

__webpack_require__(905);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
  var $conversation = null;
  var saveOptions = null;
  var conversationDetailUrl = null;
  var SOURCE_HEADER = Rover.api.getSourceHeader($('.js-book-or-archive-actions').length > 0 ? 'web/inbox-pending' : 'web/conversation-detail');

  var save = function save(options) {
    saveOptions = options;

    if (typeof options.shouldAcceptNonSpayed !== 'undefined' || typeof options.shouldAcceptNonNeutered !== 'undefined') {
      $.ajax({
        url: Rover.urls.serviceHostingPreferences,
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          accepts_unspayed_females: options.shouldAcceptNonSpayed,
          accepts_non_neutered_males: options.shouldAcceptNonNeutered
        }),
        success: function success() {
          archive();
        },

        error: onSaveError
      });
    } else {
      archive();
    }
  };

  var onSaveError = function onSaveError() {
    var failureModal = new _rover_modal2.default({
      title: 'Failure',
      content: 'Your preferences could not be updated. Please try again in a few moments.',
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });
    failureModal.open();
  };

  var archive = function archive() {
    $.ajax({
      url: conversationDetailUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        provider_archived_status: saveOptions.reason ? { reason: saveOptions.reason } : null
      }),
      success: showArchiveSuccessModal,
      error: showArchiveErrorModal
    });
  };

  var showArchiveSuccessModal = function showArchiveSuccessModal() {
    var confirmationModal = new _rover_modal2.default({
      title: 'Success',
      content: 'Your conversation has been archived',
      showFooter: true,
      cancelText: 'Undo',
      okCloses: true
    });

    confirmationModal.on('cancel', function () {
      undoArchive();
    });

    confirmationModal.open();
    toggleUndoButton(true);
  };

  var showArchiveErrorModal = function showArchiveErrorModal() {
    var failureModal = new _rover_modal2.default({
      title: 'Failure',
      content: 'Your conversation couldn’t be archived. Please try again in a few moments.',
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });

    failureModal.open();
    toggleUndoButton(false);
  };

  var undoArchive = function undoArchive() {
    $.ajax({
      url: conversationDetailUrl,
      method: 'PUT',
      contentType: 'application/json',
      headers: SOURCE_HEADER,
      data: JSON.stringify({
        provider_archived_status: null
      }),
      success: function success() {
        toggleUndoButton(false);
      },

      error: showArchiveUndoErrorModal
    });
  };

  var showArchiveUndoErrorModal = function showArchiveUndoErrorModal() {
    var failureModal = new _rover_modal2.default({
      title: 'Failure',
      content: 'Unable to undo archiving. Please try again in a few moments.',
      showFooter: true,
      disableCancel: true,
      okCloses: true
    });
    failureModal.open();
  };

  var toggleUndoButton = function toggleUndoButton(show) {
    $conversation.find('.js-archive-complete').toggle(show);
    $conversation.find('.js-move-to-archive').toggle(!show);
  };

  $('.js-move-to-archive').on('click', function (event) {
    $conversation = $(this).closest('.js-conversation-container');
    var currentOpk = $conversation.attr('data-opk');
    conversationDetailUrl = $conversation.data('conversation-detail-url');

    var archiveConversationBtn = $(event.currentTarget);
    var eventData = _.extend({}, { event: archiveConversationBtn.data('event') }, archiveConversationBtn.data('event-merge'));
    dataLayer.push(eventData);

    window.archive_modal = new Rover.views.ArchiveModalView({
      title: 'Archive this request',
      content: $('.js-archive-modal'),
      showFooter: true,
      cancelText: null,
      okCloses: true,
      okText: 'Save',
      conversationDetailUrl: conversationDetailUrl,
      onSave: save
    });

    window.archive_modal.open();
  });

  $('.js-undoarchive').on('click', function () {
    undoArchive();
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(31)))

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _rover_modal = __webpack_require__(100);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (document) {
  function getModalContent(conversation) {
    if (!conversation || !conversation.blocking_modal) {
      var d = _jquery2.default.Deferred();
      d.reject();
      return d.promise();
    }

    return _jquery2.default.get(conversation.blocking_modal.web_url);
  }

  function showModal(modalContent) {
    var backboneModal = new _rover_modal2.default({
      content: modalContent,
      disableCancel: true,
      animate: true,
      padding: false,
      showFooter: false
    });
    backboneModal.open();

    // and then wait for the acknowledgement
    var d = _jquery2.default.Deferred();
    (0, _jquery2.default)(document).on('safety-dialog-acknowledged', function () {
      backboneModal.close();
      d.resolve();
    });

    return d.promise();
  }

  /*
        Returns a Promise which will be fulfilled if the dialog is completed
        or will be rejected if the dialog is not needed or if anything fails.
    */
  function handleSafetyDialog(conversationUri) {
    return _jquery2.default.get(conversationUri).then(getModalContent).then(showModal);
  }

  function doSafetyAdvisory(conversation) {
    return getModalContent(conversation).then(showModal);
  }

  function triggerSafetyDialogAcknowledged() {
    (0, _jquery2.default)(document).trigger('safety-dialog-acknowledged');

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.rover && window.webkit.messageHandlers.rover.postMessage) {
      window.webkit.messageHandlers.rover.postMessage({
        action: 'dialog-closed'
      });
    } else {
      (0, _jquery2.default)(document).trigger({ type: 'dialog-closed' });
    }
  }

  function acknowledgeSafetyForm($target) {
    var payload = $target.serialize();
    var uri = $target.attr('action');

    return _jquery2.default.post(uri, payload).always(triggerSafetyDialogAcknowledged);
  }

  function init() {
    (0, _jquery2.default)(document).on('submit', '#safety-acknowledgement-form', function (event) {
      event.preventDefault();
      (0, _jquery2.default)(event.currentTarget).attr('disabled', 'disabled');
      (0, _jquery2.default)(event.currentTarget).closest('.js-modal-dialog').addClass('rover-loading');
      acknowledgeSafetyForm((0, _jquery2.default)(event.currentTarget));
    });
  }

  _Rover2.default.safety = {
    handleSafetyDialog: handleSafetyDialog,
    doSafetyAdvisory: doSafetyAdvisory
  };
  init();
})(document);

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

$(function () {
  'use strict';

  var validator = void 0;

  var starRatingErrorPlacement = function starRatingErrorPlacement($error, $element) {
    if ($element.hasClass('starrating') || $element.hasClass('labeledstarrating')) {
      $element = $element.closest('.form-group');
    }
    if ($element.attr('name') != 'description') {
      $.validator.defaults.errorPlacement($error, $element);
    }
  };

  /*
    * Implement custom handling to jump to the first invalid
    * form field, even if it's one of our hidden star inputs.
    */
  var starRatingInvalidHandler = function starRatingInvalidHandler(ev, validator) {
    var $firstErrorElement = $(validator.errorList[0].element);

    if ($firstErrorElement.hasClass('starrating')) {
      var _top = $firstErrorElement.closest('.form-group').offset().top;
      // Add a bit of top because the wrapped control will be
      // covered otherwise
      _top -= 150;
      $('html, body').animate({
        scrollTop: _top
      }, 'fast');
    }
    $.validator.defaults.invalidHandler(ev, validator);
  };

  var petRatingFormValidator = {
    ignore: [],
    errorPlacement: starRatingErrorPlacement,
    invalidHandler: starRatingInvalidHandler
  };

  $.validator.addMethod('requireAtLeastOneField', function (value, element, fields) {
    var $form = $(element).closest('form');
    var nonEmptyFields = _.reduce(fields, function (memo, value) {
      return memo + ($form.find('[name=' + value + ']').val() ? 1 : 0);
    }, 0);
    return nonEmptyFields > 0;
  });

  var sitterRatingFormValidator = {
    ignore: [],
    errorPlacement: starRatingErrorPlacement,
    invalidHandler: starRatingInvalidHandler,
    rules: {
      overall: {
        required: {
          depends: function depends(element) {
            var $private = $('[name=private]');
            // If private feedback is more than just
            // spaces we don't require a star rating
            if (!$private.val().match(/^\s*$/)) {
              return false;
            }
            return true;
          }
        }
      }
    },
    messages: {
      overall: 'A star rating is required.'
    }
  };

  var initializeFormValidation = function initializeFormValidation() {
    // Pet ratings form handler
    if ($('.js-rate-pets-form').length > 0) {
      validator = $('.js-rate-pets-form').roverValidate(petRatingFormValidator);
    } else {
      validator = $('.js-rate-sitter-form').roverValidate(sitterRatingFormValidator);
    }
  };

  var initPopovers = function initPopovers() {
    Rover.stickyPopover($('[data-toggle="sticky-popover"]'), {
      container: 'body'
    });
  };

  var initializeRatings = function initializeRatings() {
    $('.js-star-rating-widget').each(function () {
      var $this = $(this),
          overallInputName = $this.attr('data-uid'),
          $overallInput = $('[name=' + overallInputName + ']'),
          toggleContainer = $('.rating-form-toggle-container');

      $this.raty({
        starType: 'i',
        starOn: 'rover-icon rover-icon-in-star star-rating-on',
        starOff: 'rover-icon rover-icon-in-star-o star-rating-off',
        cancel: false,
        half: false,
        score: function score() {
          return $overallInput.val();
        },
        click: function click(score) {
          if (toggleContainer) {
            toggleContainer.show();
          }

          $overallInput.val(score);
          // Trigger revalidation on click if the input is in
          // an error state.
          if ($overallInput.hasClass('error')) {
            validator.validate().element($overallInput);
          }
        }
      });
    });
  };

  var initializePreferenceToggles = function initializePreferenceToggles() {
    var toggleContainer = $('.rating-form-toggle-container');
    if (toggleContainer) {
      toggleContainer.hide();
    }
  };

  var init = function init() {
    initializePreferenceToggles();
    initializeRatings();
    initializeFormValidation();
    initPopovers();
  };

  init();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(31)))

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

var _Alerts = __webpack_require__(25);

var _Alerts2 = _interopRequireDefault(_Alerts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
  if (!$('body').hasClass('js-premier-request')) {
    return;
  }

  var PremierRequestView = Backbone.View.extend({
    initialize: function initialize() {
      this.$('.js-premier-request-form').ajaxForm({
        success: _.bind(this.success, this),
        error: _.bind(this.error, this)
      });
      this.$('#id_zip_code').on('blur', this.onPostalCodeChange.bind(this));
    },
    success: function success(data) {
      if (data.next !== null) {
        window.location = data.next;
      }

      this.$('.js-premier-request-form-container').fadeOut(function () {
        $('html, body').animate({
          scrollTop: $('.js-premier-request-hours').offset().top
        });
        $('.js-premier-request-confirmation').fadeIn();
      });
    },
    error: function error() {
      _Alerts2.default.showAlert();
    },
    onPostalCodeChange: function onPostalCodeChange(e) {
      var postalCode = e.target.value;
      var $emailOptIn = this.$('#id_email_opt_in');
      if (postalCode.match(/^[A-Z][0-9][A-Z]\s*[0-9][A-Z][0-9]$/i)) {
        $emailOptIn.prop('checked', false);
        $emailOptIn.closest('.row').removeClass('hidden');
      } else {
        $emailOptIn.prop('checked', true);
        $emailOptIn.closest('.row').addClass('hidden');
      }
    }
  });

  new PremierRequestView({
    el: '.js-premier-request'
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(31)))

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_selector_view = __webpack_require__(1262);

var _service_selector_view2 = _interopRequireDefault(_service_selector_view);

var _contiguous_dates_view = __webpack_require__(1263);

var _contiguous_dates_view2 = _interopRequireDefault(_contiguous_dates_view);

var _non_contiguous_dates_view = __webpack_require__(1266);

var _non_contiguous_dates_view2 = _interopRequireDefault(_non_contiguous_dates_view);

var _recurring_dates_support_view = __webpack_require__(1267);

var _recurring_dates_support_view2 = _interopRequireDefault(_recurring_dates_support_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * services_el
 *   The div wrapping the service selection buttons.
 *   This div must have the buttons pre-rendered.
 * dates_el
 *   The div wrapping the num units and date pickers.
 * collection
 *   A ServiceButtonGroupCollection.
 */
exports.default = Backbone.View.extend({
  initialize: function initialize(opts) {
    var self = this;

    var selector = new _service_selector_view2.default(_.extend({
      collection: this.collection
    }, opts.services));

    this.dates = opts.dates;
    this.viewContainer = new Backbone.ChildViewContainer();

    this.collection.each(function (service) {
      var serviceType = service.get('service_type');
      var nonContiguous = serviceType.supports_non_contiguous_dates;
      var isRecurring = serviceType.supports_recurring_billing;
      var Component = nonContiguous ? _non_contiguous_dates_view2.default : _contiguous_dates_view2.default;

      var viewOpts = {
        service: service,
        disableStart: opts.dates.disableStart,
        startDate: opts.dates.startDate
      };

      var view = new Component(viewOpts);

      if (isRecurring) {
        view = new _recurring_dates_support_view2.default({
          service: service,
          nonRecurringView: view
        });
      }

      return self.addServiceDateSelector(view);
    });
  },
  render: function render() {
    var container = document.createDocumentFragment();
    this.viewContainer.each(function (view) {
      return container.appendChild(view.render().el);
    });
    this.dates.el.find('.js-dates-for-service').append(container);
    return this;
  },
  addServiceDateSelector: function addServiceDateSelector(view) {
    var _this = this;

    this.viewContainer.add(view, view.service.get('slug'));

    // Set up the service date views to hide / show themselves
    // when the selected service changes
    this.listenTo(view.service, 'change:selected', function (model, show) {
      return view.$el.toggleClass('hidden', !show);
    });

    if (!view.service.get('selected')) {
      view.$el.addClass('hidden');
    }

    // propagate the datesChanged event
    this.listenTo(view, 'datesChanged', _.bind(function () {
      return _this.trigger('datesChanged');
    }, this));

    return view.render();
  },
  getActiveView: function getActiveView() {
    var activeService = this.collection.getSelected();
    if (!activeService) return null;
    return this.viewContainer.findByCustom(activeService.get('slug'));
  },
  getDatesData: function getDatesData() {
    var view = this.getActiveView();
    if (!view) return {};
    return view.getDatesData();
  },
  isRecurring: function isRecurring() {
    var view = this.getActiveView();
    if (!view) return false;
    return view.isRecurring();
  },
  getContactUrl: function getContactUrl() {
    if (this.isRecurring()) return Rover.urls.recurringBillingCreationUrl;
    return Rover.urls.conversationCreationUrl;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Backbone.View.extend({
  events: {
    'click .rover-button': 'onRoverBtnClick'
  },
  initialize: function initialize() {
    _.bindAll(this, 'onCollectionChange');
    this.collection.on('change', this.onCollectionChange);
  },
  onCollectionChange: function onCollectionChange() {
    var service = this.collection.getSelected();
    this.$('.rover-button').removeClass('active');
    if (!service) return;
    this.$('.rover-button[data-slug="' + service.get('slug') + '"]').addClass('active');
  },
  onRoverBtnClick: function onRoverBtnClick(evt) {
    var $target = $(evt.target).closest('.rover-button');
    this.collection.setSelected($target.data('slug'));
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)))

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _num_units_support_view = __webpack_require__(650);

var _num_units_support_view2 = _interopRequireDefault(_num_units_support_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _num_units_support_view2.default.extend({
  template: Mustache.template('new_design/common/contiguous_dates'),
  initialize: function initialize(options) {
    _num_units_support_view2.default.prototype.initialize.call(this, options);
    var url = new Url();

    this.datesModel = new Rover.models.DateRange({
      start_date: options.startDate || url.query.start_date,
      end_date: url.query.end_date
    });

    this.propagateDatesChanged(this.datesModel, 'change');

    this.datePickerView = new Rover.views.ServiceDateRangePicker({
      slug: this.service.get('service_type').slug,
      model: this.datesModel,
      disableStart: options.disableStart
    });
  },
  render: function render() {
    var ctx = {
      serviceName: this.service.get('service_type').name.toLowerCase(),
      supportsNumUnitsPerDay: this.numUnitsView !== null
    };

    this.$el.html(this.template.render(ctx));
    this.$('.js-dates-view').append(this.datePickerView.render().$el);

    if (this.numUnitsView) {
      this.$('.js-num-units-view').append(this.numUnitsView.render().$el);
    }

    return this;
  },
  getDatesData: function getDatesData() {
    var _datesModel$toJSON = this.datesModel.toJSON(),
        startDate = _datesModel$toJSON.start_date,
        endDate = _datesModel$toJSON.end_date;

    var self = this;
    var numUnits = this.getNumUnits();

    if (!startDate || !endDate) return {};
    startDate = this.formatDate(startDate);
    endDate = this.formatDate(endDate);

    if (this.numUnitsView) {
      var dates = this.dateRange(startDate, endDate);

      return {
        dates: _.map(dates, function (date) {
          return {
            date: self.formatDate(date),
            num_units: numUnits
          };
        })
      };
    }

    return {
      start_date: startDate,
      end_date: endDate
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _num_units_model = __webpack_require__(1265);

var _num_units_model2 = _interopRequireDefault(_num_units_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
  template: Mustache.template('new_design/common/num_units'),
  bindings: {
    '.js-num-units-select': {
      observe: 'num_units',
      onSet: function onSet(value) {
        return parseInt(value, 10);
      }
    },
    '.js-num-units-description': {
      observe: 'num_units',
      onGet: 'getDescription'
    }
  },
  initialize: function initialize(opts) {
    this.model = new _num_units_model2.default();
    this.descriptions = opts.desc;
    this.context = {
      label: opts.label,
      desc: this.getDescription()
    };

    Backbone.$ = window.$; // Remove once we are off the old version of Backbone
  },
  render: function render() {
    var _this = this;

    var ctx = _.extend(this.context, this.model.attributes);
    this.$el.html(this.template.render(ctx));
    this.stickit();
    setTimeout(function () {
      $('.js-num-units-select').val(_this.model.get('num_units'));
    }, 0);
    return this;
  },
  getDescription: function getDescription(numUnits) {
    if (numUnits === 1) return this.descriptions.singular;
    return this.descriptions.plural;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)))

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Backbone.Model.extend({
  defaults: {
    num_units: 1
  }
});

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

var _num_units_support_view = __webpack_require__(650);

var _num_units_support_view2 = _interopRequireDefault(_num_units_support_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _num_units_support_view2.default.extend({
  template: Mustache.template('new_design/common/noncontiguous_dates'),
  initialize: function initialize(options) {
    _num_units_support_view2.default.prototype.initialize.call(this, options);

    this.datesModel = new Rover.models.MultiDate();
    if (this.service.get('service_type').supports_day_of_week_search) {
      this.datesModel.setDays(this.getDaysFromUrl());
    } else {
      this.datesModel.set('dates', this.getDateRangeFromUrl());
    }
    this.propagateDatesChanged(this.datesModel, 'change');

    this.datePickerView = new Rover.views.DatesPicker({
      slug: this.service.get('service_type').slug,
      model: this.datesModel,
      disableStart: options.disableStart,
      dateFormat: _datetime2.default.DATE_PICKER,
      momentFormat: _datetime2.default.DATE_SHORT,
      momentLogFormat: _datetime2.default.MONTH_DAY_FULL
    });
  },
  render: function render() {
    var ctx = { units: this.service.units() };
    this.$el.html(this.template.render(ctx));
    this.$('.js-dates-view').append(this.datePickerView.render().$el);

    if (this.numUnitsView) {
      this.$('.js-num-units-view').append(this.numUnitsView.render().$el);
    }

    return this;
  },
  getDatesData: function getDatesData() {
    var dates = this.datesModel.get('dates');
    var numUnits = this.getNumUnits();
    var self = this;

    if (!dates.length) return {};

    return {
      dates: _.map(dates, function (date) {
        return {
          date: self.formatDate(date),
          num_units: numUnits
        };
      })
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, _) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_date_spec_view = __webpack_require__(579);

var _service_date_spec_view2 = _interopRequireDefault(_service_date_spec_view);

var _days_of_week_with_start_date_view = __webpack_require__(1268);

var _days_of_week_with_start_date_view2 = _interopRequireDefault(_days_of_week_with_start_date_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service_date_spec_view2.default.extend({
  template: Mustache.template('new_design/common/recurring'),
  bindings: {
    '.js-is-recurring': {
      observe: 'isRecurring',
      getVal: function getVal($el, event, options) {
        return $(event.currentTarget).find('input').val() === 'true';
      }
    }
  },
  initialize: function initialize(options) {
    _service_date_spec_view2.default.prototype.initialize.call(this, options);

    this.model = new Backbone.Model({
      isRecurring: null
    });

    this.recurringView = new _days_of_week_with_start_date_view2.default(options);
    this.propagateDatesChanged(this.recurringView);
    this.nonRecurringView = options.nonRecurringView;
    this.propagateDatesChanged(this.nonRecurringView);

    // TODO: Change to listenTo when base_transition is gone
    this.model.on('change:isRecurring', _.bind(this.onIsRecurringChange, this));
  },
  render: function render() {
    var ctx = { units: this.service.units() };
    this.$el.html(this.template.render(ctx));
    this.$el.append(this.recurringView.render().$el.addClass('hidden'));
    this.$el.append(this.nonRecurringView.render().$el.addClass('hidden'));
    this.stickit();
    this.onIsRecurringChange(this.model, this.model.get('isRecurring'));
    return this;
  },
  getDatesData: function getDatesData() {
    if (this.isRecurring()) return this.recurringView.getDatesData();
    return this.nonRecurringView.getDatesData();
  },
  isRecurring: function isRecurring() {
    return this.model.get('isRecurring');
  },
  onIsRecurringChange: function onIsRecurringChange(model, isRecurring) {
    this.recurringView.$el.toggleClass('hidden', !isRecurring);
    this.nonRecurringView.$el.toggleClass('hidden', isRecurring || isRecurring === null);
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(31)))

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _days_of_week_view = __webpack_require__(651);

var _days_of_week_view2 = _interopRequireDefault(_days_of_week_view);

var _service_date_spec_view = __webpack_require__(579);

var _service_date_spec_view2 = _interopRequireDefault(_service_date_spec_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _days_of_week_view2.default.extend({
  template: Mustache.template('new_design/common/recurring_dates'),
  bindings: _.extend(_days_of_week_view2.default.prototype.bindings, {
    '.js-start-date': 'start_date'
  }),
  initialize: function initialize(options) {
    _days_of_week_view2.default.prototype.initialize.call(this, options);

    this.startDateView = new Rover.views.DatePicker({
      model: this.model,
      slug: this.service.get('slug'),
      field: 'start_date',
      dateText: 'Start Date'
    });
  },
  render: function render() {
    _days_of_week_view2.default.prototype.render.call(this);
    this.$('.js-recurring-start-date').append(this.startDateView.render().$el);
    return this;
  },
  getDatesData: function getDatesData() {
    var data = this.model.toJSON();
    var startDate = data.start_date;
    var datesData = _days_of_week_view2.default.prototype.getDatesData.call(this);

    if (!startDate || !datesData) return {};

    return {
      start_date: this.formatDate(startDate),
      days: datesData.days
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Backbone.Model.extend({
  defaults: {
    start_date: null,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false
  },
  reset: function reset() {
    this.set(this.defaults);
  }
});

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Backbone.Collection.extend({
  setSelected: function setSelected(slug) {
    var selected = this.getSelected();
    var toSelect = this.getBySlug(slug);

    if (selected) {
      selected.set('selected', false);
    }

    if (toSelect) {
      toSelect.set('selected', true);
    } else {
      this.first().set('selected', true);
    }
  },
  getSelected: function getSelected() {
    return this.findWhere({ selected: true });
  },
  getBySlug: function getBySlug(slug) {
    return this.findWhere({ slug: slug });
  }
});

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Cleave"] = factory();
	else
		root["Cleave"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	/**
	 * Construct a new Cleave instance by passing the configuration object
	 *
	 * @param {String | HTMLElement} element
	 * @param {Object} opts
	 */
	var Cleave = function (element, opts) {
	    var owner = this;

	    if (typeof element === 'string') {
	        owner.element = document.querySelector(element);
	    } else {
	        owner.element = ((typeof element.length !== 'undefined') && element.length > 0) ? element[0] : element;
	    }

	    if (!owner.element) {
	        throw new Error('[cleave.js] Please check the element');
	    }

	    opts.initValue = owner.element.value;

	    owner.properties = Cleave.DefaultProperties.assign({}, opts);

	    owner.init();
	};

	Cleave.prototype = {
	    init: function () {
	        var owner = this, pps = owner.properties;

	        // no need to use this lib
	        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.date && (pps.blocksLength === 0 && !pps.prefix)) {
	            owner.onInput(pps.initValue);

	            return;
	        }

	        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);

	        owner.isAndroid = Cleave.Util.isAndroid();
	        owner.lastInputValue = '';

	        owner.onChangeListener = owner.onChange.bind(owner);
	        owner.onKeyDownListener = owner.onKeyDown.bind(owner);
	        owner.onFocusListener = owner.onFocus.bind(owner);
	        owner.onCutListener = owner.onCut.bind(owner);
	        owner.onCopyListener = owner.onCopy.bind(owner);

	        owner.element.addEventListener('input', owner.onChangeListener);
	        owner.element.addEventListener('keydown', owner.onKeyDownListener);
	        owner.element.addEventListener('focus', owner.onFocusListener);
	        owner.element.addEventListener('cut', owner.onCutListener);
	        owner.element.addEventListener('copy', owner.onCopyListener);


	        owner.initPhoneFormatter();
	        owner.initDateFormatter();
	        owner.initNumeralFormatter();

	        // avoid touch input field if value is null
	        // otherwise Firefox will add red box-shadow for <input required />
	        if (pps.initValue || (pps.prefix && !pps.noImmediatePrefix)) {
	            owner.onInput(pps.initValue);
	        }
	    },

	    initNumeralFormatter: function () {
	        var owner = this, pps = owner.properties;

	        if (!pps.numeral) {
	            return;
	        }

	        pps.numeralFormatter = new Cleave.NumeralFormatter(
	            pps.numeralDecimalMark,
	            pps.numeralIntegerScale,
	            pps.numeralDecimalScale,
	            pps.numeralThousandsGroupStyle,
	            pps.numeralPositiveOnly,
	            pps.stripLeadingZeroes,
	            pps.delimiter
	        );
	    },

	    initDateFormatter: function () {
	        var owner = this, pps = owner.properties;

	        if (!pps.date) {
	            return;
	        }

	        pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern);
	        pps.blocks = pps.dateFormatter.getBlocks();
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
	    },

	    initPhoneFormatter: function () {
	        var owner = this, pps = owner.properties;

	        if (!pps.phone) {
	            return;
	        }

	        // Cleave.AsYouTypeFormatter should be provided by
	        // external google closure lib
	        try {
	            pps.phoneFormatter = new Cleave.PhoneFormatter(
	                new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode),
	                pps.delimiter
	            );
	        } catch (ex) {
	            throw new Error('[cleave.js] Please include phone-type-formatter.{country}.js lib');
	        }
	    },

	    onKeyDown: function (event) {
	        var owner = this, pps = owner.properties,
	            charCode = event.which || event.keyCode,
	            Util = Cleave.Util,
	            currentValue = owner.element.value;

	        if (Util.isAndroidBackspaceKeydown(owner.lastInputValue, currentValue)) {
	            charCode = 8;
	        }

	        owner.lastInputValue = currentValue;

	        // hit backspace when last character is delimiter
	        if (charCode === 8 && Util.isDelimiter(currentValue.slice(-pps.delimiterLength), pps.delimiter, pps.delimiters)) {
	            pps.backspace = true;

	            return;
	        }

	        pps.backspace = false;
	    },

	    onChange: function () {
	        this.onInput(this.element.value);
	    },

	    onFocus: function () {
	        var owner = this,
	            pps = owner.properties;

	        Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
	    },

	    onCut: function (e) {
	        this.copyClipboardData(e);
	        this.onInput('');
	    },

	    onCopy: function (e) {
	        this.copyClipboardData(e);
	    },

	    copyClipboardData: function (e) {
	        var owner = this,
	            pps = owner.properties,
	            Util = Cleave.Util,
	            inputValue = owner.element.value,
	            textToCopy = '';

	        if (!pps.copyDelimiter) {
	            textToCopy = Util.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
	        } else {
	            textToCopy = inputValue;
	        }

	        try {
	            if (e.clipboardData) {
	                e.clipboardData.setData('Text', textToCopy);
	            } else {
	                window.clipboardData.setData('Text', textToCopy);
	            }

	            e.preventDefault();
	        } catch (ex) {
	            //  empty
	        }
	    },

	    onInput: function (value) {
	        var owner = this, pps = owner.properties,
	            Util = Cleave.Util;

	        // case 1: delete one more character "4"
	        // 1234*| -> hit backspace -> 123|
	        // case 2: last character is not delimiter which is:
	        // 12|34* -> hit backspace -> 1|34*
	        // note: no need to apply this for numeral mode
	        if (!pps.numeral && pps.backspace && !Util.isDelimiter(value.slice(-pps.delimiterLength), pps.delimiter, pps.delimiters)) {
	            value = Util.headStr(value, value.length - pps.delimiterLength);
	        }

	        // phone formatter
	        if (pps.phone) {
	            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	                pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
	            } else {
	                pps.result = pps.phoneFormatter.format(value);
	            }
	            owner.updateValueState();

	            return;
	        }

	        // numeral formatter
	        if (pps.numeral) {
	            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	                pps.result = pps.prefix + pps.numeralFormatter.format(value);
	            } else {
	                pps.result = pps.numeralFormatter.format(value);
	            }
	            owner.updateValueState();

	            return;
	        }

	        // date
	        if (pps.date) {
	            value = pps.dateFormatter.getValidatedDate(value);
	        }

	        // strip delimiters
	        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

	        // strip prefix
	        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength);

	        // strip non-numeric characters
	        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

	        // convert case
	        value = pps.uppercase ? value.toUpperCase() : value;
	        value = pps.lowercase ? value.toLowerCase() : value;

	        // prefix
	        if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
	            value = pps.prefix + value;

	            // no blocks specified, no need to do formatting
	            if (pps.blocksLength === 0) {
	                pps.result = value;
	                owner.updateValueState();

	                return;
	            }
	        }

	        // update credit card props
	        if (pps.creditCard) {
	            owner.updateCreditCardPropsByValue(value);
	        }

	        // strip over length characters
	        value = Util.headStr(value, pps.maxLength);

	        // apply blocks
	        pps.result = Util.getFormattedValue(
	            value,
	            pps.blocks, pps.blocksLength,
	            pps.delimiter, pps.delimiters, pps.delimiterLazyShow
	        );

	        owner.updateValueState();
	    },

	    updateCreditCardPropsByValue: function (value) {
	        var owner = this, pps = owner.properties,
	            Util = Cleave.Util,
	            creditCardInfo;

	        // At least one of the first 4 characters has changed
	        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
	            return;
	        }

	        creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);

	        pps.blocks = creditCardInfo.blocks;
	        pps.blocksLength = pps.blocks.length;
	        pps.maxLength = Util.getMaxLength(pps.blocks);

	        // credit card type changed
	        if (pps.creditCardType !== creditCardInfo.type) {
	            pps.creditCardType = creditCardInfo.type;

	            pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
	        }
	    },

	    setCurrentSelection: function (endPos, oldValue) {
	        var elem = this.element;

	        // If cursor was at the end of value, just place it back.
	        // Because new value could contain additional chars.
	        if (oldValue.length !== endPos && elem === document.activeElement) {
	          if ( elem.createTextRange ) {
	            var range = elem.createTextRange();

	            range.move('character', endPos);
	            range.select();
	          } else {
	            elem.setSelectionRange(endPos, endPos);
	          }
	        }
	    },

	    updateValueState: function () {
	        var owner = this,
	            pps = owner.properties;

	        if (!owner.element) {
	            return;
	        }

	        var endPos = owner.element.selectionEnd;
	        var oldValue = owner.element.value;

	        endPos += Cleave.Util.getPositionOffset(endPos, oldValue, pps.result, pps.delimiter, pps.delimiters);

	        // fix Android browser type="text" input field
	        // cursor not jumping issue
	        if (owner.isAndroid) {
	            window.setTimeout(function () {
	                owner.element.value = pps.result;
	                owner.setCurrentSelection(endPos, oldValue);
	            }, 1);

	            return;
	        }

	        owner.element.value = pps.result;
	        owner.setCurrentSelection(endPos, oldValue);
	    },

	    setPhoneRegionCode: function (phoneRegionCode) {
	        var owner = this, pps = owner.properties;

	        pps.phoneRegionCode = phoneRegionCode;
	        owner.initPhoneFormatter();
	        owner.onChange();
	    },

	    setRawValue: function (value) {
	        var owner = this, pps = owner.properties;

	        value = value !== undefined && value !== null ? value.toString() : '';

	        if (pps.numeral) {
	            value = value.replace('.', pps.numeralDecimalMark);
	        }

	        pps.backspace = false;
	        
	        owner.element.value = value;
	        owner.onInput(value);
	    },

	    getRawValue: function () {
	        var owner = this,
	            pps = owner.properties,
	            Util = Cleave.Util,
	            rawValue = owner.element.value;

	        if (pps.rawValueTrimPrefix) {
	            rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength);
	        }

	        if (pps.numeral) {
	            rawValue = pps.numeralFormatter.getRawValue(rawValue);
	        } else {
	            rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
	        }

	        return rawValue;
	    },

	    getISOFormatDate: function () {
	        var owner = this,
	            pps = owner.properties;

	        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
	    },

	    getFormattedValue: function () {
	        return this.element.value;
	    },

	    destroy: function () {
	        var owner = this;

	        owner.element.removeEventListener('input', owner.onChangeListener);
	        owner.element.removeEventListener('keydown', owner.onKeyDownListener);
	        owner.element.removeEventListener('focus', owner.onFocusListener);
	        owner.element.removeEventListener('cut', owner.onCutListener);
	        owner.element.removeEventListener('copy', owner.onCopyListener);
	    },

	    toString: function () {
	        return '[Cleave Object]';
	    }
	};

	Cleave.NumeralFormatter = __webpack_require__(1);
	Cleave.DateFormatter = __webpack_require__(2);
	Cleave.PhoneFormatter = __webpack_require__(3);
	Cleave.CreditCardDetector = __webpack_require__(4);
	Cleave.Util = __webpack_require__(5);
	Cleave.DefaultProperties = __webpack_require__(6);

	// for angular directive
	((typeof global === 'object' && global) ? global : window)['Cleave'] = Cleave;

	// CommonJS
	module.exports = Cleave;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	var NumeralFormatter = function (numeralDecimalMark,
	                                 numeralIntegerScale,
	                                 numeralDecimalScale,
	                                 numeralThousandsGroupStyle,
	                                 numeralPositiveOnly,
	                                 stripLeadingZeroes,
	                                 delimiter) {
	    var owner = this;

	    owner.numeralDecimalMark = numeralDecimalMark || '.';
	    owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
	    owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
	    owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
	    owner.numeralPositiveOnly = !!numeralPositiveOnly;
	    owner.stripLeadingZeroes = stripLeadingZeroes !== false;
	    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ',';
	    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
	};

	NumeralFormatter.groupStyle = {
	    thousand: 'thousand',
	    lakh:     'lakh',
	    wan:      'wan',
	    none:     'none'    
	};

	NumeralFormatter.prototype = {
	    getRawValue: function (value) {
	        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
	    },

	    format: function (value) {
	        var owner = this, parts, partInteger, partDecimal = '';

	        // strip alphabet letters
	        value = value.replace(/[A-Za-z]/g, '')
	            // replace the first decimal mark with reserved placeholder
	            .replace(owner.numeralDecimalMark, 'M')

	            // strip non numeric letters except minus and "M"
	            // this is to ensure prefix has been stripped
	            .replace(/[^\dM-]/g, '')

	            // replace the leading minus with reserved placeholder
	            .replace(/^\-/, 'N')

	            // strip the other minus sign (if present)
	            .replace(/\-/g, '')

	            // replace the minus sign (if present)
	            .replace('N', owner.numeralPositiveOnly ? '' : '-')

	            // replace decimal mark
	            .replace('M', owner.numeralDecimalMark);

	        // strip any leading zeros
	        if (owner.stripLeadingZeroes) {
	            value = value.replace(/^(-)?0+(?=\d)/, '$1');
	        }

	        partInteger = value;

	        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
	            parts = value.split(owner.numeralDecimalMark);
	            partInteger = parts[0];
	            partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
	        }

	        if (owner.numeralIntegerScale > 0) {
	          partInteger = partInteger.slice(0, owner.numeralIntegerScale + (value.slice(0, 1) === '-' ? 1 : 0));
	        }

	        switch (owner.numeralThousandsGroupStyle) {
	        case NumeralFormatter.groupStyle.lakh:
	            partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);

	            break;

	        case NumeralFormatter.groupStyle.wan:
	            partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);

	            break;

	        case NumeralFormatter.groupStyle.thousand:
	            partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);

	            break;
	        }

	        return partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
	    }
	};

	module.exports = NumeralFormatter;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	var DateFormatter = function (datePattern) {
	    var owner = this;

	    owner.date = [];
	    owner.blocks = [];
	    owner.datePattern = datePattern;
	    owner.initBlocks();
	};

	DateFormatter.prototype = {
	    initBlocks: function () {
	        var owner = this;
	        owner.datePattern.forEach(function (value) {
	            if (value === 'Y') {
	                owner.blocks.push(4);
	            } else {
	                owner.blocks.push(2);
	            }
	        });
	    },

	    getISOFormatDate: function () {
	        var owner = this,
	            date = owner.date;

	        return date[2] ? (
	            date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0])
	        ) : '';
	    },

	    getBlocks: function () {
	        return this.blocks;
	    },

	    getValidatedDate: function (value) {
	        var owner = this, result = '';

	        value = value.replace(/[^\d]/g, '');

	        owner.blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    sub0 = sub.slice(0, 1),
	                    rest = value.slice(length);

	                switch (owner.datePattern[index]) {
	                case 'd':
	                    if (sub === '00') {
	                        sub = '01';
	                    } else if (parseInt(sub0, 10) > 3) {
	                        sub = '0' + sub0;
	                    } else if (parseInt(sub, 10) > 31) {
	                        sub = '31';
	                    }

	                    break;

	                case 'm':
	                    if (sub === '00') {
	                        sub = '01';
	                    } else if (parseInt(sub0, 10) > 1) {
	                        sub = '0' + sub0;
	                    } else if (parseInt(sub, 10) > 12) {
	                        sub = '12';
	                    }

	                    break;
	                }

	                result += sub;

	                // update remaining string
	                value = rest;
	            }
	        });

	        return this.getFixedDateString(result);
	    },

	    getFixedDateString: function (value) {
	        var owner = this, datePattern = owner.datePattern, date = [],
	            dayIndex = 0, monthIndex = 0, yearIndex = 0,
	            dayStartIndex = 0, monthStartIndex = 0, yearStartIndex = 0,
	            day, month, year, fullYearDone = false;

	        // mm-dd || dd-mm
	        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
	            dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
	            monthStartIndex = 2 - dayStartIndex;
	            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);

	            date = this.getFixedDate(day, month, 0);
	        }

	        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
	        if (value.length === 8) {
	            datePattern.forEach(function (type, index) {
	                switch (type) {
	                case 'd':
	                    dayIndex = index;
	                    break;
	                case 'm':
	                    monthIndex = index;
	                    break;
	                default:
	                    yearIndex = index;
	                    break;
	                }
	            });

	            yearStartIndex = yearIndex * 2;
	            dayStartIndex = (dayIndex <= yearIndex) ? dayIndex * 2 : (dayIndex * 2 + 2);
	            monthStartIndex = (monthIndex <= yearIndex) ? monthIndex * 2 : (monthIndex * 2 + 2);

	            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
	            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
	            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

	            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

	            date = this.getFixedDate(day, month, year);
	        }

	        owner.date = date;

	        return date.length === 0 ? value : datePattern.reduce(function (previous, current) {
	            switch (current) {
	            case 'd':
	                return previous + owner.addLeadingZero(date[0]);
	            case 'm':
	                return previous + owner.addLeadingZero(date[1]);
	            default:
	                return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2]) : '');
	            }
	        }, '');
	    },

	    getFixedDate: function (day, month, year) {
	        day = Math.min(day, 31);
	        month = Math.min(month, 12);
	        year = parseInt((year || 0), 10);

	        if ((month < 7 && month % 2 === 0) || (month > 8 && month % 2 === 1)) {
	            day = Math.min(day, month === 2 ? (this.isLeapYear(year) ? 29 : 28) : 30);
	        }

	        return [day, month, year];
	    },

	    isLeapYear: function (year) {
	        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	    },

	    addLeadingZero: function (number) {
	        return (number < 10 ? '0' : '') + number;
	    },

	    addLeadingZeroForYear: function (number) {
	        return (number < 10 ? '000' : (number < 100 ? '00' : (number < 1000 ? '0' : ''))) + number;
	    }
	};

	module.exports = DateFormatter;



/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	var PhoneFormatter = function (formatter, delimiter) {
	    var owner = this;

	    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ' ';
	    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';

	    owner.formatter = formatter;
	};

	PhoneFormatter.prototype = {
	    setFormatter: function (formatter) {
	        this.formatter = formatter;
	    },

	    format: function (phoneNumber) {
	        var owner = this;

	        owner.formatter.clear();

	        // only keep number and +
	        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

	        // strip delimiter
	        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');

	        var result = '', current, validated = false;

	        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
	            current = owner.formatter.inputDigit(phoneNumber.charAt(i));

	            // has ()- or space inside
	            if (/[\s()-]/g.test(current)) {
	                result = current;

	                validated = true;
	            } else {
	                if (!validated) {
	                    result = current;
	                }
	                // else: over length input
	                // it turns to invalid number again
	            }
	        }

	        // strip ()
	        // e.g. US: 7161234567 returns (716) 123-4567
	        result = result.replace(/[()]/g, '');
	        // replace library delimiter with user customized delimiter
	        result = result.replace(/[\s-]/g, owner.delimiter);

	        return result;
	    }
	};

	module.exports = PhoneFormatter;



/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	var CreditCardDetector = {
	    blocks: {
	        uatp:          [4, 5, 6],
	        amex:          [4, 6, 5],
	        diners:        [4, 6, 4],
	        discover:      [4, 4, 4, 4],
	        mastercard:    [4, 4, 4, 4],
	        dankort:       [4, 4, 4, 4],
	        instapayment:  [4, 4, 4, 4],
	        jcb:           [4, 4, 4, 4],
	        maestro:       [4, 4, 4, 4],
	        visa:          [4, 4, 4, 4],
	        mir:           [4, 4, 4, 4],
	        unionPay:      [4, 4, 4, 4],
	        general:       [4, 4, 4, 4],
	        generalStrict: [4, 4, 4, 7]
	    },

	    re: {
	        // starts with 1; 15 digits, not starts with 1800 (jcb card)
	        uatp: /^(?!1800)1\d{0,14}/,

	        // starts with 34/37; 15 digits
	        amex: /^3[47]\d{0,13}/,

	        // starts with 6011/65/644-649; 16 digits
	        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

	        // starts with 300-305/309 or 36/38/39; 14 digits
	        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

	        // starts with 51-55/2221–2720; 16 digits
	        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,

	        // starts with 5019/4175/4571; 16 digits
	        dankort: /^(5019|4175|4571)\d{0,12}/,

	        // starts with 637-639; 16 digits
	        instapayment: /^63[7-9]\d{0,13}/,

	        // starts with 2131/1800/35; 16 digits
	        jcb: /^(?:2131|1800|35\d{0,2})\d{0,12}/,

	        // starts with 50/56-58/6304/67; 16 digits
	        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

	        // starts with 22; 16 digits
	        mir: /^220[0-4]\d{0,12}/,

	        // starts with 4; 16 digits
	        visa: /^4\d{0,15}/,

	        // starts with 62; 16 digits
	        unionPay: /^62\d{0,14}/
	    },

	    getInfo: function (value, strictMode) {
	        var blocks = CreditCardDetector.blocks,
	            re = CreditCardDetector.re;

	        // Some credit card can have up to 19 digits number.
	        // Set strictMode to true will remove the 16 max-length restrain,
	        // however, I never found any website validate card number like
	        // this, hence probably you don't want to enable this option.
	        strictMode = !!strictMode;

	        for (var key in re) {
	            if (re[key].test(value)) {
	                var block;

	                if (strictMode) {
	                    block = blocks.generalStrict;
	                } else {
	                    block = blocks[key];
	                }

	                return {
	                    type: key,
	                    blocks: block
	                };
	            }
	        }

	        return {
	            type:   'unknown',
	            blocks: strictMode ? blocks.generalStrict : blocks.general
	        };
	    }
	};

	module.exports = CreditCardDetector;



/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	var Util = {
	    noop: function () {
	    },

	    strip: function (value, re) {
	        return value.replace(re, '');
	    },

	    isDelimiter: function (letter, delimiter, delimiters) {
	        // single delimiter
	        if (delimiters.length === 0) {
	            return letter === delimiter;
	        }

	        // multiple delimiters
	        return delimiters.some(function (current) {
	            if (letter === current) {
	                return true;
	            }
	        });
	    },

	    getDelimiterREByDelimiter: function (delimiter) {
	        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
	    },

	    getPositionOffset: function (prevPos, oldValue, newValue, delimiter, delimiters) {
	        var oldRawValue, newRawValue, lengthOffset;

	        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
	        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
	        lengthOffset = oldRawValue.length - newRawValue.length;

	        return (lengthOffset !== 0) ? (lengthOffset / Math.abs(lengthOffset)) : 0;
	    },

	    stripDelimiters: function (value, delimiter, delimiters) {
	        var owner = this;

	        // single delimiter
	        if (delimiters.length === 0) {
	            var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';

	            return value.replace(delimiterRE, '');
	        }

	        // multiple delimiters
	        delimiters.forEach(function (current) {
	            value = value.replace(owner.getDelimiterREByDelimiter(current), '');
	        });

	        return value;
	    },

	    headStr: function (str, length) {
	        return str.slice(0, length);
	    },

	    getMaxLength: function (blocks) {
	        return blocks.reduce(function (previous, current) {
	            return previous + current;
	        }, 0);
	    },

	    // strip value by prefix length
	    // for prefix: PRE
	    // (PRE123, 3) -> 123
	    // (PR123, 3) -> 23 this happens when user hits backspace in front of "PRE"
	    getPrefixStrippedValue: function (value, prefix, prefixLength) {
	        if (value.slice(0, prefixLength) !== prefix) {
	            var diffIndex = this.getFirstDiffIndex(prefix, value.slice(0, prefixLength));

	            value = prefix + value.slice(diffIndex, diffIndex + 1) + value.slice(prefixLength + 1);
	        }

	        return value.slice(prefixLength);
	    },

	    getFirstDiffIndex: function (prev, current) {
	        var index = 0;

	        while (prev.charAt(index) === current.charAt(index)) {
	            if (prev.charAt(index++) === '') {
	                return -1;
	            }
	        }

	        return index;
	    },

	    getFormattedValue: function (value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
	        var result = '',
	            multipleDelimiters = delimiters.length > 0,
	            currentDelimiter;

	        // no options, normal input
	        if (blocksLength === 0) {
	            return value;
	        }

	        blocks.forEach(function (length, index) {
	            if (value.length > 0) {
	                var sub = value.slice(0, length),
	                    rest = value.slice(length);

	                if (multipleDelimiters) {
	                    currentDelimiter = delimiters[delimiterLazyShow ? (index - 1) : index] || currentDelimiter;
	                } else {
	                    currentDelimiter = delimiter;
	                }

	                if (delimiterLazyShow) {
	                    if (index > 0) {
	                        result += currentDelimiter;
	                    }

	                    result += sub;
	                } else {
	                    result += sub;

	                    if (sub.length === length && index < blocksLength - 1) {
	                        result += currentDelimiter;
	                    }
	                }

	                // update remaining string
	                value = rest;
	            }
	        });

	        return result;
	    },

	    // move cursor to the end
	    // the first time user focuses on an input with prefix
	    fixPrefixCursor: function (el, prefix, delimiter, delimiters) {
	        if (!el) {
	            return;
	        }

	        var val = el.value,
	            appendix = delimiter || (delimiters[0] || ' ');

	        if (!el.setSelectionRange || !prefix || (prefix.length + appendix.length) < val.length) {
	            return;
	        }

	        var len = val.length * 2;

	        // set timeout to avoid blink
	        setTimeout(function () {
	            el.setSelectionRange(len, len);
	        }, 1);
	    },

	    isAndroid: function () {
	        return navigator && /android/i.test(navigator.userAgent);
	    },

	    // On Android chrome, the keyup and keydown events
	    // always return key code 229 as a composition that
	    // buffers the user’s keystrokes
	    // see https://github.com/nosir/cleave.js/issues/147
	    isAndroidBackspaceKeydown: function (lastInputValue, currentInputValue) {
	        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
	            return false;
	        }

	        return currentInputValue === lastInputValue.slice(0, -1);
	    }
	};

	module.exports = Util;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	/**
	 * Props Assignment
	 *
	 * Separate this, so react module can share the usage
	 */
	var DefaultProperties = {
	    // Maybe change to object-assign
	    // for now just keep it as simple
	    assign: function (target, opts) {
	        target = target || {};
	        opts = opts || {};

	        // credit card
	        target.creditCard = !!opts.creditCard;
	        target.creditCardStrictMode = !!opts.creditCardStrictMode;
	        target.creditCardType = '';
	        target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || (function () {});

	        // phone
	        target.phone = !!opts.phone;
	        target.phoneRegionCode = opts.phoneRegionCode || 'AU';
	        target.phoneFormatter = {};

	        // date
	        target.date = !!opts.date;
	        target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
	        target.dateFormatter = {};

	        // numeral
	        target.numeral = !!opts.numeral;
	        target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
	        target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
	        target.numeralDecimalMark = opts.numeralDecimalMark || '.';
	        target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
	        target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
	        target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;

	        // others
	        target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;

	        target.uppercase = !!opts.uppercase;
	        target.lowercase = !!opts.lowercase;

	        target.prefix = (target.creditCard || target.date) ? '' : (opts.prefix || '');
	        target.noImmediatePrefix = !!opts.noImmediatePrefix;
	        target.prefixLength = target.prefix.length;
	        target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
	        target.copyDelimiter = !!opts.copyDelimiter;

	        target.initValue = (opts.initValue !== undefined && opts.initValue !== null) ? opts.initValue.toString() : '';

	        target.delimiter =
	            (opts.delimiter || opts.delimiter === '') ? opts.delimiter :
	                (opts.date ? '/' :
	                    (opts.numeral ? ',' :
	                        (opts.phone ? ' ' :
	                            ' ')));
	        target.delimiterLength = target.delimiter.length;
	        target.delimiterLazyShow = !!opts.delimiterLazyShow;
	        target.delimiters = opts.delimiters || [];

	        target.blocks = opts.blocks || [];
	        target.blocksLength = target.blocks.length;

	        target.root = (typeof global === 'object' && global) ? global : window;

	        target.maxLength = 0;

	        target.backspace = false;
	        target.result = '';

	        return target;
	    }
	};

	module.exports = DefaultProperties;


	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ])
});
;

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Exposing intl-tel-input as a component
 */
module.exports = __webpack_require__(1273);


/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * International Telephone Input v12.1.15
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// wrap in UMD - see https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
(function(factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(9) ], __WEBPACK_AMD_DEFINE_RESULT__ = function($) {
            factory($, window, document);
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === "object" && module.exports) {
        module.exports = factory(require("jquery"), window, document);
    } else {
        factory(jQuery, window, document);
    }
})(function($, window, document, undefined) {
    "use strict";
    // these vars persist through all instances of the plugin
    var pluginName = "intlTelInput", id = 1, // give each instance it's own id for namespaced event handling
    defaults = {
        // whether or not to allow the dropdown
        allowDropdown: true,
        // if there is just a dial code in the input: remove it on blur, and re-add it on focus
        autoHideDialCode: true,
        // add a placeholder in the input with an example number for the selected country
        autoPlaceholder: "polite",
        // modify the auto placeholder
        customPlaceholder: null,
        // append menu to a specific element
        dropdownContainer: "",
        // don't display these countries
        excludeCountries: [],
        // format the input value during initialisation and on setNumber
        formatOnDisplay: true,
        // geoIp lookup function
        geoIpLookup: null,
        // inject a hidden input with this name, and on submit, populate it with the result of getNumber
        hiddenInput: "",
        // initial country
        initialCountry: "",
        // don't insert international dial codes
        nationalMode: true,
        // display only these countries
        onlyCountries: [],
        // number type to use for placeholders
        placeholderNumberType: "MOBILE",
        // the countries at the top of the list. defaults to united states and united kingdom
        preferredCountries: [ "us", "gb" ],
        // display the country dial code next to the selected flag so it's not part of the typed number
        separateDialCode: false,
        // specify the path to the libphonenumber script to enable validation/formatting
        utilsScript: ""
    }, keys = {
        UP: 38,
        DOWN: 40,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32,
        TAB: 9
    }, // https://en.wikipedia.org/wiki/List_of_North_American_Numbering_Plan_area_codes#Non-geographic_area_codes
    regionlessNanpNumbers = [ "800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889" ];
    // keep track of if the window.load event has fired as impossible to check after the fact
    $(window).on("load", function() {
        // UPDATE: use a public static field so we can fudge it in the tests
        $.fn[pluginName].windowLoaded = true;
    });
    function Plugin(element, options) {
        this.telInput = $(element);
        this.options = $.extend({}, defaults, options);
        // event namespace
        this.ns = "." + pluginName + id++;
        // Chrome, FF, Safari, IE9+
        this.isGoodBrowser = Boolean(element.setSelectionRange);
        this.hadInitialPlaceholder = Boolean($(element).attr("placeholder"));
    }
    Plugin.prototype = {
        _init: function() {
            // if in nationalMode, disable options relating to dial codes
            if (this.options.nationalMode) {
                this.options.autoHideDialCode = false;
            }
            // if separateDialCode then doesn't make sense to A) insert dial code into input (autoHideDialCode), and B) display national numbers (because we're displaying the country dial code next to them)
            if (this.options.separateDialCode) {
                this.options.autoHideDialCode = this.options.nationalMode = false;
            }
            // we cannot just test screen size as some smartphones/website meta tags will report desktop resolutions
            // Note: for some reason jasmine breaks if you put this in the main Plugin function with the rest of these declarations
            // Note: to target Android Mobiles (and not Tablets), we must find "Android" and "Mobile"
            this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (this.isMobile) {
                // trigger the mobile dropdown css
                $("body").addClass("iti-mobile");
                // on mobile, we want a full screen dropdown, so we must append it to the body
                if (!this.options.dropdownContainer) {
                    this.options.dropdownContainer = "body";
                }
            }
            // we return these deferred objects from the _init() call so they can be watched, and then we resolve them when each specific request returns
            // Note: again, jasmine breaks when I put these in the Plugin function
            this.autoCountryDeferred = new $.Deferred();
            this.utilsScriptDeferred = new $.Deferred();
            // in various situations there could be no country selected initially, but we need to be able to assume this variable exists
            this.selectedCountryData = {};
            // process all the data: onlyCountries, excludeCountries, preferredCountries etc
            this._processCountryData();
            // generate the markup
            this._generateMarkup();
            // set the initial state of the input value and the selected flag
            this._setInitialState();
            // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click
            this._initListeners();
            // utils script, and auto country
            this._initRequests();
            // return the deferreds
            return [ this.autoCountryDeferred, this.utilsScriptDeferred ];
        },
        /********************
   *  PRIVATE METHODS
   ********************/
        // prepare all of the country data, including onlyCountries, excludeCountries and preferredCountries options
        _processCountryData: function() {
            // process onlyCountries or excludeCountries array if present
            this._processAllCountries();
            // process the countryCodes map
            this._processCountryCodes();
            // process the preferredCountries
            this._processPreferredCountries();
        },
        // add a country code to this.countryCodes
        _addCountryCode: function(iso2, dialCode, priority) {
            if (!(dialCode in this.countryCodes)) {
                this.countryCodes[dialCode] = [];
            }
            var index = priority || 0;
            this.countryCodes[dialCode][index] = iso2;
        },
        // process onlyCountries or excludeCountries array if present
        _processAllCountries: function() {
            if (this.options.onlyCountries.length) {
                var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
                    return country.toLowerCase();
                });
                this.countries = allCountries.filter(function(country) {
                    return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
                });
            } else if (this.options.excludeCountries.length) {
                var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                    return country.toLowerCase();
                });
                this.countries = allCountries.filter(function(country) {
                    return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
                });
            } else {
                this.countries = allCountries;
            }
        },
        // process the countryCodes map
        _processCountryCodes: function() {
            this.countryCodes = {};
            for (var i = 0; i < this.countries.length; i++) {
                var c = this.countries[i];
                this._addCountryCode(c.iso2, c.dialCode, c.priority);
                // area codes
                if (c.areaCodes) {
                    for (var j = 0; j < c.areaCodes.length; j++) {
                        // full dial code is country code + dial code
                        this._addCountryCode(c.iso2, c.dialCode + c.areaCodes[j]);
                    }
                }
            }
        },
        // process preferred countries - iterate through the preferences, fetching the country data for each one
        _processPreferredCountries: function() {
            this.preferredCountries = [];
            for (var i = 0; i < this.options.preferredCountries.length; i++) {
                var countryCode = this.options.preferredCountries[i].toLowerCase(), countryData = this._getCountryData(countryCode, false, true);
                if (countryData) {
                    this.preferredCountries.push(countryData);
                }
            }
        },
        // generate all of the markup for the plugin: the selected flag overlay, and the dropdown
        _generateMarkup: function() {
            // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can easily put the plugin in an inconsistent state e.g. the wrong flag selected for the autocompleted number, which on submit could mean the wrong number is saved (esp in nationalMode)
            this.telInput.attr("autocomplete", "off");
            // containers (mostly for positioning)
            var parentClass = "intl-tel-input";
            if (this.options.allowDropdown) {
                parentClass += " allow-dropdown";
            }
            if (this.options.separateDialCode) {
                parentClass += " separate-dial-code";
            }
            this.telInput.wrap($("<div>", {
                "class": parentClass
            }));
            this.flagsContainer = $("<div>", {
                "class": "flag-container"
            }).insertBefore(this.telInput);
            // currently selected flag (displayed to left of input)
            var selectedFlag = $("<div>", {
                "class": "selected-flag"
            });
            selectedFlag.appendTo(this.flagsContainer);
            this.selectedFlagInner = $("<div>", {
                "class": "iti-flag"
            }).appendTo(selectedFlag);
            if (this.options.separateDialCode) {
                this.selectedDialCode = $("<div>", {
                    "class": "selected-dial-code"
                }).appendTo(selectedFlag);
            }
            if (this.options.allowDropdown) {
                // make element focusable and tab naviagable
                selectedFlag.attr("tabindex", "0");
                // CSS triangle
                $("<div>", {
                    "class": "iti-arrow"
                }).appendTo(selectedFlag);
                // country dropdown: preferred countries, then divider, then all countries
                this.countryList = $("<ul>", {
                    "class": "country-list hide"
                });
                if (this.preferredCountries.length) {
                    this._appendListItems(this.preferredCountries, "preferred");
                    $("<li>", {
                        "class": "divider"
                    }).appendTo(this.countryList);
                }
                this._appendListItems(this.countries, "");
                // this is useful in lots of places
                this.countryListItems = this.countryList.children(".country");
                // create dropdownContainer markup
                if (this.options.dropdownContainer) {
                    this.dropdown = $("<div>", {
                        "class": "intl-tel-input iti-container"
                    }).append(this.countryList);
                } else {
                    this.countryList.appendTo(this.flagsContainer);
                }
            } else {
                // a little hack so we don't break anything
                this.countryListItems = $();
            }
            if (this.options.hiddenInput) {
                this.hiddenInput = $("<input>", {
                    type: "hidden",
                    name: this.options.hiddenInput
                }).insertBefore(this.telInput);
            }
        },
        // add a country <li> to the countryList <ul> container
        _appendListItems: function(countries, className) {
            // we create so many DOM elements, it is faster to build a temp string
            // and then add everything to the DOM in one go at the end
            var tmp = "";
            // for each country
            for (var i = 0; i < countries.length; i++) {
                var c = countries[i];
                // open the list item
                tmp += "<li class='country " + className + "' data-dial-code='" + c.dialCode + "' data-country-code='" + c.iso2 + "'>";
                // add the flag
                tmp += "<div class='flag-box'><div class='iti-flag " + c.iso2 + "'></div></div>";
                // and the country name and dial code
                tmp += "<span class='country-name'>" + c.name + "</span>";
                tmp += "<span class='dial-code'>+" + c.dialCode + "</span>";
                // close the list item
                tmp += "</li>";
            }
            this.countryList.append(tmp);
        },
        // set the initial state of the input value and the selected flag by:
        // 1. extracting a dial code from the given number
        // 2. using explicit initialCountry
        // 3. picking the first preferred country
        // 4. picking the first country
        _setInitialState: function() {
            var val = this.telInput.val();
            // if we already have a dial code, and it's not a regionlessNanp, we can go ahead and set the flag, else fall back to the default country
            // UPDATE: actually we do want to set the flag for a regionlessNanp in one situation: if we're in nationalMode and there's no initialCountry - otherwise we lose the +1 and we're left with an invalid number
            if (this._getDialCode(val) && (!this._isRegionlessNanp(val) || this.options.nationalMode && !this.options.initialCountry)) {
                this._updateFlagFromNumber(val);
            } else if (this.options.initialCountry !== "auto") {
                // see if we should select a flag
                if (this.options.initialCountry) {
                    this._setFlag(this.options.initialCountry.toLowerCase());
                } else {
                    // no dial code and no initialCountry, so default to first in list
                    this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
                    if (!val) {
                        this._setFlag(this.defaultCountry);
                    }
                }
                // if empty and no nationalMode and no autoHideDialCode then insert the default dial code
                if (!val && !this.options.nationalMode && !this.options.autoHideDialCode && !this.options.separateDialCode) {
                    this.telInput.val("+" + this.selectedCountryData.dialCode);
                }
            }
            // NOTE: if initialCountry is set to auto, that will be handled separately
            // format
            if (val) {
                // this wont be run after _updateDialCode as that's only called if no val
                this._updateValFromNumber(val);
            }
        },
        // initialise the main event listeners: input keyup, and click selected flag
        _initListeners: function() {
            this._initKeyListeners();
            if (this.options.autoHideDialCode) {
                this._initFocusListeners();
            }
            if (this.options.allowDropdown) {
                this._initDropdownListeners();
            }
            if (this.hiddenInput) {
                this._initHiddenInputListener();
            }
        },
        // update hidden input on form submit
        _initHiddenInputListener: function() {
            var that = this;
            var form = this.telInput.closest("form");
            if (form.length) {
                form.submit(function() {
                    that.hiddenInput.val(that.getNumber());
                });
            }
        },
        // initialise the dropdown listeners
        _initDropdownListeners: function() {
            var that = this;
            // hack for input nested inside label: clicking the selected-flag to open the dropdown would then automatically trigger a 2nd click on the input which would close it again
            var label = this.telInput.closest("label");
            if (label.length) {
                label.on("click" + this.ns, function(e) {
                    // if the dropdown is closed, then focus the input, else ignore the click
                    if (that.countryList.hasClass("hide")) {
                        that.telInput.focus();
                    } else {
                        e.preventDefault();
                    }
                });
            }
            // toggle country dropdown on click
            var selectedFlag = this.selectedFlagInner.parent();
            selectedFlag.on("click" + this.ns, function(e) {
                // only intercept this event if we're opening the dropdown
                // else let it bubble up to the top ("click-off-to-close" listener)
                // we cannot just stopPropagation as it may be needed to close another instance
                if (that.countryList.hasClass("hide") && !that.telInput.prop("disabled") && !that.telInput.prop("readonly")) {
                    that._showDropdown();
                }
            });
            // open dropdown list if currently focused
            this.flagsContainer.on("keydown" + that.ns, function(e) {
                var isDropdownHidden = that.countryList.hasClass("hide");
                if (isDropdownHidden && (e.which == keys.UP || e.which == keys.DOWN || e.which == keys.SPACE || e.which == keys.ENTER)) {
                    // prevent form from being submitted if "ENTER" was pressed
                    e.preventDefault();
                    // prevent event from being handled again by document
                    e.stopPropagation();
                    that._showDropdown();
                }
                // allow navigation from dropdown to input on TAB
                if (e.which == keys.TAB) {
                    that._closeDropdown();
                }
            });
        },
        // init many requests: utils script / geo ip lookup
        _initRequests: function() {
            var that = this;
            // if the user has specified the path to the utils script, fetch it on window.load, else resolve
            if (this.options.utilsScript) {
                // if the plugin is being initialised after the window.load event has already been fired
                if ($.fn[pluginName].windowLoaded) {
                    $.fn[pluginName].loadUtils(this.options.utilsScript, this.utilsScriptDeferred);
                } else {
                    // wait until the load event so we don't block any other requests e.g. the flags image
                    $(window).on("load", function() {
                        $.fn[pluginName].loadUtils(that.options.utilsScript, that.utilsScriptDeferred);
                    });
                }
            } else {
                this.utilsScriptDeferred.resolve();
            }
            if (this.options.initialCountry === "auto") {
                this._loadAutoCountry();
            } else {
                this.autoCountryDeferred.resolve();
            }
        },
        // perform the geo ip lookup
        _loadAutoCountry: function() {
            var that = this;
            // 3 options:
            // 1) already loaded (we're done)
            // 2) not already started loading (start)
            // 3) already started loading (do nothing - just wait for loading callback to fire)
            if ($.fn[pluginName].autoCountry) {
                this.handleAutoCountry();
            } else if (!$.fn[pluginName].startedLoadingAutoCountry) {
                // don't do this twice!
                $.fn[pluginName].startedLoadingAutoCountry = true;
                if (typeof this.options.geoIpLookup === "function") {
                    this.options.geoIpLookup(function(countryCode) {
                        $.fn[pluginName].autoCountry = countryCode.toLowerCase();
                        // tell all instances the auto country is ready
                        // TODO: this should just be the current instances
                        // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight away (e.g. if they have already done the geo ip lookup somewhere else). Using setTimeout means that the current thread of execution will finish before executing this, which allows the plugin to finish initialising.
                        setTimeout(function() {
                            $(".intl-tel-input input").intlTelInput("handleAutoCountry");
                        });
                    });
                }
            }
        },
        // initialize any key listeners
        _initKeyListeners: function() {
            var that = this;
            // update flag on keyup
            // (keep this listener separate otherwise the setTimeout breaks all the tests)
            this.telInput.on("keyup" + this.ns, function() {
                if (that._updateFlagFromNumber(that.telInput.val())) {
                    that._triggerCountryChange();
                }
            });
            // update flag on cut/paste events (now supported in all major browsers)
            this.telInput.on("cut" + this.ns + " paste" + this.ns, function() {
                // hack because "paste" event is fired before input is updated
                setTimeout(function() {
                    if (that._updateFlagFromNumber(that.telInput.val())) {
                        that._triggerCountryChange();
                    }
                });
            });
        },
        // adhere to the input's maxlength attr
        _cap: function(number) {
            var max = this.telInput.attr("maxlength");
            return max && number.length > max ? number.substr(0, max) : number;
        },
        // listen for mousedown, focus and blur
        _initFocusListeners: function() {
            var that = this;
            // mousedown decides where the cursor goes, so if we're focusing we must preventDefault as we'll be inserting the dial code, and we want the cursor to be at the end no matter where they click
            this.telInput.on("mousedown" + this.ns, function(e) {
                if (!that.telInput.is(":focus") && !that.telInput.val()) {
                    e.preventDefault();
                    // but this also cancels the focus, so we must trigger that manually
                    that.telInput.focus();
                }
            });
            // on focus: if empty, insert the dial code for the currently selected flag
            this.telInput.on("focus" + this.ns, function(e) {
                if (!that.telInput.val() && !that.telInput.prop("readonly") && that.selectedCountryData.dialCode) {
                    // insert the dial code
                    that.telInput.val("+" + that.selectedCountryData.dialCode);
                    // after auto-inserting a dial code, if the first key they hit is '+' then assume they are entering a new number, so remove the dial code. use keypress instead of keydown because keydown gets triggered for the shift key (required to hit the + key), and instead of keyup because that shows the new '+' before removing the old one
                    that.telInput.one("keypress.plus" + that.ns, function(e) {
                        if (e.which == keys.PLUS) {
                            that.telInput.val("");
                        }
                    });
                    // after tabbing in, make sure the cursor is at the end we must use setTimeout to get outside of the focus handler as it seems the selection happens after that
                    setTimeout(function() {
                        var input = that.telInput[0];
                        if (that.isGoodBrowser) {
                            var len = that.telInput.val().length;
                            input.setSelectionRange(len, len);
                        }
                    });
                }
            });
            // on blur or form submit: if just a dial code then remove it
            var form = this.telInput.prop("form");
            if (form) {
                $(form).on("submit" + this.ns, function() {
                    that._removeEmptyDialCode();
                });
            }
            this.telInput.on("blur" + this.ns, function() {
                that._removeEmptyDialCode();
            });
        },
        _removeEmptyDialCode: function() {
            var value = this.telInput.val(), startsPlus = value.charAt(0) == "+";
            if (startsPlus) {
                var numeric = this._getNumeric(value);
                // if just a plus, or if just a dial code
                if (!numeric || this.selectedCountryData.dialCode == numeric) {
                    this.telInput.val("");
                }
            }
            // remove the keypress listener we added on focus
            this.telInput.off("keypress.plus" + this.ns);
        },
        // extract the numeric digits from the given string
        _getNumeric: function(s) {
            return s.replace(/\D/g, "");
        },
        // show the dropdown
        _showDropdown: function() {
            this._setDropdownPosition();
            // update highlighting and scroll to active list item
            var activeListItem = this.countryList.children(".active");
            if (activeListItem.length) {
                this._highlightListItem(activeListItem);
                this._scrollTo(activeListItem);
            }
            // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
            this._bindDropdownListeners();
            // update the arrow
            this.selectedFlagInner.children(".iti-arrow").addClass("up");
            this.telInput.trigger("open:countrydropdown");
        },
        // decide where to position dropdown (depends on position within viewport, and scroll)
        _setDropdownPosition: function() {
            var that = this;
            if (this.options.dropdownContainer) {
                this.dropdown.appendTo(this.options.dropdownContainer);
            }
            // show the menu and grab the dropdown height
            this.dropdownHeight = this.countryList.removeClass("hide").outerHeight();
            if (!this.isMobile) {
                var pos = this.telInput.offset(), inputTop = pos.top, windowTop = $(window).scrollTop(), // dropdownFitsBelow = (dropdownBottom < windowBottom)
                dropdownFitsBelow = inputTop + this.telInput.outerHeight() + this.dropdownHeight < windowTop + $(window).height(), dropdownFitsAbove = inputTop - this.dropdownHeight > windowTop;
                // by default, the dropdown will be below the input. If we want to position it above the input, we add the dropup class.
                this.countryList.toggleClass("dropup", !dropdownFitsBelow && dropdownFitsAbove);
                // if dropdownContainer is enabled, calculate postion
                if (this.options.dropdownContainer) {
                    // by default the dropdown will be directly over the input because it's not in the flow. If we want to position it below, we need to add some extra top value.
                    var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.innerHeight();
                    // calculate placement
                    this.dropdown.css({
                        top: inputTop + extraTop,
                        left: pos.left
                    });
                    // close menu on window scroll
                    $(window).on("scroll" + this.ns, function() {
                        that._closeDropdown();
                    });
                }
            }
        },
        // we only bind dropdown listeners when the dropdown is open
        _bindDropdownListeners: function() {
            var that = this;
            // when mouse over a list item, just highlight that one
            // we add the class "highlight", so if they hit "enter" we know which one to select
            this.countryList.on("mouseover" + this.ns, ".country", function(e) {
                that._highlightListItem($(this));
            });
            // listen for country selection
            this.countryList.on("click" + this.ns, ".country", function(e) {
                that._selectListItem($(this));
            });
            // click off to close
            // (except when this initial opening click is bubbling up)
            // we cannot just stopPropagation as it may be needed to close another instance
            var isOpening = true;
            $("html").on("click" + this.ns, function(e) {
                if (!isOpening) {
                    that._closeDropdown();
                }
                isOpening = false;
            });
            // listen for up/down scrolling, enter to select, or letters to jump to country name.
            // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
            // just hit down and hold it to scroll down (no keyup event).
            // listen on the document because that's where key events are triggered if no input has focus
            var query = "", queryTimer = null;
            $(document).on("keydown" + this.ns, function(e) {
                // prevent down key from scrolling the whole page,
                // and enter key from submitting a form etc
                e.preventDefault();
                if (e.which == keys.UP || e.which == keys.DOWN) {
                    // up and down to navigate
                    that._handleUpDownKey(e.which);
                } else if (e.which == keys.ENTER) {
                    // enter to select
                    that._handleEnterKey();
                } else if (e.which == keys.ESC) {
                    // esc to close
                    that._closeDropdown();
                } else if (e.which >= keys.A && e.which <= keys.Z || e.which == keys.SPACE) {
                    // upper case letters (note: keyup/keydown only return upper case letters)
                    // jump to countries that start with the query string
                    if (queryTimer) {
                        clearTimeout(queryTimer);
                    }
                    query += String.fromCharCode(e.which);
                    that._searchForCountry(query);
                    // if the timer hits 1 second, reset the query
                    queryTimer = setTimeout(function() {
                        query = "";
                    }, 1e3);
                }
            });
        },
        // highlight the next/prev item in the list (and ensure it is visible)
        _handleUpDownKey: function(key) {
            var current = this.countryList.children(".highlight").first();
            var next = key == keys.UP ? current.prev() : current.next();
            if (next.length) {
                // skip the divider
                if (next.hasClass("divider")) {
                    next = key == keys.UP ? next.prev() : next.next();
                }
                this._highlightListItem(next);
                this._scrollTo(next);
            }
        },
        // select the currently highlighted item
        _handleEnterKey: function() {
            var currentCountry = this.countryList.children(".highlight").first();
            if (currentCountry.length) {
                this._selectListItem(currentCountry);
            }
        },
        // find the first list item whose name starts with the query string
        _searchForCountry: function(query) {
            for (var i = 0; i < this.countries.length; i++) {
                if (this._startsWith(this.countries[i].name, query)) {
                    var listItem = this.countryList.children("[data-country-code=" + this.countries[i].iso2 + "]").not(".preferred");
                    // update highlighting and scroll
                    this._highlightListItem(listItem);
                    this._scrollTo(listItem, true);
                    break;
                }
            }
        },
        // check if (uppercase) string a starts with string b
        _startsWith: function(a, b) {
            return a.substr(0, b.length).toUpperCase() == b;
        },
        // update the input's value to the given val (format first if possible)
        // NOTE: this is called from _setInitialState, handleUtils and setNumber
        _updateValFromNumber: function(number) {
            if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                var format = !this.options.separateDialCode && (this.options.nationalMode || number.charAt(0) != "+") ? intlTelInputUtils.numberFormat.NATIONAL : intlTelInputUtils.numberFormat.INTERNATIONAL;
                number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
            }
            number = this._beforeSetNumber(number);
            this.telInput.val(number);
        },
        // check if need to select a new flag based on the given number
        // Note: called from _setInitialState, keyup handler, setNumber
        _updateFlagFromNumber: function(number) {
            // if we're in nationalMode and we already have US/Canada selected, make sure the number starts with a +1 so _getDialCode will be able to extract the area code
            // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag from the number), that means we're initialising the plugin with a number that already has a dial code, so fine to ignore this bit
            if (number && this.options.nationalMode && this.selectedCountryData.dialCode == "1" && number.charAt(0) != "+") {
                if (number.charAt(0) != "1") {
                    number = "1" + number;
                }
                number = "+" + number;
            }
            // try and extract valid dial code from input
            var dialCode = this._getDialCode(number), countryCode = null, numeric = this._getNumeric(number);
            if (dialCode) {
                // check if one of the matching countries is already selected
                var countryCodes = this.countryCodes[this._getNumeric(dialCode)], alreadySelected = $.inArray(this.selectedCountryData.iso2, countryCodes) > -1, // check if the given number contains a NANP area code i.e. the only dialCode that could be extracted was +1 (instead of say +1204) and the actual number's length is >=4
                isNanpAreaCode = dialCode == "+1" && numeric.length >= 4, nanpSelected = this.selectedCountryData.dialCode == "1";
                // only update the flag if:
                // A) NOT (we currently have a NANP flag selected, and the number is a regionlessNanp)
                // AND
                // B) either a matching country is not already selected OR the number contains a NANP area code (ensure the flag is set to the first matching country)
                if (!(nanpSelected && this._isRegionlessNanp(numeric)) && (!alreadySelected || isNanpAreaCode)) {
                    // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first non-empty index
                    for (var j = 0; j < countryCodes.length; j++) {
                        if (countryCodes[j]) {
                            countryCode = countryCodes[j];
                            break;
                        }
                    }
                }
            } else if (number.charAt(0) == "+" && numeric.length) {
                // invalid dial code, so empty
                // Note: use getNumeric here because the number has not been formatted yet, so could contain bad chars
                countryCode = "";
            } else if (!number || number == "+") {
                // empty, or just a plus, so default
                countryCode = this.defaultCountry;
            }
            if (countryCode !== null) {
                return this._setFlag(countryCode);
            }
            return false;
        },
        // check if the given number is a regionless NANP number (expects the number to contain an international dial code)
        _isRegionlessNanp: function(number) {
            var numeric = this._getNumeric(number);
            if (numeric.charAt(0) == "1") {
                var areaCode = numeric.substr(1, 3);
                return $.inArray(areaCode, regionlessNanpNumbers) > -1;
            }
            return false;
        },
        // remove highlighting from other list items and highlight the given item
        _highlightListItem: function(listItem) {
            this.countryListItems.removeClass("highlight");
            listItem.addClass("highlight");
        },
        // find the country data for the given country code
        // the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
        _getCountryData: function(countryCode, ignoreOnlyCountriesOption, allowFail) {
            var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
            for (var i = 0; i < countryList.length; i++) {
                if (countryList[i].iso2 == countryCode) {
                    return countryList[i];
                }
            }
            if (allowFail) {
                return null;
            } else {
                throw new Error("No country data for '" + countryCode + "'");
            }
        },
        // select the given flag, update the placeholder and the active list item
        // Note: called from _setInitialState, _updateFlagFromNumber, _selectListItem, setCountry
        _setFlag: function(countryCode) {
            var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
            // do this first as it will throw an error and stop if countryCode is invalid
            this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
            // update the defaultCountry - we only need the iso2 from now on, so just store that
            if (this.selectedCountryData.iso2) {
                this.defaultCountry = this.selectedCountryData.iso2;
            }
            this.selectedFlagInner.attr("class", "iti-flag " + countryCode);
            // update the selected country's title attribute
            var title = countryCode ? this.selectedCountryData.name + ": +" + this.selectedCountryData.dialCode : "Unknown";
            this.selectedFlagInner.parent().attr("title", title);
            if (this.options.separateDialCode) {
                var dialCode = this.selectedCountryData.dialCode ? "+" + this.selectedCountryData.dialCode : "", parent = this.telInput.parent();
                if (prevCountry.dialCode) {
                    parent.removeClass("iti-sdc-" + (prevCountry.dialCode.length + 1));
                }
                if (dialCode) {
                    parent.addClass("iti-sdc-" + dialCode.length);
                }
                this.selectedDialCode.text(dialCode);
            }
            // and the input's placeholder
            this._updatePlaceholder();
            // update the active list item
            this.countryListItems.removeClass("active");
            if (countryCode) {
                this.countryListItems.find(".iti-flag." + countryCode).first().closest(".country").addClass("active");
            }
            // return if the flag has changed or not
            return prevCountry.iso2 !== countryCode;
        },
        // update the input placeholder to an example number from the currently selected country
        _updatePlaceholder: function() {
            var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && (this.options.autoPlaceholder === true || this.options.autoPlaceholder === "polite");
            if (window.intlTelInputUtils && shouldSetPlaceholder) {
                var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType], placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
                placeholder = this._beforeSetNumber(placeholder);
                if (typeof this.options.customPlaceholder === "function") {
                    placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
                }
                this.telInput.attr("placeholder", placeholder);
            }
        },
        // called when the user selects a list item from the dropdown
        _selectListItem: function(listItem) {
            // update selected flag and active list item
            var flagChanged = this._setFlag(listItem.attr("data-country-code"));
            this._closeDropdown();
            this._updateDialCode(listItem.attr("data-dial-code"), true);
            // focus the input
            this.telInput.focus();
            // put cursor at end - this fix is required for FF and IE11 (with nationalMode=false i.e. auto inserting dial code), who try to put the cursor at the beginning the first time
            if (this.isGoodBrowser) {
                var len = this.telInput.val().length;
                this.telInput[0].setSelectionRange(len, len);
            }
            if (flagChanged) {
                this._triggerCountryChange();
            }
        },
        // close the dropdown and unbind any listeners
        _closeDropdown: function() {
            this.countryList.addClass("hide");
            // update the arrow
            this.selectedFlagInner.children(".iti-arrow").removeClass("up");
            // unbind key events
            $(document).off(this.ns);
            // unbind click-off-to-close
            $("html").off(this.ns);
            // unbind hover and click listeners
            this.countryList.off(this.ns);
            // remove menu from container
            if (this.options.dropdownContainer) {
                if (!this.isMobile) {
                    $(window).off("scroll" + this.ns);
                }
                this.dropdown.detach();
            }
            this.telInput.trigger("close:countrydropdown");
        },
        // check if an element is visible within it's container, else scroll until it is
        _scrollTo: function(element, middle) {
            var container = this.countryList, containerHeight = container.height(), containerTop = container.offset().top, containerBottom = containerTop + containerHeight, elementHeight = element.outerHeight(), elementTop = element.offset().top, elementBottom = elementTop + elementHeight, newScrollTop = elementTop - containerTop + container.scrollTop(), middleOffset = containerHeight / 2 - elementHeight / 2;
            if (elementTop < containerTop) {
                // scroll up
                if (middle) {
                    newScrollTop -= middleOffset;
                }
                container.scrollTop(newScrollTop);
            } else if (elementBottom > containerBottom) {
                // scroll down
                if (middle) {
                    newScrollTop += middleOffset;
                }
                var heightDifference = containerHeight - elementHeight;
                container.scrollTop(newScrollTop - heightDifference);
            }
        },
        // replace any existing dial code with the new one
        // Note: called from _selectListItem and setCountry
        _updateDialCode: function(newDialCode, hasSelectedListItem) {
            var inputVal = this.telInput.val(), newNumber;
            // save having to pass this every time
            newDialCode = "+" + newDialCode;
            if (inputVal.charAt(0) == "+") {
                // there's a plus so we're dealing with a replacement (doesn't matter if nationalMode or not)
                var prevDialCode = this._getDialCode(inputVal);
                if (prevDialCode) {
                    // current number contains a valid dial code, so replace it
                    newNumber = inputVal.replace(prevDialCode, newDialCode);
                } else {
                    // current number contains an invalid dial code, so ditch it
                    // (no way to determine where the invalid dial code ends and the rest of the number begins)
                    newNumber = newDialCode;
                }
            } else if (this.options.nationalMode || this.options.separateDialCode) {
                // don't do anything
                return;
            } else {
                // nationalMode is disabled
                if (inputVal) {
                    // there is an existing value with no dial code: prefix the new dial code
                    newNumber = newDialCode + inputVal;
                } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
                    // no existing value and either they've just selected a list item, or autoHideDialCode is disabled: insert new dial code
                    newNumber = newDialCode;
                } else {
                    return;
                }
            }
            this.telInput.val(newNumber);
        },
        // try and extract a valid international dial code from a full telephone number
        // Note: returns the raw string inc plus character and any whitespace/dots etc
        _getDialCode: function(number) {
            var dialCode = "";
            // only interested in international numbers (starting with a plus)
            if (number.charAt(0) == "+") {
                var numericChars = "";
                // iterate over chars
                for (var i = 0; i < number.length; i++) {
                    var c = number.charAt(i);
                    // if char is number
                    if ($.isNumeric(c)) {
                        numericChars += c;
                        // if current numericChars make a valid dial code
                        if (this.countryCodes[numericChars]) {
                            // store the actual raw string (useful for matching later)
                            dialCode = number.substr(0, i + 1);
                        }
                        // longest dial code is 4 chars
                        if (numericChars.length == 4) {
                            break;
                        }
                    }
                }
            }
            return dialCode;
        },
        // get the input val, adding the dial code if separateDialCode is enabled
        _getFullNumber: function() {
            var val = $.trim(this.telInput.val()), dialCode = this.selectedCountryData.dialCode, prefix, numericVal = this._getNumeric(val), // normalized means ensure starts with a 1, so we can match against the full dial code
            normalizedVal = numericVal.charAt(0) == "1" ? numericVal : "1" + numericVal;
            if (this.options.separateDialCode) {
                prefix = "+" + dialCode;
            } else if (val.charAt(0) != "+" && val.charAt(0) != "1" && dialCode && dialCode.charAt(0) == "1" && dialCode.length == 4 && dialCode != normalizedVal.substr(0, 4)) {
                // if the user has entered a national NANP number, then ensure it includes the full dial code / area code
                prefix = dialCode.substr(1);
            } else {
                prefix = "";
            }
            return prefix + val;
        },
        // remove the dial code if separateDialCode is enabled
        _beforeSetNumber: function(number) {
            if (this.options.separateDialCode) {
                var dialCode = this._getDialCode(number);
                if (dialCode) {
                    // US dialCode is "+1", which is what we want
                    // CA dialCode is "+1 123", which is wrong - should be "+1" (as it has multiple area codes)
                    // AS dialCode is "+1 684", which is what we want
                    // Solution: if the country has area codes, then revert to just the dial code
                    if (this.selectedCountryData.areaCodes !== null) {
                        dialCode = "+" + this.selectedCountryData.dialCode;
                    }
                    // a lot of numbers will have a space separating the dial code and the main number, and some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get rid of it
                    // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc
                    var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                    number = number.substr(start);
                }
            }
            return this._cap(number);
        },
        // trigger the 'countrychange' event
        _triggerCountryChange: function() {
            this.telInput.trigger("countrychange", this.selectedCountryData);
        },
        /**************************
   *  SECRET PUBLIC METHODS
   **************************/
        // this is called when the geoip call returns
        handleAutoCountry: function() {
            if (this.options.initialCountry === "auto") {
                // we must set this even if there is an initial val in the input: in case the initial val is invalid and they delete it - they should see their auto country
                this.defaultCountry = $.fn[pluginName].autoCountry;
                // if there's no initial value in the input, then update the flag
                if (!this.telInput.val()) {
                    this.setCountry(this.defaultCountry);
                }
                this.autoCountryDeferred.resolve();
            }
        },
        // this is called when the utils request completes
        handleUtils: function() {
            // if the request was successful
            if (window.intlTelInputUtils) {
                // if there's an initial value in the input, then format it
                if (this.telInput.val()) {
                    this._updateValFromNumber(this.telInput.val());
                }
                this._updatePlaceholder();
            }
            this.utilsScriptDeferred.resolve();
        },
        /********************
   *  PUBLIC METHODS
   ********************/
        // remove plugin
        destroy: function() {
            if (this.allowDropdown) {
                // make sure the dropdown is closed (and unbind listeners)
                this._closeDropdown();
                // click event to open dropdown
                this.selectedFlagInner.parent().off(this.ns);
                // label click hack
                this.telInput.closest("label").off(this.ns);
            }
            // unbind submit event handler on form
            if (this.options.autoHideDialCode) {
                var form = this.telInput.prop("form");
                if (form) {
                    $(form).off(this.ns);
                }
            }
            // unbind all events: key events, and focus/blur events if autoHideDialCode=true
            this.telInput.off(this.ns);
            // remove markup (but leave the original input)
            var container = this.telInput.parent();
            container.before(this.telInput).remove();
        },
        // get the extension from the current number
        getExtension: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return "";
        },
        // format the number to the given format
        getNumber: function(format) {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.formatNumber(this._getFullNumber(), this.selectedCountryData.iso2, format);
            }
            return "";
        },
        // get the type of the entered number e.g. landline/mobile
        getNumberType: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return -99;
        },
        // get the country data for the currently selected flag
        getSelectedCountryData: function() {
            return this.selectedCountryData;
        },
        // get the validation error
        getValidationError: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getValidationError(this._getFullNumber(), this.selectedCountryData.iso2);
            }
            return -99;
        },
        // validate the input val - assumes the global function isValidNumber (from utilsScript)
        isValidNumber: function() {
            var val = $.trim(this._getFullNumber()), countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
            return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
        },
        // update the selected flag, and update the input val accordingly
        setCountry: function(countryCode) {
            countryCode = countryCode.toLowerCase();
            // check if already selected
            if (!this.selectedFlagInner.hasClass(countryCode)) {
                this._setFlag(countryCode);
                this._updateDialCode(this.selectedCountryData.dialCode, false);
                this._triggerCountryChange();
            }
        },
        // set the input value and update the flag
        setNumber: function(number) {
            // we must update the flag first, which updates this.selectedCountryData, which is used for formatting the number before displaying it
            var flagChanged = this._updateFlagFromNumber(number);
            this._updateValFromNumber(number);
            if (flagChanged) {
                this._triggerCountryChange();
            }
        },
        // set the placeholder number typ
        setPlaceholderNumberType: function(type) {
            this.options.placeholderNumberType = type;
            this._updatePlaceholder();
        }
    };
    // using https://github.com/jquery-boilerplate/jquery-boilerplate/wiki/Extending-jQuery-Boilerplate
    // (adapted to allow public functions)
    $.fn[pluginName] = function(options) {
        var args = arguments;
        // Is the first parameter an object (options), or was omitted,
        // instantiate a new instance of the plugin.
        if (options === undefined || typeof options === "object") {
            // collect all of the deferred objects for all instances created with this selector
            var deferreds = [];
            this.each(function() {
                if (!$.data(this, "plugin_" + pluginName)) {
                    var instance = new Plugin(this, options);
                    var instanceDeferreds = instance._init();
                    // we now have 2 deffereds: 1 for auto country, 1 for utils script
                    deferreds.push(instanceDeferreds[0]);
                    deferreds.push(instanceDeferreds[1]);
                    $.data(this, "plugin_" + pluginName, instance);
                }
            });
            // return the promise from the "master" deferred object that tracks all the others
            return $.when.apply(null, deferreds);
        } else if (typeof options === "string" && options[0] !== "_") {
            // If the first parameter is a string and it doesn't start
            // with an underscore or "contains" the `init`-function,
            // treat this as a call to a public method.
            // Cache the method call to make it possible to return a value
            var returns;
            this.each(function() {
                var instance = $.data(this, "plugin_" + pluginName);
                // Tests that there's already a plugin-instance
                // and checks that the requested public method exists
                if (instance instanceof Plugin && typeof instance[options] === "function") {
                    // Call the method of our plugin instance,
                    // and pass it the supplied arguments.
                    returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }
                // Allow instances to be destroyed via the 'destroy' method
                if (options === "destroy") {
                    $.data(this, "plugin_" + pluginName, null);
                }
            });
            // If the earlier cached method gives a value back return the value,
            // otherwise return this to preserve chainability.
            return returns !== undefined ? returns : this;
        }
    };
    /********************
 *  STATIC METHODS
 ********************/
    // get the country data object
    $.fn[pluginName].getCountryData = function() {
        return allCountries;
    };
    // load the utils script
    $.fn[pluginName].loadUtils = function(path, utilsScriptDeferred) {
        if (!$.fn[pluginName].loadedUtilsScript) {
            // don't do this twice! (dont just check if window.intlTelInputUtils exists as if init plugin multiple times in quick succession, it may not have finished loading yet)
            $.fn[pluginName].loadedUtilsScript = true;
            // dont use $.getScript as it prevents caching
            $.ajax({
                type: "GET",
                url: path,
                complete: function() {
                    // tell all instances that the utils request is complete
                    $(".intl-tel-input input").intlTelInput("handleUtils");
                },
                dataType: "script",
                cache: true
            });
        } else if (utilsScriptDeferred) {
            utilsScriptDeferred.resolve();
        }
    };
    // default options
    $.fn[pluginName].defaults = defaults;
    // version
    $.fn[pluginName].version = "12.1.15";
    // Array of country objects for the flag dropdown.
    // Here is the criteria for the plugin to support a given country/territory
    // - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
    // - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
    // - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
    // - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml
    // Each country array has the following information:
    // [
    //    Country name,
    //    iso2 code,
    //    International dial code,
    //    Order (if >1 country with same dial code),
    //    Area codes
    // ]
    var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1684" ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1264" ], [ "Antigua and Barbuda", "ag", "1268" ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1242" ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1246" ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1441" ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1284" ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1 ], [ "Cayman Islands", "ky", "1345" ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2 ], [ "Cocos (Keeling) Islands", "cc", "61", 1 ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1767" ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1473" ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1671" ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1 ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2 ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1876" ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3 ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1 ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1 ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1664" ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1670" ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1869" ], [ "Saint Lucia", "lc", "1758" ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1784" ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1721" ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1 ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1868" ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1649" ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1340" ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1 ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1 ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1 ] ];
    // loop over all of the countries above
    for (var i = 0; i < allCountries.length; i++) {
        var c = allCountries[i];
        allCountries[i] = {
            name: c[0],
            iso2: c[1],
            dialCode: c[2],
            priority: c[3] || 0,
            areaCodes: c[4] || null
        };
    }
});

/***/ }),

/***/ 1274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Rover = Rover || {};
Rover.models = Rover.models || {};
Rover.collections = Rover.collections || {};

Rover.models.Dog = Backbone.Model.extend({
  defaults: {
    id: null,
    name: '',
    weight: '',
    breeds: [],
    gender: ''
  }
});

Rover.collections.DogCollection = Backbone.Collection.extend({
  model: Rover.models.Dog
  // Future: set this up and fetch dogs asynchronously
  // url: fetchUsersDogsUrl
  //
});

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(function () {
  if (!$('body').hasClass('js-account-notifications')) {
    return;
  }
  $(document).on('change', '.js-notify-opt-out', function () {
    var $el = $('.js-granular-notify-controls');
    if ($(this).is(':checked')) {
      $el.fadeOut();
    } else {
      $el.fadeIn();
    }
  });
  $(document).on('change', '.js-quiet-hours', function () {
    var $el = $('.js-quiet-hours-row');
    if ($(this).is(':checked')) {
      $el.fadeIn();
    } else {
      $el.fadeOut();
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Rover.models.WeekendAvailability = Backbone.Model.extend({
  defaults: {
    week_monday: null,
    start_date: null,
    end_date: null,
    is_available: null,
    has_answered: null,
    strings: null
  },
  isNew: function isNew() {
    // Force a put request to the endpoint
    return false;
  },
  url: function url() {
    return Rover.urls.weekendAvailability;
  },
  setAvailable: function setAvailable(success, error) {
    return this.save({ is_available: true }, { success: success, error: error });
  },
  setUnavailable: function setUnavailable(success, error) {
    return this.save({ is_available: false }, { success: success, error: error });
  }
});

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Alerts = __webpack_require__(25);

var _Alerts2 = _interopRequireDefault(_Alerts);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(14);

var _underscore2 = _interopRequireDefault(_underscore);

var _backbone = __webpack_require__(8);

var _backbone2 = _interopRequireDefault(_backbone);

var _moment = __webpack_require__(174);

var _moment2 = _interopRequireDefault(_moment);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  if (!(0, _jquery2.default)('body').hasClass('js-weekend-availability')) {
    return;
  }

  var WeekendAvailView = _backbone2.default.View.extend({
    initialize: function initialize() {
      var startDate = (0, _moment2.default)(_Rover2.default.context.weekendAvail.get('start_date'), _datetime2.default.DATE_ISO).format(_datetime2.default.MONTH_DAY_WEEK_MED);
      var lastDate = (0, _moment2.default)(_Rover2.default.context.weekendAvail.get('last_day'), _datetime2.default.DATE_ISO).format(_datetime2.default.MONTH_DAY_WEEK_MED);
      this.$('.js-start-date').empty().append('<strong>' + startDate + '</strong>');
      this.$('.js-last-date').empty().append('<strong>' + lastDate + '</strong>');
      _Rover2.default.context.weekendAvail.save({ is_available: _Rover2.default.context.isAvailableIntent }, {
        success: _underscore2.default.bind(this.success, this),
        error: _underscore2.default.bind(this.error, this)
      });
    },
    success: function success() {
      this.$('.js-loading-content').remove();
      this.$('.js-loaded-content').removeClass('hidden');
    },
    error: function error() {
      _Alerts2.default.showAlert('updating your availability');
    }
  });

  var weekendAvailView = new WeekendAvailView({
    el: '.js-weekend-availability'
  });
});

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

var _rover_modal = __webpack_require__(100);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Rover.views.QuizView = Backbone.View.extend({
  initialize: function initialize() {
    _.bindAll(this, 'advanceQuestion', 'displayError', 'onQuestionSuccess', 'onQuestionError');
    var questions = this.getQuestions();
    var currentQuestion = this.getCurrentQuestion();
    var index = questions.index(currentQuestion);
    if (index === 0) {
      this.showIntroModal();
    } else if (index === -1) {
      // Quiz is done, show success view
      this.showQuizDone();
    }
    var self = this;
    $('.js-question-form').ajaxForm({
      beforeSubmit: function beforeSubmit() {
        $('.js-form-error').hide();
      },
      success: function success() {
        return self.onQuestionSuccess(this);
      },
      error: function error(response) {
        return self.onQuestionError(this, response);
      }
    });
  },
  onQuestionSuccess: function onQuestionSuccess(ajaxForm) {
    this.advanceQuestion();
  },
  onQuestionError: function onQuestionError(ajaxForm, response) {
    var error = response.responseJSON.error_description;
    this.displayError(error);
  },
  getQuestions: function getQuestions() {
    return $('.js-quiz-question');
  },
  getCurrentQuestion: function getCurrentQuestion() {
    return $(this.getQuestions().filter(':visible'));
  },
  getNextQuestion: function getNextQuestion() {
    var questions = this.getQuestions();
    var index = questions.index(this.getCurrentQuestion());
    var question = questions[index + 1];
    if (question) {
      return $(question);
    }
  },
  advanceQuestion: function advanceQuestion() {
    var nextQuestion = this.getNextQuestion();
    if (nextQuestion) {
      var currentQuestion = this.getCurrentQuestion();
      currentQuestion.hide();
      nextQuestion.show();

      var contentModuleId = nextQuestion.attr('data-content-module-id');
      $('.js-content-module').hide();
      $('.js-content-module[data-content-module-id="' + contentModuleId + '"]').show();
    } else {
      this.showQuizDone();
    }
  },
  displayError: function displayError(errorText) {
    var currentQuestion = this.getCurrentQuestion();
    currentQuestion.find('input[type=radio]').prop('checked', false);
    var $formErrorDiv = currentQuestion.find('.js-form-error');
    $formErrorDiv.html(errorText);
    $formErrorDiv.show();
  },
  showIntroModal: function showIntroModal() {
    var modal = new _rover_modal2.default({
      title: $('.js-intro-modal-title').html(),
      content: $('.js-intro-modal-content').html()
    });
    modal.open();
  },
  showQuizDone: function showQuizDone() {
    $('.js-rover-primary-col').hide();
    $('.js-rover-secondary-col').hide();
    $('.js-quiz-done').show();
  }
});

$(function () {
  var $body = $('body');
  if (!$body.hasClass('js-safety-quiz')) {
    return;
  }
  new Rover.views.QuizView({});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)))

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _conversation = __webpack_require__(578);

var _conversation2 = _interopRequireDefault(_conversation);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(14);

var _underscore2 = _interopRequireDefault(_underscore);

var _moment = __webpack_require__(174);

var _moment2 = _interopRequireDefault(_moment);

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _requestable = __webpack_require__(461);

var _requestable2 = _interopRequireDefault(_requestable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConversationModel = _requestable2.default.extend({
  defaults: {
    dates: []
  },
  initialize: function initialize() {
    var _this = this;

    this.on('change:dates', _underscore2.default.bind(function () {
      _this.trigger('datesChanged');
    }, this));
  },
  getOpk: function getOpk() {
    return (0, _conversation2.default)(this.get('url'));
  },
  getServiceType: function getServiceType() {
    return this.get('_service_type');
  },
  getRelationship: function getRelationship() {
    return this.get('relationship');
  },
  getDatesData: function getDatesData() {
    return {
      start_date: this.get('start_date'),
      end_date: this.get('end_date'),
      dates: this.get('dates')
    };
  },
  isEndDateExclusive: function isEndDateExclusive() {
    var serviceType = this.getServiceType();
    if (!serviceType) {
      return true;
    } else if (serviceType.is_end_date_exclusive === false) {
      return false;
    }
    return true;
  },
  supportsNonContiguousDates: function supportsNonContiguousDates() {
    var serviceType = this.getServiceType();
    return !!serviceType && serviceType.supports_non_contiguous_dates;
  },
  supportsNumUnitsPerDay: function supportsNumUnitsPerDay() {
    var serviceType = this.getServiceType();
    return !!serviceType && serviceType.supports_num_units_per_day;
  },
  requiresDates: function requiresDates() {
    var serviceType = this.getServiceType();
    return !!serviceType && !serviceType.supports_start_end_date;
  },
  unitsAndDatesAsSentence: function unitsAndDatesAsSentence() {
    var out = '';
    if (this.supportsNumUnitsPerDay()) {
      var numUnitsPerDay = this.getNumUnitsPerDay();
      out += numUnitsPerDay;
      if (numUnitsPerDay > 1) {
        out += ' times ';
      } else {
        out += ' time ';
      }
      out += 'per day ';
    }
    if (!this.supportsNonContiguousDates()) {
      var start = (0, _moment2.default)(this.get('start_date')).format(this.dateDisplayFormat);
      var end = (0, _moment2.default)(this.get('end_date')).format(this.dateDisplayFormat);
      out += 'from ' + start + ' to ' + end;
    } else {
      out += 'on ' + _Rover2.default.utils.syndeticJoin(this.datesList());
    }
    return out;
  },
  dropOff: function dropOff() {
    var out = '';

    if (this.supportsNumUnitsPerDay()) {
      return this.unitsAndDatesAsSentence();
    }
    if (!this.supportsNonContiguousDates()) {
      var start = (0, _moment2.default)(this.get('start_date')).format(_datetime2.default.MONTH_DAY_WEEK_MED);
      out += 'Drop off: ' + start;
    } else {
      out += 'on ' + _Rover2.default.utils.syndeticJoin(this.datesList());
    }
    return out;
  },
  from: function from() {
    var start = (0, _moment2.default)(this.get('start_date')).format(_datetime2.default.MONTH_DAY_WEEK_MED);
    return 'From: ' + start;
  },
  to: function to() {
    var end = (0, _moment2.default)(this.get('end_date')).format(_datetime2.default.MONTH_DAY_WEEK_MED);
    return 'To: ' + end;
  },
  pickUp: function pickUp() {
    if (this.supportsNonContiguousDates()) {
      return '';
    }

    var end = (0, _moment2.default)(this.get('end_date')).format(_datetime2.default.MONTH_DAY_WEEK_MED);
    var out = 'Pick up: ' + end;
    return out;
  },
  datesList: function datesList(format) {
    var dateFormat = format || this.dateDisplayFormat;
    return this.get('dates').map(function (date) {
      return (0, _moment2.default)(date.date).format(dateFormat);
    });
  },
  isOvernightBoarding: function isOvernightBoarding() {
    return this.get('service_type') === 'overnight-boarding';
  },
  isOvernightTraveling: function isOvernightTraveling() {
    return this.get('service_type') === 'overnight-traveling';
  },
  getDuration: function getDuration() {
    var startDate = (0, _moment2.default)(this.get('start_date'));
    var endDate = (0, _moment2.default)(this.get('end_date'));
    var endDateExclusive = null;

    if (this.supportsNonContiguousDates()) {
      return this.get('dates').length;
    }
    if (!this.isEndDateExclusive()) {
      endDateExclusive = endDate.add(1, 'days');
    } else {
      endDateExclusive = endDate;
    }

    return Math.max(1, endDateExclusive.diff(startDate, 'days'));
  },
  getNumUnitsPerDay: function getNumUnitsPerDay() {
    var dates = this.get('dates');

    if (!this.supportsNumUnitsPerDay() || dates.length === 0) {
      return 1;
    }

    return dates[0].num_units;
  },
  saveNumUnitsPerDay: function saveNumUnitsPerDay(numUnitsPerDay, optimisticAttrUpdate) {
    var newDates = this.get('dates').map(function (date) {
      return {
        date: date.date,
        num_units: numUnitsPerDay
      };
    });

    return this.saveDraftPricing({ dates: newDates }, optimisticAttrUpdate);
  },
  saveDates: function saveDates(dates, optimisticAttrUpdate) {
    var numUnitsToSet = this.getNumUnitsPerDay();

    if (!this.requiresDates()) {
      return null;
    }

    var newDates = dates.map(function (date) {
      return {
        date: date,
        num_units: numUnitsToSet
      };
    });

    return this.saveDraftPricing({ dates: newDates }, optimisticAttrUpdate);
  },
  saveStartAndEndDate: function saveStartAndEndDate(startDate, endDate, optimisticAttrUpdate) {
    if (this.supportsNonContiguousDates()) {
      return null;
    }

    if (this.supportsNumUnitsPerDay()) {
      return this.saveDates(this.buildDerivedDates(startDate, endDate), optimisticAttrUpdate);
    }
    return this.saveDraftPricing({ start_date: startDate, end_date: endDate }, optimisticAttrUpdate);
  },
  buildDerivedDates: function buildDerivedDates(startDate, endDate) {
    var dateFormat = this.dateFormat;

    var startDateM = (0, _moment2.default)(startDate, dateFormat);
    var endDateM = (0, _moment2.default)(endDate, dateFormat);
    var dates = [startDate];
    var diff = endDateM.diff(startDateM, 'days');

    // start_date and end_date are equal
    if (diff === 0) {
      return dates;
    }

    for (var i = 1; i <= diff; i += 1) {
      dates.push((0, _moment2.default)(startDate, dateFormat).add(i, 'days').format(dateFormat));
    }

    return dates;
  },
  save: function save(attrs, options) {
    // We NEVER want to set the provider_archived_status when saving because
    // if we do, we're telling the api that this is an archiving operation
    // Write your own archiving operation, if you wish.
    this.unset('provider_archived_status', { silent: true });

    return _requestable2.default.prototype.save.call(this, attrs, options);
  },
  shadowSave: function shadowSave(attributes) {
    // For some operations (i.e. create request, cancel request) the API
    // expects the client to set some model attributes to specific values,
    // call PUT, then it will return the model with updated attributes.
    //
    // There may be many Views listening to attributes on this model. If
    // we have to change one of those attributes to facilitate the the
    // specific API operation (like 'request') then some listeners may
    // be triggered even though we didn't set that attribute to a normal
    // state.
    //
    // To work around this trouble, we're creating a copy of the model
    // which includes all of that model's attributes, saving it, and
    // when that save succeeds, updating the original with the new
    // attributes.
    //
    // Alternatives to this approach include:
    // 1. Use this.set(attributes, {silent: true}) which will suppress
    //    triggers. If the subsequent save fails, however, the model
    //    could be left in an invalid state. Also, the Backbone docs
    //    say that you should probably never use {silent: True}
    // 2. Put a property on the Conversation model so that it can track
    //    when this save is in flight. All listeners on request should
    //    ignore changes while it is in flight. Once the save completes,
    //    disable the flag.

    var currentAttributes = this.attributes;
    var self = this;
    var shadowAttributes = Object.assign({}, currentAttributes, attributes);
    var shadow = new ConversationModel(shadowAttributes);
    shadow.set('booking_add_ons', shadow.getActiveBookingAddOns());
    return shadow.save().then(function (data) {
      self.set(data);
    }, function (err) {
      var confirmation = void 0;
      if (err.status === 409 && err.statusText === 'CONFLICT') {
        // eslint-disable-next-line no-alert, no-restricted-globals
        confirmation = confirm('This request has been updated since you loaded this page. Press OK to see up-to-date details.');
      }

      if (confirmation) {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
      return err;
    });
  },
  getDraftPricing: function getDraftPricing(options) {
    var uri = this.get('urls').pricing;
    var request = {
      service: this.get('service'),
      requester: this.get('requester').url,
      pets: _underscore2.default.pluck(this.get('pets'), 'url')
    };

    if (this.requiresDates()) {
      request.dates = this.get('dates');
    } else {
      request.start_date = this.get('start_date');
      request.end_date = this.get('end_date');
    }

    request = _underscore2.default.extend(request, options);

    return _jquery2.default.ajax({
      method: 'POST',
      url: uri,
      data: JSON.stringify(request),
      contentType: 'application/json'
    });
  }
});

exports.default = ConversationModel;

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initIntlTelInput = initIntlTelInput;
exports.updateCleaveForInputs = updateCleaveForInputs;

var _cleave = __webpack_require__(1271);

var _cleave2 = _interopRequireDefault(_cleave);

var _jquery = __webpack_require__(9);

var _jquery2 = _interopRequireDefault(_jquery);

var _injector = __webpack_require__(22);

var _injector2 = _interopRequireDefault(_injector);

__webpack_require__(1272);

__webpack_require__(1274);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initIntlTelInput(inputEl, utilsLoadedCallback) {
  var $intlTelInput = inputEl ? (0, _jquery2.default)(inputEl) : (0, _jquery2.default)('.js-intl-tel-input');
  $intlTelInput.each(function () {
    var _this = this;

    // hack: for django form to make sure the correct value is sent to django b/c we cannot call js using
    // traditional post. This will not be an issue if the flow use ajax
    var name = (0, _jquery2.default)(this).attr('name');
    (0, _jquery2.default)(this).attr('name', '');
    // the utils script will be load lazily. Temp solution until we get better phone number input component
    (0, _jquery2.default)(this).intlTelInput({
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.15/js/utils.js',
      hiddenInput: name,
      autoPlaceholder: 'off',
      preferredCountries: ['us', 'ca', 'gb'],
      initialCountry: 'auto',
      geoIpLookup: function geoIpLookup(callback) {
        callback((0, _injector2.default)('Rover.context.countryCode', 'US'));
      }
    }).done(function () {
      if (utilsLoadedCallback) {
        utilsLoadedCallback((0, _jquery2.default)(_this));
      }
    });
    (0, _jquery2.default)(this).on('countrychange', function (e, countryData) {
      if (typeof window.intlTelInputUtils === 'undefined') return;
      var newNumber = window.intlTelInputUtils.formatNumber((0, _jquery2.default)(_this).val(), countryData.iso2, window.intlTelInputUtils.numberFormat.INTERNATIONAL);
      (0, _jquery2.default)(_this).intlTelInput('setNumber', newNumber);
    });
  });
  return $intlTelInput;
}

function updateCleaveForInputs() {
  // For each of the input, initialize cleave. Cleave gets destroyed and recreated when user change country since
  // we only use cleave for US
  var cleave = (0, _jquery2.default)(this).data('cleave');
  if (cleave) {
    cleave.destroy();
  }
  if (['us', 'ca'].includes((0, _jquery2.default)(this).intlTelInput('getSelectedCountryData').iso2)) {
    // hack: strip out +1 otherwise cleave will keep adding 1 in the beginning
    var value = (0, _jquery2.default)(this).val() || '';
    if (value.startsWith('+1')) {
      (0, _jquery2.default)(this).val(value.substring(2));
    }
    (0, _jquery2.default)(this).data('cleave', new _cleave2.default(this, {
      blocks: [3, 3, 4],
      delimiter: '-',
      numericOnly: true
    }));
  }
}

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APIVersion", function() { return APIVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "frontendDefaultApiVersion", function() { return frontendDefaultApiVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apiUrl", function() { return apiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fullApiUrl", function() { return fullApiUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_react_lib_types_Enum__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var APIVersion = function (_Enum) {
  _inherits(APIVersion, _Enum);

  function APIVersion() {
    _classCallCheck(this, APIVersion);

    return _possibleConstructorReturn(this, (APIVersion.__proto__ || Object.getPrototypeOf(APIVersion)).apply(this, arguments));
  }

  return APIVersion;
}(__WEBPACK_IMPORTED_MODULE_0__rover_react_lib_types_Enum__["a" /* default */]);

APIVersion.v3 = new APIVersion('v3');
APIVersion.v4 = new APIVersion('v4');
var frontendDefaultApiVersion = APIVersion.v3;

var apiUrl = function apiUrl() {
  var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : frontendDefaultApiVersion;
  return '/api/' + version + '/' + suffix;
};

var fullApiUrl = function fullApiUrl(suffix, version) {
  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location;

  var path = apiUrl(suffix, version);
  var base = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

  return '' + base + path;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  apiUrl: apiUrl,
  fullApiUrl: fullApiUrl,
  frontendDefaultApiVersion: frontendDefaultApiVersion
});

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(14);

var _underscore2 = _interopRequireDefault(_underscore);

var _backbone = __webpack_require__(8);

var _backbone2 = _interopRequireDefault(_backbone);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.Model.extend({
  dateFormat: _datetime2.default.DATE_ISO,
  dateDisplayFormat: _datetime2.default.DATE_SHORT,
  idAttribute: 'url',
  isRecurring: false,
  url: function url() {
    return this.get('url');
  },
  initialize: function initialize() {
    _underscore2.default.bindAll(this, 'acceptRequest', 'createRequest', 'toggleRequesterAddOn');
  },
  getOpk: function getOpk() {
    // This should be overridden by "subclasses"
    return '';
  },
  getState: function getState() {
    var state = this.get('status');
    var request = this.get('request');

    if (state === 'booked' || state === 'cancelled') {
      return 'booked';
    } else if (!request) {
      return 'authorize';
    } else if (request && request.requester_actions.indexOf('accepted') !== -1) {
      return 'pay';
    } else if (request && request.provider_actions.indexOf('accepted') !== -1) {
      return 'requested';
    }

    // We shouldn't get here
    return null;
  },
  getUnit: function getUnit() {
    var addOn = _underscore2.default.findWhere(this.get('booking_add_ons'), {
      is_alternative_rate: true
    });
    return addOn ? addOn.frequency : null;
  },
  isBooked: function isBooked() {
    return this.getState() === 'booked';
  },
  isPayingState: function isPayingState() {
    return ['authorize', 'pay'].indexOf(this.getState()) !== -1 && !_Rover2.default.context.isSitter;
  },
  getActiveBookingAddOns: function getActiveBookingAddOns() {
    var pets = this.get('pets') || [];
    var petUrls = _underscore2.default.pluck(pets, 'url');

    return _underscore2.default.filter(this.get('booking_add_ons'), function (addon) {
      // exclude inactive addons and ones with pets not in the pets attribute

      if (!addon.active) {
        return false;
      }

      if (!addon.pet) {
        return true;
      }

      return _underscore2.default.contains(petUrls, addon.pet);
    });
  },
  hasRequest: function hasRequest() {
    return this.get('request') !== null;
  },
  getRequestVersion: function getRequestVersion() {
    if (!this.hasRequest()) {
      return null;
    }
    return this.get('request').request_version;
  },
  includesPet: function includesPet(petUrl) {
    return _underscore2.default.chain(this.get('pets')).pluck('url').contains(petUrl).value();
  },
  getRequestRecipient: function getRequestRecipient() {
    if (!this.hasRequest()) {
      return null;
    }

    var request = this.get('request');
    return this.getParticipantByUrl(request.recipient);
  },
  getParticipantByUrl: function getParticipantByUrl(url) {
    var participants = [this.get('requester'), this.get('provider')];
    return _underscore2.default.chain(participants).filter(function (person) {
      return person.url === url;
    }).first().value();
  },
  setPets: function setPets(pets) {
    var bookingAddOns = this.getCleanBookingAddOns(pets);
    this.set({
      pets: pets,
      booking_add_ons: bookingAddOns
    });
  },
  getCleanBookingAddOns: function getCleanBookingAddOns(pets) {
    // get a list of addons which are either !is_alternative_rate or is a rate
    // for a pet included in the given list
    var bookingAddOns = this.get('booking_add_ons');
    var petUrls = _underscore2.default.pluck(pets, 'url');
    return bookingAddOns.filter(function (bao) {
      return bao.active && !bao.is_alternative_rate || petUrls.indexOf(bao.pet) > -1;
    });
  },
  toggleRequesterAddOn: function toggleRequesterAddOn(addOnSlug, active) {
    var _this = this;

    var addOn = _underscore2.default.filter(this.get('requester_add_ons'), function (ao) {
      return ao.slug === addOnSlug;
    })[0];
    addOn.active = active;
    this.getDraftPricing({
      booking_add_ons: this.get('booking_add_ons'),
      requester_add_ons: this.get('requester_add_ons')
    }).then(function (data) {
      _this.trigger('change:requester_add_ons', _this, _this.get('requester_add_ons'));
      _this.set('total_price', data.total_price);
    });
  },
  parse: function parse(response, xhr) {
    // The API returns inactive addons which are not useful to us. Remove them.
    return _extends({}, response, {
      booking_add_ons: _underscore2.default.filter(response.booking_add_ons, function (bao) {
        return bao.active;
      })
    });
  },
  createRequest: function createRequest() {
    // aka "Book It"

    return this.shadowSave({
      request: {
        status: 'pending',
        request_version: null
      },
      source: _Rover2.default.utils.getSourceDescription()
    });
  },
  cancelRequest: function cancelRequest() {
    return this.shadowSave({
      request: {
        status: 'cancelled',
        request_version: this.getRequestVersion()
      },
      source: _Rover2.default.utils.getSourceDescription()
    });
  },
  declineRequest: function declineRequest() {
    return this.shadowSave({
      request: {
        status: 'declined',
        request_version: this.getRequestVersion()
      },
      source: _Rover2.default.utils.getSourceDescription()
    });
  },
  acceptRequest: function acceptRequest() {
    return this.shadowSave({
      request: {
        status: 'accepted',
        request_version: this.getRequestVersion()
      },
      source: _Rover2.default.utils.getSourceDescription()
    });
  },
  getAlternativeRateAddOns: function getAlternativeRateAddOns() {
    return _underscore2.default.filter(this.getActiveBookingAddOns(), function (ao) {
      return ao.is_alternative_rate;
    });
  },
  getNonAlternativeRateAddOns: function getNonAlternativeRateAddOns() {
    return _underscore2.default.filter(this.getActiveBookingAddOns(), function (ao) {
      return !ao.is_alternative_rate;
    });
  },
  getActiveRequesterAddOns: function getActiveRequesterAddOns() {
    return _underscore2.default.filter(this.get('requester_add_ons'), function (ao) {
      return ao.active;
    });
  },
  getOptionalRequesterAddOns: function getOptionalRequesterAddOns() {
    return _underscore2.default.filter(this.get('requester_add_ons'), function (ao) {
      return !ao.is_required;
    });
  },
  fetchModel: function fetchModel(options) {
    // Normal fetch().then() gets (attributes, message, xhr) as arguments
    // For this method, fetchModel().then() gets (model, response) as arguments
    // so you can do normal promise chains and void having to use the
    // success and error callbacks.
    var d = _jquery2.default.Deferred();
    var o = _extends({
      success: d.resolve,
      error: d.reject
    }, options);
    this.fetch(o);
    return d.promise();
  },
  getPricing: function getPricing() {
    return this.getDraftPricing();
  },
  updateDraftPricing: function updateDraftPricing(attrs) {
    var _this2 = this;

    var newAttrs = attrs;
    newAttrs.booking_add_ons = this.get('booking_add_ons');
    this.getDraftPricing(newAttrs).then(function (data) {
      _this2.set(data);
    });
  },
  savePricingData: function savePricingData(data, deferred) {
    var _this3 = this;

    var d = deferred || _jquery2.default.Deferred();
    var originalAttributes = {};

    _underscore2.default.each(data, function (attr, key) {
      var oldValue = _this3.get(key);
      if (oldValue) {
        originalAttributes[key] = oldValue;
        _this3.set(key, attr);
      }
    });
    this.save({}, {
      success: function success(model, response, options) {
        d.resolve(response);
      },
      error: function error(model, response, options) {
        _this3.set(originalAttributes);
        d.reject(response);
      }
    });
    return d.promise();
  },
  saveDraftPricing: function saveDraftPricing(attrs) {
    var _this4 = this;

    var optimisticAttrUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var d = _jquery2.default.Deferred();

    if (optimisticAttrUpdate) {
      this.set(attrs);
    }

    this.getDraftPricing(attrs).then(function (data) {
      _this4.savePricingData(data, d);
    }, d.reject);
    return d.promise();
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function getConversationOpk(url) {
  return url.match(/conversations\/([a-zA-z0-9]+)\/$/)[1] || {};
}

/* harmony default export */ __webpack_exports__["default"] = (getConversationOpk);

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(174);

var _moment2 = _interopRequireDefault(_moment);

var _backbone = __webpack_require__(8);

var _backbone2 = _interopRequireDefault(_backbone);

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.View.extend({
  DAYS: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
  initialize: function initialize(options) {
    this.service = options.service;
    this.$el.addClass('js-service-dates-spec');
  },
  isRecurring: function isRecurring() {
    return false;
  },
  propagateDatesChanged: function propagateDatesChanged(target) {
    var _this = this;

    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'datesChanged';

    this.listenTo(target, event, _.bind(function () {
      return _this.trigger('datesChanged');
    }, this));
  },
  getDaysFromUrl: function getDaysFromUrl() {
    var url = new Url();

    return _.filter(this.DAYS, function (day) {
      var value = url.query[day];
      if (!value) return false;
      return value.toLowerCase() === 'true';
    });
  },
  getDateRangeFromUrl: function getDateRangeFromUrl() {
    var url = new Url();
    if (url.query.start_date && url.query.end_date) {
      return this.dateRange(url.query.start_date, url.query.end_date);
    }
    return [];
  },
  formatDate: function formatDate(dateString) {
    var date = (0, _moment2.default)(dateString, [_datetime2.default.DATE_SHORT, _datetime2.default.DATE_ISO]).toDate();
    if (!dateString) return null;
    return this.dateInISOFormat(date);
  },
  dateInISOFormat: function dateInISOFormat(date) {
    function zeroPad(s) {
      s += '';
      return '' + (s.length < 2 ? '0' : '') + s;
    }

    return date.getFullYear() + '-' + zeroPad(date.getMonth() + 1) + '-' + zeroPad(date.getDate());
  },
  dateRange: function dateRange(startDate, endDate) {
    var date = (0, _moment2.default)(startDate, [_datetime2.default.DATE_SHORT, _datetime2.default.DATE_ISO]);
    var end = (0, _moment2.default)(endDate, [_datetime2.default.DATE_SHORT, _datetime2.default.DATE_ISO]);
    var dateRange = [date.format(_datetime2.default.DATE_SHORT)];

    // If the service's end date is exclusive, we need to exclude the last day selected
    if (this.service.is_end_date_exclusive()) {
      end = end.subtract(1, 'days');
    }

    while (date.isBefore(end)) {
      date = date.add(1, 'days');
      dateRange.push(date.format(_datetime2.default.DATE_SHORT));
    }

    return dateRange;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialUtils = exports.FacebookUtils = undefined;

var _Alerts = __webpack_require__(25);

var _Alerts2 = _interopRequireDefault(_Alerts);

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Mustache = __webpack_require__(44);

var _Mustache2 = _interopRequireDefault(_Mustache);

var _dataLayer = __webpack_require__(61);

var _dataLayer2 = _interopRequireDefault(_dataLayer);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _currentUser = __webpack_require__(262);

var _currentUser2 = _interopRequireDefault(_currentUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Helper functions for Facebook calls
var FacebookUtils = {
  observer: new _vue2.default(),
  initialized: false,
  setUpFBAsyncInit: function setUpFBAsyncInit() {
    // Facebook's API automatically calls this function once it has finished loading
    window.fbAsyncInit = function () {
      var FB = window.FB;
      FB.init({
        appId: _Rover2.default.facebook.appId, // App ID
        version: 'v2.11',
        status: true, // check login status
        cookie: true, // enable cookies to allow the server to access the session
        xfbml: true // parse XFBML
      });

      FB.Event.subscribe('edge.create', FacebookUtils.eventHandlers.handleFacebookLike);
      FB.Event.subscribe('auth.authResponseChange', FacebookUtils.eventHandlers.handleFacebookAuthChange);
      FB.Event.subscribe('comment.create', FacebookUtils.eventHandlers.handleFacebookCommentCreate);
      // Show all FBui elements
      (0, _jquery2.default)('.FBui').show();

      FacebookUtils.initialized = true;
      FacebookUtils.observer.$emit('FB:initialized');
    };
  },
  isInitialized: function isInitialized() {
    return new Promise(function (resolve, reject) {
      return FacebookUtils.initialized ? resolve(window.FB) : FacebookUtils.observer.$on('FB:initialized', function () {
        return resolve(window.FB);
      });
    });
  },
  defaultFBSignupError: function defaultFBSignupError() {
    alert("We're sorry, we were unable to connect your Facebook account " + 'due to an error. If you would like immediate help visit our Help Center at ' + 'support.rover.com, or call us at 888-453-7889');
  },
  defaultFBLoginError: function defaultFBLoginError() {
    alert("We're sorry, we were unable to authenticate with Facebook. " + 'If you would like immediate help visit our Help Center at ' + 'support.rover.com, or call us at 888-453-7889');
  },
  resetSharingDialog: function resetSharingDialog($form, clearCopy) {
    var shouldClearCopy = clearCopy === true;
    var $sharingCopy = (0, _jquery2.default)('.js-sharing-copy');

    $sharingCopy.prop('disabled', false);
    $form.find('.js-facebook-share-photo-button').btn('reset');

    if (shouldClearCopy) {
      $sharingCopy.val('');
    }
  },
  connectAccount: function connectAccount(authResponse, successCallback, errorCallback) {
    _jquery2.default.ajax({
      method: 'GET',
      url: _Rover2.default.facebook.authCallbackUrl,
      data: {
        facebook_id: authResponse.user_id,
        person_id: _currentUser2.default.id
      }
    }).done(function () {
      _jquery2.default.ajax({
        method: 'POST',
        url: _Rover2.default.facebook.authCallbackUrl,
        data: {
          token: authResponse.access_token,
          facebook_id: authResponse.user_id
        }
      }).done(successCallback).fail(errorCallback);
    }).fail(errorCallback);
  },
  connectAndResubmit: function connectAndResubmit($form, connect) {
    if (connect) {
      _Rover2.default.facebook.login(function () {
        (0, _jquery2.default)('.js-need-connect-to-share').addClass('hide');
        _Rover2.default.facebook.submittedForm.trigger('submit');
      }, function () {
        FacebookUtils.defaultFBSignupError();
        FacebookUtils.resetSharingDialog($form);
      }, 'email,publish_actions');
    } else {
      FacebookUtils.resetSharingDialog($form);
      (0, _jquery2.default)('.js-need-connect-to-share').removeClass('hide');
    }
  },
  publishGranted: function publishGranted(permissionData) {
    if (permissionData) {
      for (var i = 0; i < permissionData.length; i += 1) {
        var permObj = permissionData[i];
        if (permObj.permission === 'publish_actions' && permObj.status === 'granted') {
          return true;
        }
      }
    }

    return false;
  },
  sharePhotoError: function sharePhotoError($form, response) {
    if (response.type === 'needs_connect') {
      FacebookUtils.resetSharingDialog($form);
      (0, _jquery2.default)('.js-need-connect-to-share').removeClass('hide');
    } else {
      FacebookUtils.defaultFBLoginError();
    }
  },
  sharePhotoOnFacebook: function sharePhotoOnFacebook() {
    var $form = _Rover2.default.facebook.submittedForm;
    var caption = _jquery2.default.trim((0, _jquery2.default)('.js-sharing-copy').val());
    var imageToShare = $form.find('[name=imageToShare]').val();
    var urlToShare = $form.find('[name=urlToShare]').val();
    var contentType = $form.find('[name=contentType]').val();
    var objectId = $form.find('[name=objectId]').val();

    _jquery2.default.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: {
        caption: caption,
        message_image_id: objectId,
        photo_url: imageToShare,
        link: urlToShare
      },
      success: function success(data) {
        if (data.status === 'success') {
          $form.find('.js-facebook-share-photo-button').btn('complete');

          setTimeout(function () {
            (0, _jquery2.default)('.js-facebook-share-modal').on('hidden.bs.modal', function () {
              FacebookUtils.resetSharingDialog($form, true);
            }).modal('hide');
          }, 1500);

          _Rover2.default.trackSocial('facebook', 'image-share', contentType, objectId);
        } else {
          FacebookUtils.sharePhotoError($form, data);
        }
      },
      error: function error(jqXHR) {
        FacebookUtils.sharePhotoError($form, _jquery2.default.parseJSON(jqXHR.responseText));
      }
    });
  },

  clickHandlers: {
    handleConnectButtonClick: function handleConnectButtonClick(e) {
      _Rover2.default.facebook.currentConnectButton = (0, _jquery2.default)(e.currentTarget);
      _Rover2.default.facebook.currentConnectButton.btn('loading');
      _Rover2.default.facebook.connectLocation = _Rover2.default.facebook.currentConnectButton.attr('data-connect-location');

      var resetButton = function resetButton(success) {
        _Rover2.default.facebook.currentConnectButton.btn('reset');

        if (success) {
          if (_Rover2.default.facebook.currentConnectButton.attr('data-hide-on-success')) {
            _Rover2.default.facebook.currentConnectButton.hide();
            if (_Rover2.default.facebook.currentConnectButton.parents('.js-connect-facebook-wrapper')) {
              _Rover2.default.facebook.currentConnectButton.parents('.js-connect-facebook-wrapper').hide();
            }
          }
          if (_Rover2.default.facebook.currentConnectButton.attr('data-show-success-message')) {
            _Alerts2.default.showAlert('success', 'Your account is now connected with Facebook!');
          }
          (0, _jquery2.default)(window).trigger('connectsuccess.facebook.rover');
        }
      };

      _Rover2.default.facebook.login(function (authResponse) {
        FacebookUtils.connectAccount(authResponse, function () {
          resetButton(true);
        }, function (xhr) {
          var msg = 'We were unable to connect your Facebook account.' + ' Please try again later.';
          if (parseInt(xhr.status, 10) === 409) {
            msg = 'Another user is already connected to this Facebook account.' + ' Please try again with a different Facebook login.';
          }
          _Alerts2.default.showAlert('warning', msg);
          resetButton(false);
        });
      }, function () {
        resetButton(false);
      });
    },
    handleSignupButtonClick: function handleSignupButtonClick(e) {
      _Rover2.default.facebook.currentConnectButton = (0, _jquery2.default)(e.currentTarget);
      _Rover2.default.facebook.currentConnectButton.btn('loading');
      _Rover2.default.facebook.signup(false, function () {
        _dataLayer2.default.push({
          event: 'account-sign-up-facebook-sign-up',
          submitStatus: 'fail',
          errorMessage: 'We were unable to connect with Facebook. Please use the form below to sign up.'
        });
        _Rover2.default.facebook.currentConnectButton.btn('reset');
        var errorContainer = _Rover2.default.facebook.currentConnectButton.attr('data-error-container');
        if (errorContainer) {
          _Alerts2.default.showAlert('danger', 'We were unable to sign you up', errorContainer);
        } else {
          FacebookUtils.defaultFBSignupError();
        }
      });
    },
    validatePermissionsAndShareOnFacebook: function validatePermissionsAndShareOnFacebook(e) {
      e.preventDefault();
      var FB = window.FB;
      var $form = (0, _jquery2.default)(e.currentTarget);
      $form.find('.js-facebook-share-photo-button').btn('loading');
      (0, _jquery2.default)('.js-sharing-copy').prop('disabled', true);

      _Rover2.default.facebook.submittedForm = $form;

      if (_currentUser2.default.id === 0) {
        (0, _jquery2.default)('.js-need-to-log-in').removeClass('hide');
        return false;
      }

      if (!_Rover2.default.facebook.connected) {
        FacebookUtils.connectAndResubmit($form, false);
        return false;
      }

      FB.api('/me/permissions', function (response) {
        if (FacebookUtils.publishGranted(response.data)) {
          FacebookUtils.sharePhotoOnFacebook();
        } else {
          FacebookUtils.connectAndResubmit($form, true);
        }
      });

      return false;
    },
    handleFBuiClick: function handleFBuiClick(e) {
      var $elt = (0, _jquery2.default)(e.currentTarget);
      var linkUrl = $elt.attr('data-link');
      // NOTE: Do not specify the data-* attributes if you want to use the
      // OpenGraph tags on the page (which you should do)
      var data = {
        method: $elt.attr('data-method') || 'feed',
        link: $elt.attr('data-link'),
        href: $elt.attr('data-link'),
        name: $elt.attr('data-name'),
        picture: $elt.attr('data-picture'),
        source: $elt.attr('data-source'),
        caption: $elt.attr('data-caption'),
        description: $elt.attr('data-description')
      };

      FacebookUtils.isInitialized().then(function (FB) {
        FB.ui(data, function (response) {
          if (response) {
            var trackingEvent = $elt.attr('data-tracking-event') || 'share_review';
            if (trackingEvent === 'testimonial-request-sent') {
              _jquery2.default.post(_Rover2.default.urls.trackTestimonialRequest, {
                method: 'facebook'
              }, function () {
                (0, _jquery2.default)(document).trigger('testimonial-requested');
              });
            }

            var shareAction = 'share';
            if ($elt.hasClass('js-enter-contest')) {
              shareAction = 'contest-share';
            }

            _Rover2.default.trackSocial('facebook', shareAction, $elt.attr('data-content-type'), $elt.attr('data-object-id'));
            _Rover2.default.postShareCallback('facebook', 'share');
          }
        });
      });
    }
  },
  eventHandlers: {
    handleFacebookLike: function handleFacebookLike(url, htmlElement) {
      _Rover2.default.postShareCallback('facebook', 'like');
    },
    handleFacebookCommentCreate: function handleFacebookCommentCreate(response) {
      _jquery2.default.post('{% url "marketing-comment-notify" %}', {
        link: response.href
      });
    },
    handleFacebookAuthChange: function handleFacebookAuthChange(response) {
      _Rover2.default.facebook.connected = response.status === 'connected';

      if (!_Rover2.default.facebook.connected) {
        _jquery2.default.removeCookie('longtermtoken');
        return;
      }

      // Only ask for a longterm token once a day
      if (_jquery2.default.cookie('longtermtoken')) {
        return;
      }
      _jquery2.default.cookie('longtermtoken', true, { expires: 1, path: '/' });

      var data = {
        token: response.authResponse.accessToken,
        facebook_id: response.authResponse.userID
      };

      if (_Rover2.default.facebook.connectLocation) {
        data.connect_location = _Rover2.default.facebook.connectLocation;
      }

      // Ping our server to renew/get a long term access token (stored on FacebookInfo record)
      _jquery2.default.post(_Rover2.default.facebook.authCallbackUrl, data);
    }
  }
};

var TwitterUtils = {
  handleTwitterLoad: function handleTwitterLoad() {
    // Set up twitter event tracking and post-share callbacks
    if (window.twttr) {
      window.twttr.ready(function (twitterObject) {
        twitterObject.events.bind('follow', function () {
          _Rover2.default.postShareCallback('twitter', 'like');
        });
        twitterObject.events.bind('tweet', function () {
          _Rover2.default.postShareCallback('twitter', 'share');
        });
      });
    }
  },
  basicTwitterIntentSupport: function basicTwitterIntentSupport() {
    // @see - https://dev.twitter.com/web/intents
    if (window.twitterIntentHandler) return;
    var intentRegex = /twitter\.com(:\d{2,4})?\/intent\/(\w+)/;
    var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
    var width = 550;
    var height = 420;
    var winHeight = screen.height;
    var winWidth = screen.width;

    function handleIntent(e) {
      var event = e || window.event;
      var target = event.target || event.srcElement;

      while (target && target.nodeName.toLowerCase() !== 'a') {
        target = target.parentNode;
      }

      if (target && target.nodeName.toLowerCase() === 'a' && target.href) {
        var m = target.href.match(intentRegex);
        if (m) {
          var left = Math.round(winWidth / 2 - width / 2);
          var top = 0;

          if (winHeight > height) {
            top = Math.round(winHeight / 2 - height / 2);
          }

          var o = windowOptions + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;
          window.open(target.href, 'intent', o);
          event.returnValue = false;
          if (event.preventDefault) {
            event.preventDefault();
          }
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener('click', handleIntent, false);
    } else if (document.attachEvent) {
      document.attachEvent('onclick', handleIntent);
    }
    window.twitterIntentHandler = true;
  }
};

var SocialUtils = {
  handlePinItClick: function handlePinItClick() {
    var newwindow = window.open((0, _jquery2.default)(this).attr('href'), 'name', 'height=300,width=600');

    if (window.focus) {
      newwindow.focus();
    }

    _Rover2.default.postShareCallback('pinterest', 'share');
    return false;
  },
  loadSocialScripts: function loadSocialScripts() {
    // Load facebook SDK if FB elements present on page
    if ((0, _jquery2.default)('.FBui').length || (0, _jquery2.default)('.js-connect').length || (0, _jquery2.default)('.js-connect-facebook').length || (0, _jquery2.default)('.js-facebook-sign-up').length || (0, _jquery2.default)('.js-facebook-register').length || (0, _jquery2.default)('.js-facebook-share-modal').length || (0, _jquery2.default)('.js-shareable-image').length || (0, _jquery2.default)('.fb-like').length) {
      _jquery2.default.getScript('//connect.facebook.net/en_US/sdk.js');
    }

    // Load google plus if share button markup is present on page
    if ((0, _jquery2.default)('.g-plusone').length) {
      _jquery2.default.getScript('https://apis.google.com/js/plusone.js');
      // Configuration which is apparently required despite not being
      // documented anywhere.  Thanks, Google
      window.___gcfg = {
        lang: 'en-US'
      };
    }

    // Load twitter if share button markup is present on page
    // Otherwise just run a basic click handler for twitter intents
    if ((0, _jquery2.default)('.twitter-share-button').length || (0, _jquery2.default)('.js-twitter-custom-share').length) {
      _jquery2.default.getScript('//platform.twitter.com/widgets.js', TwitterUtils.handleTwitterLoad);
    } else {
      TwitterUtils.basicTwitterIntentSupport();
    }
  },
  handleSocialSharePhoto: function handleSocialSharePhoto(e) {
    var $currentTarget = (0, _jquery2.default)(e.currentTarget);
    var network = $currentTarget.attr('data-network');
    var $wrapper = $currentTarget.parents('.js-sharing-wrapper');

    var imageToShare = $wrapper.attr('data-image-to-share');
    var imageThumb = $wrapper.attr('data-image-thumbnail');
    var contentType = $wrapper.attr('data-content-type');
    var objectId = $wrapper.attr('data-object-id');
    var campaign = $wrapper.attr('data-campaign');
    var trackingContent = $wrapper.attr('data-tracking-content');
    var shareLocation = $wrapper.attr('data-share-location');

    var utmParams = {
      utm_medium: 'onsite',
      utm_source: network,
      utm_campaign: campaign,
      utm_content: trackingContent
    };
    var urlToShare = $wrapper.attr('data-url-to-share') + '?' + _jquery2.default.param(utmParams);

    if (network === 'facebook') {
      // Show FB share modal
      var facebookShareFormRendered = _Mustache2.default.template('new_design/social/facebook_share_form').render({
        imageToShare: imageToShare,
        urlToShare: urlToShare,
        imageThumb: imageThumb,
        contentType: contentType,
        objectId: objectId,
        shareLocation: shareLocation,
        signinUrl: _Rover2.default.urls.signin
      });

      (0, _jquery2.default)('.js-share-photo-to-facebook-form-content').html(facebookShareFormRendered);
      (0, _jquery2.default)('.js-facebook-share-modal').modal('show');
    } else if (network === 'pinterest') {
      var popupWidth = 750;
      var popupHeight = 331;
      var left = screen.width / 2 - popupWidth / 2;
      var top = screen.height / 2 - popupHeight / 2;
      var popupOptions = 'top=' + top + ',left=' + left + ',height=' + popupHeight + ',width=' + popupWidth + ',toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no';

      var pinterestUrl = _Mustache2.default.template('new_design/social/pinterest_share_link').render({
        url: encodeURIComponent(urlToShare),
        imageUrl: encodeURIComponent(imageToShare)
      });

      window.open(pinterestUrl, 'Share on Pinterest!', popupOptions);
    }
  }
};

exports.FacebookUtils = FacebookUtils;
exports.SocialUtils = SocialUtils;

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_date_spec_view = __webpack_require__(579);

var _service_date_spec_view2 = _interopRequireDefault(_service_date_spec_view);

var _service_num_units_view = __webpack_require__(1264);

var _service_num_units_view2 = _interopRequireDefault(_service_num_units_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service_date_spec_view2.default.extend({
  initialize: function initialize(options) {
    _service_date_spec_view2.default.prototype.initialize.call(this, options);
    if (this.service.supports_num_units_per_day()) {
      this.numUnitsView = this.createNumUnitsView();
    } else {
      this.numUnitsView = null;
    }
  },
  createNumUnitsView: function createNumUnitsView() {
    var view = new _service_num_units_view2.default({
      label: this.service.num_units_label(),
      desc: this.service.num_units_description()
    });

    this.propagateDatesChanged(view.model, 'change');
    return view;
  },
  getNumUnits: function getNumUnits() {
    if (this.numUnitsView) return this.numUnitsView.model.get('num_units');
    return 1;
  }
});

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _num_units_support_view = __webpack_require__(650);

var _num_units_support_view2 = _interopRequireDefault(_num_units_support_view);

var _service_date_spec_view = __webpack_require__(579);

var _service_date_spec_view2 = _interopRequireDefault(_service_date_spec_view);

var _recurring_dates_model = __webpack_require__(1269);

var _recurring_dates_model2 = _interopRequireDefault(_recurring_dates_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _num_units_support_view2.default.extend({
  template: Mustache.template('new_design/common/recurring_days'),
  bindings: {
    '.js-monday': 'monday',
    '.js-tuesday': 'tuesday',
    '.js-wednesday': 'wednesday',
    '.js-thursday': 'thursday',
    '.js-friday': 'friday',
    '.js-saturday': 'saturday',
    '.js-sunday': 'sunday',
    '.js-hidden-input': {
      observe: _service_date_spec_view2.default.prototype.DAYS,
      onGet: function onGet(values) {
        var total = _.filter(values, function (value) {
          return value;
        }).length;
        return total ? '1' : '';
      },

      updateModel: false
    }
  },
  initialize: function initialize(options) {
    _num_units_support_view2.default.prototype.initialize.call(this, options);
    var self = this;
    this.model = new _recurring_dates_model2.default();
    _.each(this.getDaysFromUrl(), function (day) {
      return self.model.set(day, true);
    });
    this.propagateDatesChanged(this.model, 'change');
    this.model.on('change', _.bind(this.onModelChange, this));
  },
  render: function render() {
    var ctx = _.extend(this.model.toJSON(), {
      slug: this.service.get('slug'),
      units: this.service.units(),
      supportsNumUnitsPerDay: this.numUnitsView !== null
    });

    this.$el.html(this.template.render(ctx));

    if (this.numUnitsView) {
      this.$('.js-recurring-num-units').append(this.numUnitsView.render().$el);
    }

    this.stickit();
    return this;
  },
  getDatesData: function getDatesData() {
    var numUnits = this.getNumUnits();
    var days = [];
    var self = this;

    _.each(this.DAYS, function (day) {
      if (self.model.get(day)) {
        days.push({ day: day, num_units: numUnits });
      }
    });

    if (!days.length) return {};
    return { days: days };
  },
  isRecurring: function isRecurring() {
    return true;
  },
  hasErrors: function hasErrors() {
    return this.$('.js-days-of-the-week').hasClass('has-error');
  },
  onModelChange: function onModelChange() {
    if (this.hasErrors()) {
      this.$('.js-hidden-input').valid();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Backbone.Model.extend({
  supports_num_units_per_day: function supports_num_units_per_day() {
    return this.get('service_type').supports_num_units_per_day;
  },
  supports_recurring_billing: function supports_recurring_billing() {
    return this.get('service_type').supports_recurring_billing;
  },
  is_end_date_exclusive: function is_end_date_exclusive() {
    return this.get('service_type').is_end_date_exclusive;
  },
  num_units_label: function num_units_label() {
    return 'How many ' + this.units() + ' per day?';
  },
  isHosting: function isHosting() {
    return this.get('service_type').location === 'provider_home';
  },
  isSDV: function isSDV() {
    return this.get('service_type').supports_service_delivery_verification;
  },
  units: function units() {
    if (this.get('slug') === 'doggy-day-care') return 'day care';
    return this.standard_rate_add_on().unit + 's';
  },
  num_units_description: function num_units_description() {
    return {
      singular: this.standard_rate_add_on().unit + ' per day',
      plural: this.units() + ' per day'
    };
  },
  standard_rate_add_on: function standard_rate_add_on() {
    var srao = {};

    _.each(this.get('service_add_ons'), function (o) {
      if (o.slug === 'standard-rate') {
        srao = o;
      }
    });

    return srao;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

/* =========================================================
 * bootstrap-slider.js v3.0.0
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

(function( $ ) {

    var ErrorMsgs = {
        formatInvalidInputErrorMsg : function(input) {
            return "Invalid input value '" + input + "' passed in";
        },
        callingContextNotSliderInstance : "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
    };

    var Slider = function(element, options) {
        var el = this.element = $(element).hide();
        var origWidth =  $(element)[0].style.width;

        var updateSlider = false;
        var parent = this.element.parent();


        if (parent.hasClass('slider') === true) {
            updateSlider = true;
            this.picker = parent;
        } else {
            this.picker = $('<div class="slider">'+
                                '<div class="slider-track">'+
                                    '<div class="slider-selection"></div>'+
                                    '<div class="slider-handle"></div>'+
                                    '<div class="slider-handle"></div>'+
                                '</div>'+
                                '<div id="tooltip" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
                                '<div id="tooltip_min" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
                                '<div id="tooltip_max" class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'+
                            '</div>')
                                .insertBefore(this.element)
                                .append(this.element);
        }

        this.id = this.element.data('slider-id')||options.id;
        if (this.id) {
            this.picker[0].id = this.id;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
            this.touchCapable = true;
        }

        var tooltip = this.element.data('slider-tooltip')||options.tooltip;

        this.tooltip = this.picker.find('#tooltip');
        this.tooltipInner = this.tooltip.find('div.tooltip-inner');

        this.tooltip_min = this.picker.find('#tooltip_min');
        this.tooltipInner_min = this.tooltip_min.find('div.tooltip-inner');

        this.tooltip_max = this.picker.find('#tooltip_max');
        this.tooltipInner_max= this.tooltip_max.find('div.tooltip-inner');

        if (updateSlider === true) {
            // Reset classes
            this.picker.removeClass('slider-horizontal');
            this.picker.removeClass('slider-vertical');
            this.tooltip.removeClass('hide');
            this.tooltip_min.removeClass('hide');
            this.tooltip_max.removeClass('hide');

        }

        this.orientation = this.element.data('slider-orientation')||options.orientation;
        switch(this.orientation) {
            case 'vertical':
                this.picker.addClass('slider-vertical');
                this.stylePos = 'top';
                this.mousePos = 'pageY';
                this.sizePos = 'offsetHeight';
                this.tooltip.addClass('right')[0].style.left = '100%';
                this.tooltip_min.addClass('right')[0].style.left = '100%';
                this.tooltip_max.addClass('right')[0].style.left = '100%';
                break;
            default:
                this.picker
                    .addClass('slider-horizontal')
                    .css('width', origWidth);
                this.orientation = 'horizontal';
                this.stylePos = 'left';
                this.mousePos = 'pageX';
                this.sizePos = 'offsetWidth';
                this.tooltip.addClass('top')[0].style.top = -this.tooltip.outerHeight() - 14 + 'px';
                this.tooltip_min.addClass('top')[0].style.top = -this.tooltip_min.outerHeight() - 14 + 'px';
                this.tooltip_max.addClass('top')[0].style.top = -this.tooltip_max.outerHeight() - 14 + 'px';
                break;
        }

        var self = this;
        $.each(['min',
                'max',
                'step',
                'precision',
                'value',
                'reversed',
                'handle'
            ], function(i, attr) {
                if (typeof el.data('slider-' + attr) !== 'undefined') {
                    self[attr] = el.data('slider-' + attr);
                } else if (typeof options[attr] !== 'undefined') {
                    self[attr] = options[attr];
                } else if (typeof el.prop(attr) !== 'undefined') {
                    self[attr] = el.prop(attr);
                } else {
                    self[attr] = 0; // to prevent empty string issues in calculations in IE
                }
        });

        if (this.value instanceof Array) {
            if (updateSlider && !this.range) {
                this.value = this.value[0];
            } else {
                this.range = true;
            }
        } else if (this.range) {
            // User wants a range, but value is not an array
            this.value = [this.value, this.max];
        }

        this.selection = this.element.data('slider-selection')||options.selection;
        this.selectionEl = this.picker.find('.slider-selection');
        if (this.selection === 'none') {
            this.selectionEl.addClass('hide');
        }

        this.selectionElStyle = this.selectionEl[0].style;

        this.handle1 = this.picker.find('.slider-handle:first');
        this.handle1Stype = this.handle1[0].style;

        this.handle2 = this.picker.find('.slider-handle:last');
        this.handle2Stype = this.handle2[0].style;

        if (updateSlider === true) {
            // Reset classes
            this.handle1.removeClass('round triangle');
            this.handle2.removeClass('round triangle hide');
        }

        switch(this.handle) {
            case 'round':
                this.handle1.addClass('round');
                this.handle2.addClass('round');
                break;
            case 'triangle':
                this.handle1.addClass('triangle');
                this.handle2.addClass('triangle');
                break;
        }

        this.offset = this.picker.offset();
        this.size = this.picker[0][this.sizePos];
        this.formater = options.formater;

        this.tooltip_separator = options.tooltip_separator;
        this.tooltip_split = options.tooltip_split;

        this.setValue(this.value);

        this.handle1.on({
            keydown: $.proxy(this.keydown, this, 0)
        });
        this.handle2.on({
            keydown: $.proxy(this.keydown, this, 1)
        });

        if (this.touchCapable) {
            // Touch: Bind touch events:
            this.picker.on({
                touchstart: $.proxy(this.mousedown, this)
            });
        }
        // Bind mouse events:
        this.picker.on({
            mousedown: $.proxy(this.mousedown, this)
        });

        if(tooltip === 'hide') {
            this.tooltip.addClass('hide');
            this.tooltip_min.addClass('hide');
            this.tooltip_max.addClass('hide');
        } else if(tooltip === 'always') {
            this.showTooltip();
            this.alwaysShowTooltip = true;
        } else {
            this.picker.on({
                mouseenter: $.proxy(this.showTooltip, this),
                mouseleave: $.proxy(this.hideTooltip, this)
            });
            this.handle1.on({
                focus: $.proxy(this.showTooltip, this),
                blur: $.proxy(this.hideTooltip, this)
            });
            this.handle2.on({
                focus: $.proxy(this.showTooltip, this),
                blur: $.proxy(this.hideTooltip, this)
            });
        }

        this.enabled = options.enabled &&
                        (this.element.data('slider-enabled') === undefined || this.element.data('slider-enabled') === true);
        if(this.enabled) {
            this.enable();
        } else {
            this.disable();
        }
    };

    Slider.prototype = {
        constructor: Slider,

        over: false,
        inDrag: false,

        showTooltip: function(){
            if (this.tooltip_split === false ){
                this.tooltip.addClass('in');
            } else {
                this.tooltip_min.addClass('in');
                this.tooltip_max.addClass('in');
            }

            this.over = true;
        },

        hideTooltip: function(){
            if (this.inDrag === false && this.alwaysShowTooltip !== true) {
                this.tooltip.removeClass('in');
                this.tooltip_min.removeClass('in');
                this.tooltip_max.removeClass('in');
            }
            this.over = false;
        },

        layout: function(){
            var positionPercentages;

            if(this.reversed) {
                positionPercentages = [ 100 - this.percentage[0], this.percentage[1] ];
            } else {
                positionPercentages = [ this.percentage[0], this.percentage[1] ];
            }

            this.handle1Stype[this.stylePos] = positionPercentages[0]+'%';
            this.handle2Stype[this.stylePos] = positionPercentages[1]+'%';

            if (this.orientation === 'vertical') {
                this.selectionElStyle.top = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
                this.selectionElStyle.height = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';
            } else {
                this.selectionElStyle.left = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
                this.selectionElStyle.width = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';

                var offset_min = this.tooltip_min[0].getBoundingClientRect();
                var offset_max = this.tooltip_max[0].getBoundingClientRect();

                if (offset_min.right > offset_max.left) {
                    this.tooltip_max.removeClass('top');
                    this.tooltip_max.addClass('bottom')[0].style.top = 18 + 'px';
                } else {
                    this.tooltip_max.removeClass('bottom');
                    this.tooltip_max.addClass('top')[0].style.top = -30 + 'px';
                }
            }

            if (this.range) {
                this.tooltipInner.text(
                    this.formater(this.value[0]) + this.tooltip_separator + this.formater(this.value[1])
                );
                this.tooltip[0].style[this.stylePos] = this.size * (positionPercentages[0] + (positionPercentages[1] - positionPercentages[0])/2)/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';

                this.tooltipInner_min.text(
                    this.formater(this.value[0])
                );
                this.tooltipInner_max.text(
                    this.formater(this.value[1])
                );

                this.tooltip_min[0].style[this.stylePos] = this.size * ( (positionPercentages[0])/100) - (this.orientation === 'vertical' ? this.tooltip_min.outerHeight()/2 : this.tooltip_min.outerWidth()/2) +'px';
                this.tooltip_max[0].style[this.stylePos] = this.size * ( (positionPercentages[1])/100) - (this.orientation === 'vertical' ? this.tooltip_max.outerHeight()/2 : this.tooltip_max.outerWidth()/2) +'px';

            } else {
                this.tooltipInner.text(
                    this.formater(this.value[0])
                );
                this.tooltip[0].style[this.stylePos] = this.size * positionPercentages[0]/100 - (this.orientation === 'vertical' ? this.tooltip.outerHeight()/2 : this.tooltip.outerWidth()/2) +'px';
            }
        },

        mousedown: function(ev) {
            if(!this.isEnabled()) {
                return false;
            }
            // Touch: Get the original event:
            if (this.touchCapable && ev.type === 'touchstart') {
                ev = ev.originalEvent;
            }

            this.triggerFocusOnHandle();

            this.offset = this.picker.offset();
            this.size = this.picker[0][this.sizePos];

            var percentage = this.getPercentage(ev);

            if (this.range) {
                var diff1 = Math.abs(this.percentage[0] - percentage);
                var diff2 = Math.abs(this.percentage[1] - percentage);
                this.dragged = (diff1 < diff2) ? 0 : 1;
            } else {
                this.dragged = 0;
            }

            this.percentage[this.dragged] = this.reversed ? 100 - percentage : percentage;
            this.layout();

            if (this.touchCapable) {
                // Touch: Bind touch events:
                $(document).on({
                    touchmove: $.proxy(this.mousemove, this),
                    touchend: $.proxy(this.mouseup, this)
                });
            }
            // Bind mouse events:
            $(document).on({
                mousemove: $.proxy(this.mousemove, this),
                mouseup: $.proxy(this.mouseup, this)
            });

            this.inDrag = true;
            var val = this.calculateValue();
            this.element.trigger({
                    type: 'slideStart',
                    value: val
                })
                .data('value', val)
                .prop('value', val);
            this.setValue(val);
            return true;
        },

        triggerFocusOnHandle: function(handleIdx) {
            if(handleIdx === 0) {
                this.handle1.focus();
            }
            if(handleIdx === 1) {
                this.handle2.focus();
            }
        },

        keydown: function(handleIdx, ev) {
            if(!this.isEnabled()) {
                return false;
            }

            var dir;
            switch (ev.which) {
                case 37: // left
                case 40: // down
                    dir = -1;
                    break;
                case 39: // right
                case 38: // up
                    dir = 1;
                    break;
            }
            if (!dir) {
                return;
            }

            var oneStepValuePercentageChange = dir * this.percentage[2];
            var percentage = this.percentage[handleIdx] + oneStepValuePercentageChange;

            if (percentage > 100) {
                percentage = 100;
            } else if (percentage < 0) {
                percentage = 0;
            }

            this.dragged = handleIdx;
            this.adjustPercentageForRangeSliders(percentage);
            this.percentage[this.dragged] = percentage;
            this.layout();

            var val = this.calculateValue();

            this.element.trigger({
                    type: 'slideStart',
                    value: val
                })
                .data('value', val)
                .prop('value', val);

            this.slide(val);

            this.element
                .trigger({
                    type: 'slideStop',
                    value: val
                })
                .data('value', val)
                .prop('value', val);
            return false;
        },

        mousemove: function(ev) {
            if(!this.isEnabled()) {
                return false;
            }
            // Touch: Get the original event:
            if (this.touchCapable && ev.type === 'touchmove') {
                ev = ev.originalEvent;
            }

            var percentage = this.getPercentage(ev);
            this.adjustPercentageForRangeSliders(percentage);
            this.percentage[this.dragged] = this.reversed ? 100 - percentage : percentage;
            this.layout();

            var val = this.calculateValue();
            this.slide(val);

            return false;
        },
        slide: function(val) {
            this.setValue(val);

            var slideEventValue = this.range ? this.value : this.value[0];
            this.element
                .trigger({
                    'type': 'slide',
                    'value': slideEventValue
                })
                .data('value', this.value)
                .prop('value', this.value);
        },
        adjustPercentageForRangeSliders: function(percentage) {
            if (this.range) {
                if (this.dragged === 0 && this.percentage[1] < percentage) {
                    this.percentage[0] = this.percentage[1];
                    this.dragged = 1;
                } else if (this.dragged === 1 && this.percentage[0] > percentage) {
                    this.percentage[1] = this.percentage[0];
                    this.dragged = 0;
                }
            }
        },

        mouseup: function() {
            if(!this.isEnabled()) {
                return false;
            }
            if (this.touchCapable) {
                // Touch: Unbind touch event handlers:
                $(document).off({
                    touchmove: this.mousemove,
                    touchend: this.mouseup
                });
            }
            // Unbind mouse event handlers:
            $(document).off({
                mousemove: this.mousemove,
                mouseup: this.mouseup
            });

            this.inDrag = false;
            if (this.over === false) {
                this.hideTooltip();
            }
            var val = this.calculateValue();
            this.layout();
            this.element
                .data('value', val)
                .prop('value', val)
                .trigger({
                    type: 'slideStop',
                    value: val
                });
            return false;
        },

        calculateValue: function() {
            var val;
            if (this.range) {
                val = [this.min,this.max];
                if (this.percentage[0] !== 0){
                    val[0] = (Math.max(this.min, this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step));
                    val[0] = this.applyPrecision(val[0]);
                }
                if (this.percentage[1] !== 100){
                    val[1] = (Math.min(this.max, this.min + Math.round((this.diff * this.percentage[1]/100)/this.step)*this.step));
                    val[1] = this.applyPrecision(val[1]);
                }
                this.value = val;
            } else {
                val = (this.min + Math.round((this.diff * this.percentage[0]/100)/this.step)*this.step);
                if (val < this.min) {
                    val = this.min;
                }
                else if (val > this.max) {
                    val = this.max;
                }
                val = parseFloat(val);
                val = this.applyPrecision(val);
                this.value = [val, this.value[1]];
            }
            return val;
        },
        applyPrecision: function(val) {
            var precision = this.precision || this.getNumDigitsAfterDecimalPlace(this.step);
            return this.applyToFixedAndParseFloat(val, precision);
        },
        /*
            Credits to Mike Samuel for the following method!
            Source: http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
        */
        getNumDigitsAfterDecimalPlace: function(num) {
            var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            if (!match) { return 0; }
            return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
        },

        applyToFixedAndParseFloat: function(num, toFixedInput) {
            var truncatedNum = num.toFixed(toFixedInput);
            return parseFloat(truncatedNum);
        },

        getPercentage: function(ev) {
            if (this.touchCapable && (ev.type === 'touchstart' || ev.type === 'touchmove')) {
                ev = ev.touches[0];
            }
            var percentage = (ev[this.mousePos] - this.offset[this.stylePos])*100/this.size;
            percentage = Math.round(percentage/this.percentage[2])*this.percentage[2];
            return Math.max(0, Math.min(100, percentage));
        },

        getValue: function() {
            if (this.range) {
                return this.value;
            }
            return this.value[0];
        },

        setValue: function(val) {
            if (!val) {
                val = 0;
            }
            this.value = this.validateInputValue(val);

            if (this.range) {
                this.value[0] = this.applyPrecision(this.value[0]);
                this.value[1] = this.applyPrecision(this.value[1]);

                this.value[0] = Math.max(this.min, Math.min(this.max, this.value[0]));
                this.value[1] = Math.max(this.min, Math.min(this.max, this.value[1]));
            } else {
                this.value = this.applyPrecision(this.value);
                this.value = [ Math.max(this.min, Math.min(this.max, this.value))];
                this.handle2.addClass('hide');
                if (this.selection === 'after') {
                    this.value[1] = this.max;
                } else {
                    this.value[1] = this.min;
                }
            }

            this.diff = this.max - this.min;
            if (this.diff > 0) {
                this.percentage = [
                    (this.value[0] - this.min) * 100 / this.diff,
                    (this.value[1] - this.min) * 100 / this.diff,
                    this.step * 100 / this.diff
                ];
            } else {
                this.percentage = [0, 0, 100];
            }

            this.layout();
        },

        validateInputValue : function(val) {
            if(typeof val === 'number') {
                return val;
            } else if(val instanceof Array) {
                $.each(val, function(i, input) { if (typeof input !== 'number') { throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(input) ); }});
                return val;
            } else {
                throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(val) );
            }
        },

        destroy: function(){
            this.handle1.off();
            this.handle2.off();
            this.element.off().show().insertBefore(this.picker);
            this.picker.off().remove();
            $(this.element).removeData('slider');
        },

        disable: function() {
            this.enabled = false;
            this.handle1.removeAttr("tabindex");
            this.handle2.removeAttr("tabindex");
            this.picker.addClass('slider-disabled');
            this.element.trigger('slideDisabled');
        },

        enable: function() {
            this.enabled = true;
            this.handle1.attr("tabindex", 0);
            this.handle2.attr("tabindex", 0);
            this.picker.removeClass('slider-disabled');
            this.element.trigger('slideEnabled');
        },

        toggle: function() {
            if(this.enabled) {
                this.disable();
            } else {
                this.enable();
            }
        },

        isEnabled: function() {
            return this.enabled;
        },

        setAttribute: function(attribute, value) {
            this[attribute] = value;
        },

        getAttribute: function(attribute) {
            return this[attribute];
        }

    };

    var publicMethods = {
        getValue : Slider.prototype.getValue,
        setValue : Slider.prototype.setValue,
        setAttribute : Slider.prototype.setAttribute,
        getAttribute : Slider.prototype.getAttribute,
        destroy : Slider.prototype.destroy,
        disable : Slider.prototype.disable,
        enable : Slider.prototype.enable,
        toggle : Slider.prototype.toggle,
        isEnabled: Slider.prototype.isEnabled
    };

    $.fn.slider = function (option) {
        if (typeof option === 'string' && option !== 'refresh') {
            var args = Array.prototype.slice.call(arguments, 1);
            return invokePublicMethod.call(this, option, args);
        } else {
            return createNewSliderInstance.call(this, option);
        }
    };

    function invokePublicMethod(methodName, args) {
        if(publicMethods[methodName]) {
            var sliderObject = retrieveSliderObjectFromElement(this);
            var result = publicMethods[methodName].apply(sliderObject, args);

            if (typeof result === "undefined") {
                return $(this);
            } else {
                return result;
            }
        } else {
            throw new Error("method '" + methodName + "()' does not exist for slider.");
        }
    }

    function retrieveSliderObjectFromElement(element) {
        var sliderObject = $(element).data('slider');
        if(sliderObject && sliderObject instanceof Slider) {
            return sliderObject;
        } else {
            throw new Error(ErrorMsgs.callingContextNotSliderInstance);
        }
    }

    function createNewSliderInstance(opts) {
        var $this = $(this);
        $this.each(function() {
            var $this = $(this),
                slider = $this.data('slider'),
                options = typeof opts === 'object' && opts;

            // If slider already exists, use its attributes
            // as options so slider refreshes properly
            if (slider && !options) {
                options = {};

                $.each($.fn.slider.defaults, function(key) {
                    options[key] = slider[key];
                });
            }

            $this.data('slider', (new Slider(this, $.extend({}, $.fn.slider.defaults, options))));
        });
        return $this;
    }

    $.fn.slider.defaults = {
        min: 0,
        max: 10,
        step: 1,
        precision: 0,
        orientation: 'horizontal',
        value: 5,
        range: false,
        selection: 'before',
        tooltip: 'show',
        tooltip_separator: ':',
        tooltip_split: false,
        handle: 'round',
        reversed : false,
        enabled: true,
        formater: function(value) {
            return value;
        }
    };

    $.fn.slider.Constructor = Slider;

})( window.jQuery );


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Bowser - a browser detector
  * https://github.com/ded/bowser
  * MIT License | (c) Dustin Diaz 2014
  */

!function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports['browser'] = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
}('bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , result

    if (/opera|opr/i.test(ua)) {
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/windows phone/i.test(ua)) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      , msie: t
      , version: getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (/sailfish/i.test(ua)) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (/silk/i.test(ua)) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
      , version: versionIdentifier
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/(web|hpw)os/i.test(ua)) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (/tizen/i.test(ua)) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/safari/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      , version: versionIdentifier
      }
    }
    else result = {}

    // set webkit or gecko flag for browsers based on these engines
    if (/(apple)?webkit/i.test(ua)) {
      result.name = result.name || "Webkit"
      result.webkit = t
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (android || result.silk) {
      result.android = t
    } else if (iosdevice) {
      result[iosdevice] = t
      result.ios = t
    }

    // OS version extraction
    var osVersion = '';
    if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (tablet || iosdevice == 'ipad' || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile))) || result.silk) {
      result.tablet = t
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || result.blackberry || result.webos || result.bada) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if ((result.msie && result.version >= 10) ||
        (result.chrome && result.version >= 20) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')


  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* Chosen v1.1.0 | (c) 2011-2013 by Harvest | MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md */
!function(){var a,AbstractChosen,Chosen,SelectParser,b,c={}.hasOwnProperty,d=function(a,b){function d(){this.constructor=a}for(var e in b)c.call(b,e)&&(a[e]=b[e]);return d.prototype=b.prototype,a.prototype=new d,a.__super__=b.prototype,a};SelectParser=function(){function SelectParser(){this.options_index=0,this.parsed=[]}return SelectParser.prototype.add_node=function(a){return"OPTGROUP"===a.nodeName.toUpperCase()?this.add_group(a):this.add_option(a)},SelectParser.prototype.add_group=function(a){var b,c,d,e,f,g;for(b=this.parsed.length,this.parsed.push({array_index:b,group:!0,label:this.escapeExpression(a.label),children:0,disabled:a.disabled}),f=a.childNodes,g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(this.add_option(c,b,a.disabled));return g},SelectParser.prototype.add_option=function(a,b,c){return"OPTION"===a.nodeName.toUpperCase()?(""!==a.text?(null!=b&&(this.parsed[b].children+=1),this.parsed.push({array_index:this.parsed.length,options_index:this.options_index,value:a.value,text:a.text,html:a.innerHTML,selected:a.selected,disabled:c===!0?c:a.disabled,group_array_index:b,classes:a.className,style:a.style.cssText})):this.parsed.push({array_index:this.parsed.length,options_index:this.options_index,empty:!0}),this.options_index+=1):void 0},SelectParser.prototype.escapeExpression=function(a){var b,c;return null==a||a===!1?"":/[\&\<\>\"\'\`]/.test(a)?(b={"<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},c=/&(?!\w+;)|[\<\>\"\'\`]/g,a.replace(c,function(a){return b[a]||"&amp;"})):a},SelectParser}(),SelectParser.select_to_array=function(a){var b,c,d,e,f;for(c=new SelectParser,f=a.childNodes,d=0,e=f.length;e>d;d++)b=f[d],c.add_node(b);return c.parsed},AbstractChosen=function(){function AbstractChosen(a,b){this.form_field=a,this.options=null!=b?b:{},AbstractChosen.browser_is_supported()&&(this.is_multiple=this.form_field.multiple,this.set_default_text(),this.set_default_values(),this.setup(),this.set_up_html(),this.register_observers())}return AbstractChosen.prototype.set_default_values=function(){var a=this;return this.click_test_action=function(b){return a.test_active_click(b)},this.activate_action=function(b){return a.activate_field(b)},this.active_field=!1,this.mouse_on_container=!1,this.results_showing=!1,this.result_highlighted=null,this.allow_single_deselect=null!=this.options.allow_single_deselect&&null!=this.form_field.options[0]&&""===this.form_field.options[0].text?this.options.allow_single_deselect:!1,this.disable_search_threshold=this.options.disable_search_threshold||0,this.disable_search=this.options.disable_search||!1,this.enable_split_word_search=null!=this.options.enable_split_word_search?this.options.enable_split_word_search:!0,this.group_search=null!=this.options.group_search?this.options.group_search:!0,this.search_contains=this.options.search_contains||!1,this.single_backstroke_delete=null!=this.options.single_backstroke_delete?this.options.single_backstroke_delete:!0,this.max_selected_options=this.options.max_selected_options||1/0,this.inherit_select_classes=this.options.inherit_select_classes||!1,this.display_selected_options=null!=this.options.display_selected_options?this.options.display_selected_options:!0,this.display_disabled_options=null!=this.options.display_disabled_options?this.options.display_disabled_options:!0},AbstractChosen.prototype.set_default_text=function(){return this.default_text=this.form_field.getAttribute("data-placeholder")?this.form_field.getAttribute("data-placeholder"):this.is_multiple?this.options.placeholder_text_multiple||this.options.placeholder_text||AbstractChosen.default_multiple_text:this.options.placeholder_text_single||this.options.placeholder_text||AbstractChosen.default_single_text,this.results_none_found=this.form_field.getAttribute("data-no_results_text")||this.options.no_results_text||AbstractChosen.default_no_result_text},AbstractChosen.prototype.mouse_enter=function(){return this.mouse_on_container=!0},AbstractChosen.prototype.mouse_leave=function(){return this.mouse_on_container=!1},AbstractChosen.prototype.input_focus=function(){var a=this;if(this.is_multiple){if(!this.active_field)return setTimeout(function(){return a.container_mousedown()},50)}else if(!this.active_field)return this.activate_field()},AbstractChosen.prototype.input_blur=function(){var a=this;return this.mouse_on_container?void 0:(this.active_field=!1,setTimeout(function(){return a.blur_test()},100))},AbstractChosen.prototype.results_option_build=function(a){var b,c,d,e,f;for(b="",f=this.results_data,d=0,e=f.length;e>d;d++)c=f[d],b+=c.group?this.result_add_group(c):this.result_add_option(c),(null!=a?a.first:void 0)&&(c.selected&&this.is_multiple?this.choice_build(c):c.selected&&!this.is_multiple&&this.single_set_selected_text(c.text));return b},AbstractChosen.prototype.result_add_option=function(a){var b,c;return a.search_match?this.include_option_in_results(a)?(b=[],a.disabled||a.selected&&this.is_multiple||b.push("active-result"),!a.disabled||a.selected&&this.is_multiple||b.push("disabled-result"),a.selected&&b.push("result-selected"),null!=a.group_array_index&&b.push("group-option"),""!==a.classes&&b.push(a.classes),c=document.createElement("li"),c.className=b.join(" "),c.style.cssText=a.style,c.setAttribute("data-option-array-index",a.array_index),c.innerHTML=a.search_text,this.outerHTML(c)):"":""},AbstractChosen.prototype.result_add_group=function(a){var b;return a.search_match||a.group_match?a.active_options>0?(b=document.createElement("li"),b.className="group-result",b.innerHTML=a.search_text,this.outerHTML(b)):"":""},AbstractChosen.prototype.results_update_field=function(){return this.set_default_text(),this.is_multiple||this.results_reset_cleanup(),this.result_clear_highlight(),this.results_build(),this.results_showing?this.winnow_results():void 0},AbstractChosen.prototype.reset_single_select_options=function(){var a,b,c,d,e;for(d=this.results_data,e=[],b=0,c=d.length;c>b;b++)a=d[b],a.selected?e.push(a.selected=!1):e.push(void 0);return e},AbstractChosen.prototype.results_toggle=function(){return this.results_showing?this.results_hide():this.results_show()},AbstractChosen.prototype.results_search=function(){return this.results_showing?this.winnow_results():this.results_show()},AbstractChosen.prototype.winnow_results=function(){var a,b,c,d,e,f,g,h,i,j,k,l,m;for(this.no_results_clear(),e=0,g=this.get_search_text(),a=g.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&"),d=this.search_contains?"":"^",c=new RegExp(d+a,"i"),j=new RegExp(a,"i"),m=this.results_data,k=0,l=m.length;l>k;k++)b=m[k],b.search_match=!1,f=null,this.include_option_in_results(b)&&(b.group&&(b.group_match=!1,b.active_options=0),null!=b.group_array_index&&this.results_data[b.group_array_index]&&(f=this.results_data[b.group_array_index],0===f.active_options&&f.search_match&&(e+=1),f.active_options+=1),(!b.group||this.group_search)&&(b.search_text=b.group?b.label:b.html,b.search_match=this.search_string_match(b.search_text,c),b.search_match&&!b.group&&(e+=1),b.search_match?(g.length&&(h=b.search_text.search(j),i=b.search_text.substr(0,h+g.length)+"</em>"+b.search_text.substr(h+g.length),b.search_text=i.substr(0,h)+"<em>"+i.substr(h)),null!=f&&(f.group_match=!0)):null!=b.group_array_index&&this.results_data[b.group_array_index].search_match&&(b.search_match=!0)));return this.result_clear_highlight(),1>e&&g.length?(this.update_results_content(""),this.no_results(g)):(this.update_results_content(this.results_option_build()),this.winnow_results_set_highlight())},AbstractChosen.prototype.search_string_match=function(a,b){var c,d,e,f;if(b.test(a))return!0;if(this.enable_split_word_search&&(a.indexOf(" ")>=0||0===a.indexOf("["))&&(d=a.replace(/\[|\]/g,"").split(" "),d.length))for(e=0,f=d.length;f>e;e++)if(c=d[e],b.test(c))return!0},AbstractChosen.prototype.choices_count=function(){var a,b,c,d;if(null!=this.selected_option_count)return this.selected_option_count;for(this.selected_option_count=0,d=this.form_field.options,b=0,c=d.length;c>b;b++)a=d[b],a.selected&&(this.selected_option_count+=1);return this.selected_option_count},AbstractChosen.prototype.choices_click=function(a){return a.preventDefault(),this.results_showing||this.is_disabled?void 0:this.results_show()},AbstractChosen.prototype.keyup_checker=function(a){var b,c;switch(b=null!=(c=a.which)?c:a.keyCode,this.search_field_scale(),b){case 8:if(this.is_multiple&&this.backstroke_length<1&&this.choices_count()>0)return this.keydown_backstroke();if(!this.pending_backstroke)return this.result_clear_highlight(),this.results_search();break;case 13:if(a.preventDefault(),this.results_showing)return this.result_select(a);break;case 27:return this.results_showing&&this.results_hide(),!0;case 9:case 38:case 40:case 16:case 91:case 17:break;default:return this.results_search()}},AbstractChosen.prototype.clipboard_event_checker=function(){var a=this;return setTimeout(function(){return a.results_search()},50)},AbstractChosen.prototype.container_width=function(){return null!=this.options.width?this.options.width:""+this.form_field.offsetWidth+"px"},AbstractChosen.prototype.include_option_in_results=function(a){return this.is_multiple&&!this.display_selected_options&&a.selected?!1:!this.display_disabled_options&&a.disabled?!1:a.empty?!1:!0},AbstractChosen.prototype.search_results_touchstart=function(a){return this.touch_started=!0,this.search_results_mouseover(a)},AbstractChosen.prototype.search_results_touchmove=function(a){return this.touch_started=!1,this.search_results_mouseout(a)},AbstractChosen.prototype.search_results_touchend=function(a){return this.touch_started?this.search_results_mouseup(a):void 0},AbstractChosen.prototype.outerHTML=function(a){var b;return a.outerHTML?a.outerHTML:(b=document.createElement("div"),b.appendChild(a),b.innerHTML)},AbstractChosen.browser_is_supported=function(){return"Microsoft Internet Explorer"===window.navigator.appName?document.documentMode>=8:/iP(od|hone)/i.test(window.navigator.userAgent)?!1:/Android/i.test(window.navigator.userAgent)&&/Mobile/i.test(window.navigator.userAgent)?!1:!0},AbstractChosen.default_multiple_text="Select Some Options",AbstractChosen.default_single_text="Select an Option",AbstractChosen.default_no_result_text="No results match",AbstractChosen}(),a=jQuery,a.fn.extend({chosen:function(b){return AbstractChosen.browser_is_supported()?this.each(function(){var c,d;c=a(this),d=c.data("chosen"),"destroy"===b&&d?d.destroy():d||c.data("chosen",new Chosen(this,b))}):this}}),Chosen=function(c){function Chosen(){return b=Chosen.__super__.constructor.apply(this,arguments)}return d(Chosen,c),Chosen.prototype.setup=function(){return this.form_field_jq=a(this.form_field),this.current_selectedIndex=this.form_field.selectedIndex,this.is_rtl=this.form_field_jq.hasClass("chosen-rtl")},Chosen.prototype.set_up_html=function(){var b,c;return b=["chosen-container"],b.push("chosen-container-"+(this.is_multiple?"multi":"single")),this.inherit_select_classes&&this.form_field.className&&b.push(this.form_field.className),this.is_rtl&&b.push("chosen-rtl"),c={"class":b.join(" "),style:"width: "+this.container_width()+";",title:this.form_field.title},this.form_field.id.length&&(c.id=this.form_field.id.replace(/[^\w]/g,"_")+"_chosen"),this.container=a("<div />",c),this.is_multiple?this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="'+this.default_text+'" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>'):this.container.html('<a class="chosen-single chosen-default" tabindex="-1"><span>'+this.default_text+'</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>'),this.form_field_jq.hide().after(this.container),this.dropdown=this.container.find("div.chosen-drop").first(),this.search_field=this.container.find("input").first(),this.search_results=this.container.find("ul.chosen-results").first(),this.search_field_scale(),this.search_no_results=this.container.find("li.no-results").first(),this.is_multiple?(this.search_choices=this.container.find("ul.chosen-choices").first(),this.search_container=this.container.find("li.search-field").first()):(this.search_container=this.container.find("div.chosen-search").first(),this.selected_item=this.container.find(".chosen-single").first()),this.results_build(),this.set_tab_index(),this.set_label_behavior(),this.form_field_jq.trigger("chosen:ready",{chosen:this})},Chosen.prototype.register_observers=function(){var a=this;return this.container.bind("mousedown.chosen",function(b){a.container_mousedown(b)}),this.container.bind("mouseup.chosen",function(b){a.container_mouseup(b)}),this.container.bind("mouseenter.chosen",function(b){a.mouse_enter(b)}),this.container.bind("mouseleave.chosen",function(b){a.mouse_leave(b)}),this.search_results.bind("mouseup.chosen",function(b){a.search_results_mouseup(b)}),this.search_results.bind("mouseover.chosen",function(b){a.search_results_mouseover(b)}),this.search_results.bind("mouseout.chosen",function(b){a.search_results_mouseout(b)}),this.search_results.bind("mousewheel.chosen DOMMouseScroll.chosen",function(b){a.search_results_mousewheel(b)}),this.search_results.bind("touchstart.chosen",function(b){a.search_results_touchstart(b)}),this.search_results.bind("touchmove.chosen",function(b){a.search_results_touchmove(b)}),this.search_results.bind("touchend.chosen",function(b){a.search_results_touchend(b)}),this.form_field_jq.bind("chosen:updated.chosen",function(b){a.results_update_field(b)}),this.form_field_jq.bind("chosen:activate.chosen",function(b){a.activate_field(b)}),this.form_field_jq.bind("chosen:open.chosen",function(b){a.container_mousedown(b)}),this.form_field_jq.bind("chosen:close.chosen",function(b){a.input_blur(b)}),this.search_field.bind("blur.chosen",function(b){a.input_blur(b)}),this.search_field.bind("keyup.chosen",function(b){a.keyup_checker(b)}),this.search_field.bind("keydown.chosen",function(b){a.keydown_checker(b)}),this.search_field.bind("focus.chosen",function(b){a.input_focus(b)}),this.search_field.bind("cut.chosen",function(b){a.clipboard_event_checker(b)}),this.search_field.bind("paste.chosen",function(b){a.clipboard_event_checker(b)}),this.is_multiple?this.search_choices.bind("click.chosen",function(b){a.choices_click(b)}):this.container.bind("click.chosen",function(a){a.preventDefault()})},Chosen.prototype.destroy=function(){return a(this.container[0].ownerDocument).unbind("click.chosen",this.click_test_action),this.search_field[0].tabIndex&&(this.form_field_jq[0].tabIndex=this.search_field[0].tabIndex),this.container.remove(),this.form_field_jq.removeData("chosen"),this.form_field_jq.show()},Chosen.prototype.search_field_disabled=function(){return this.is_disabled=this.form_field_jq[0].disabled,this.is_disabled?(this.container.addClass("chosen-disabled"),this.search_field[0].disabled=!0,this.is_multiple||this.selected_item.unbind("focus.chosen",this.activate_action),this.close_field()):(this.container.removeClass("chosen-disabled"),this.search_field[0].disabled=!1,this.is_multiple?void 0:this.selected_item.bind("focus.chosen",this.activate_action))},Chosen.prototype.container_mousedown=function(b){return this.is_disabled||(b&&"mousedown"===b.type&&!this.results_showing&&b.preventDefault(),null!=b&&a(b.target).hasClass("search-choice-close"))?void 0:(this.active_field?this.is_multiple||!b||a(b.target)[0]!==this.selected_item[0]&&!a(b.target).parents("a.chosen-single").length||(b.preventDefault(),this.results_toggle()):(this.is_multiple&&this.search_field.val(""),a(this.container[0].ownerDocument).bind("click.chosen",this.click_test_action),this.results_show()),this.activate_field())},Chosen.prototype.container_mouseup=function(a){return"ABBR"!==a.target.nodeName||this.is_disabled?void 0:this.results_reset(a)},Chosen.prototype.search_results_mousewheel=function(a){var b;return a.originalEvent&&(b=-a.originalEvent.wheelDelta||a.originalEvent.detail),null!=b?(a.preventDefault(),"DOMMouseScroll"===a.type&&(b=40*b),this.search_results.scrollTop(b+this.search_results.scrollTop())):void 0},Chosen.prototype.blur_test=function(){return!this.active_field&&this.container.hasClass("chosen-container-active")?this.close_field():void 0},Chosen.prototype.close_field=function(){return a(this.container[0].ownerDocument).unbind("click.chosen",this.click_test_action),this.active_field=!1,this.results_hide(),this.container.removeClass("chosen-container-active"),this.clear_backstroke(),this.show_search_field_default(),this.search_field_scale()},Chosen.prototype.activate_field=function(){return this.container.addClass("chosen-container-active"),this.active_field=!0,this.search_field.val(this.search_field.val()),this.search_field.focus()},Chosen.prototype.test_active_click=function(b){var c;return c=a(b.target).closest(".chosen-container"),c.length&&this.container[0]===c[0]?this.active_field=!0:this.close_field()},Chosen.prototype.results_build=function(){return this.parsing=!0,this.selected_option_count=null,this.results_data=SelectParser.select_to_array(this.form_field),this.is_multiple?this.search_choices.find("li.search-choice").remove():this.is_multiple||(this.single_set_selected_text(),this.disable_search||this.form_field.options.length<=this.disable_search_threshold?(this.search_field[0].readOnly=!0,this.container.addClass("chosen-container-single-nosearch")):(this.search_field[0].readOnly=!1,this.container.removeClass("chosen-container-single-nosearch"))),this.update_results_content(this.results_option_build({first:!0})),this.search_field_disabled(),this.show_search_field_default(),this.search_field_scale(),this.parsing=!1},Chosen.prototype.result_do_highlight=function(a){var b,c,d,e,f;if(a.length){if(this.result_clear_highlight(),this.result_highlight=a,this.result_highlight.addClass("highlighted"),d=parseInt(this.search_results.css("maxHeight"),10),f=this.search_results.scrollTop(),e=d+f,c=this.result_highlight.position().top+this.search_results.scrollTop(),b=c+this.result_highlight.outerHeight(),b>=e)return this.search_results.scrollTop(b-d>0?b-d:0);if(f>c)return this.search_results.scrollTop(c)}},Chosen.prototype.result_clear_highlight=function(){return this.result_highlight&&this.result_highlight.removeClass("highlighted"),this.result_highlight=null},Chosen.prototype.results_show=function(){return this.is_multiple&&this.max_selected_options<=this.choices_count()?(this.form_field_jq.trigger("chosen:maxselected",{chosen:this}),!1):(this.container.addClass("chosen-with-drop"),this.results_showing=!0,this.search_field.focus(),this.search_field.val(this.search_field.val()),this.winnow_results(),this.form_field_jq.trigger("chosen:showing_dropdown",{chosen:this}))},Chosen.prototype.update_results_content=function(a){return this.search_results.html(a)},Chosen.prototype.results_hide=function(){return this.results_showing&&(this.result_clear_highlight(),this.container.removeClass("chosen-with-drop"),this.form_field_jq.trigger("chosen:hiding_dropdown",{chosen:this})),this.results_showing=!1},Chosen.prototype.set_tab_index=function(){var a;return this.form_field.tabIndex?(a=this.form_field.tabIndex,this.form_field.tabIndex=-1,this.search_field[0].tabIndex=a):void 0},Chosen.prototype.set_label_behavior=function(){var b=this;return this.form_field_label=this.form_field_jq.parents("label"),!this.form_field_label.length&&this.form_field.id.length&&(this.form_field_label=a("label[for='"+this.form_field.id+"']")),this.form_field_label.length>0?this.form_field_label.bind("click.chosen",function(a){return b.is_multiple?b.container_mousedown(a):b.activate_field()}):void 0},Chosen.prototype.show_search_field_default=function(){return this.is_multiple&&this.choices_count()<1&&!this.active_field?(this.search_field.val(this.default_text),this.search_field.addClass("default")):(this.search_field.val(""),this.search_field.removeClass("default"))},Chosen.prototype.search_results_mouseup=function(b){var c;return c=a(b.target).hasClass("active-result")?a(b.target):a(b.target).parents(".active-result").first(),c.length?(this.result_highlight=c,this.result_select(b),this.search_field.focus()):void 0},Chosen.prototype.search_results_mouseover=function(b){var c;return c=a(b.target).hasClass("active-result")?a(b.target):a(b.target).parents(".active-result").first(),c?this.result_do_highlight(c):void 0},Chosen.prototype.search_results_mouseout=function(b){return a(b.target).hasClass("active-result")?this.result_clear_highlight():void 0},Chosen.prototype.choice_build=function(b){var c,d,e=this;return c=a("<li />",{"class":"search-choice"}).html("<span>"+b.html+"</span>"),b.disabled?c.addClass("search-choice-disabled"):(d=a("<a />",{"class":"search-choice-close","data-option-array-index":b.array_index}),d.bind("click.chosen",function(a){return e.choice_destroy_link_click(a)}),c.append(d)),this.search_container.before(c)},Chosen.prototype.choice_destroy_link_click=function(b){return b.preventDefault(),b.stopPropagation(),this.is_disabled?void 0:this.choice_destroy(a(b.target))},Chosen.prototype.choice_destroy=function(a){return this.result_deselect(a[0].getAttribute("data-option-array-index"))?(this.show_search_field_default(),this.is_multiple&&this.choices_count()>0&&this.search_field.val().length<1&&this.results_hide(),a.parents("li").first().remove(),this.search_field_scale()):void 0},Chosen.prototype.results_reset=function(){return this.reset_single_select_options(),this.form_field.options[0].selected=!0,this.single_set_selected_text(),this.show_search_field_default(),this.results_reset_cleanup(),this.form_field_jq.trigger("change"),this.active_field?this.results_hide():void 0},Chosen.prototype.results_reset_cleanup=function(){return this.current_selectedIndex=this.form_field.selectedIndex,this.selected_item.find("abbr").remove()},Chosen.prototype.result_select=function(a){var b,c;return this.result_highlight?(b=this.result_highlight,this.result_clear_highlight(),this.is_multiple&&this.max_selected_options<=this.choices_count()?(this.form_field_jq.trigger("chosen:maxselected",{chosen:this}),!1):(this.is_multiple?b.removeClass("active-result"):this.reset_single_select_options(),c=this.results_data[b[0].getAttribute("data-option-array-index")],c.selected=!0,this.form_field.options[c.options_index].selected=!0,this.selected_option_count=null,this.is_multiple?this.choice_build(c):this.single_set_selected_text(c.text),(a.metaKey||a.ctrlKey)&&this.is_multiple||this.results_hide(),this.search_field.val(""),(this.is_multiple||this.form_field.selectedIndex!==this.current_selectedIndex)&&this.form_field_jq.trigger("change",{selected:this.form_field.options[c.options_index].value}),this.current_selectedIndex=this.form_field.selectedIndex,this.search_field_scale())):void 0},Chosen.prototype.single_set_selected_text=function(a){return null==a&&(a=this.default_text),a===this.default_text?this.selected_item.addClass("chosen-default"):(this.single_deselect_control_build(),this.selected_item.removeClass("chosen-default")),this.selected_item.find("span").text(a)},Chosen.prototype.result_deselect=function(a){var b;return b=this.results_data[a],this.form_field.options[b.options_index].disabled?!1:(b.selected=!1,this.form_field.options[b.options_index].selected=!1,this.selected_option_count=null,this.result_clear_highlight(),this.results_showing&&this.winnow_results(),this.form_field_jq.trigger("change",{deselected:this.form_field.options[b.options_index].value}),this.search_field_scale(),!0)},Chosen.prototype.single_deselect_control_build=function(){return this.allow_single_deselect?(this.selected_item.find("abbr").length||this.selected_item.find("span").first().after('<abbr class="search-choice-close"></abbr>'),this.selected_item.addClass("chosen-single-with-deselect")):void 0},Chosen.prototype.get_search_text=function(){return this.search_field.val()===this.default_text?"":a("<div/>").text(a.trim(this.search_field.val())).html()},Chosen.prototype.winnow_results_set_highlight=function(){var a,b;return b=this.is_multiple?[]:this.search_results.find(".result-selected.active-result"),a=b.length?b.first():this.search_results.find(".active-result").first(),null!=a?this.result_do_highlight(a):void 0},Chosen.prototype.no_results=function(b){var c;return c=a('<li class="no-results">'+this.results_none_found+' "<span></span>"</li>'),c.find("span").first().html(b),this.search_results.append(c),this.form_field_jq.trigger("chosen:no_results",{chosen:this})},Chosen.prototype.no_results_clear=function(){return this.search_results.find(".no-results").remove()},Chosen.prototype.keydown_arrow=function(){var a;return this.results_showing&&this.result_highlight?(a=this.result_highlight.nextAll("li.active-result").first())?this.result_do_highlight(a):void 0:this.results_show()},Chosen.prototype.keyup_arrow=function(){var a;return this.results_showing||this.is_multiple?this.result_highlight?(a=this.result_highlight.prevAll("li.active-result"),a.length?this.result_do_highlight(a.first()):(this.choices_count()>0&&this.results_hide(),this.result_clear_highlight())):void 0:this.results_show()},Chosen.prototype.keydown_backstroke=function(){var a;return this.pending_backstroke?(this.choice_destroy(this.pending_backstroke.find("a").first()),this.clear_backstroke()):(a=this.search_container.siblings("li.search-choice").last(),a.length&&!a.hasClass("search-choice-disabled")?(this.pending_backstroke=a,this.single_backstroke_delete?this.keydown_backstroke():this.pending_backstroke.addClass("search-choice-focus")):void 0)},Chosen.prototype.clear_backstroke=function(){return this.pending_backstroke&&this.pending_backstroke.removeClass("search-choice-focus"),this.pending_backstroke=null},Chosen.prototype.keydown_checker=function(a){var b,c;switch(b=null!=(c=a.which)?c:a.keyCode,this.search_field_scale(),8!==b&&this.pending_backstroke&&this.clear_backstroke(),b){case 8:this.backstroke_length=this.search_field.val().length;break;case 9:this.results_showing&&!this.is_multiple&&this.result_select(a),this.mouse_on_container=!1;break;case 13:a.preventDefault();break;case 38:a.preventDefault(),this.keyup_arrow();break;case 40:a.preventDefault(),this.keydown_arrow()}},Chosen.prototype.search_field_scale=function(){var b,c,d,e,f,g,h,i,j;if(this.is_multiple){for(d=0,h=0,f="position:absolute; left: -1000px; top: -1000px; display:none;",g=["font-size","font-style","font-weight","font-family","line-height","text-transform","letter-spacing"],i=0,j=g.length;j>i;i++)e=g[i],f+=e+":"+this.search_field.css(e)+";";return b=a("<div />",{style:f}),b.text(this.search_field.val()),a("body").append(b),h=b.width()+25,b.remove(),c=this.container.outerWidth(),h>c-10&&(h=c-10),this.search_field.css({width:h+"px"})}},Chosen}(AbstractChosen)}.call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jQuery Raty - A Star Rating Plugin
 *
 * The MIT License
 *
 * @author  : Washington Botelho
 * @doc     : http://wbotelhos.com/raty
 * @version : 2.7.0
 *
 */

;
(function($) {
  'use strict';

  var methods = {
    init: function(options) {
      return this.each(function() {
        this.self = $(this);

        methods.destroy.call(this.self);

        this.opt = $.extend(true, {}, $.fn.raty.defaults, options);

        methods._adjustCallback.call(this);
        methods._adjustNumber.call(this);
        methods._adjustHints.call(this);

        this.opt.score = methods._adjustedScore.call(this, this.opt.score);

        if (this.opt.starType !== 'img') {
          methods._adjustStarType.call(this);
        }

        methods._adjustPath.call(this);
        methods._createStars.call(this);

        if (this.opt.cancel) {
          methods._createCancel.call(this);
        }

        if (this.opt.precision) {
          methods._adjustPrecision.call(this);
        }

        methods._createScore.call(this);
        methods._apply.call(this, this.opt.score);
        methods._setTitle.call(this, this.opt.score);
        methods._target.call(this, this.opt.score);

        if (this.opt.readOnly) {
          methods._lock.call(this);
        } else {
          this.style.cursor = 'pointer';

          methods._binds.call(this);
        }
      });
    },

    _adjustCallback: function() {
      var options = ['number', 'readOnly', 'score', 'scoreName', 'target'];

      for (var i = 0; i < options.length; i++) {
        if (typeof this.opt[options[i]] === 'function') {
          this.opt[options[i]] = this.opt[options[i]].call(this);
        }
      }
    },

    _adjustedScore: function(score) {
      if (!score) {
        return score;
      }

      return methods._between(score, 0, this.opt.number);
    },

    _adjustHints: function() {
      if (!this.opt.hints) {
        this.opt.hints = [];
      }

      if (!this.opt.halfShow && !this.opt.half) {
        return;
      }

      var steps = this.opt.precision ? 10 : 2;

      for (var i = 0; i < this.opt.number; i++) {
        var group = this.opt.hints[i];

        if (Object.prototype.toString.call(group) !== '[object Array]') {
          group = [group];
        }

        this.opt.hints[i] = [];

        for (var j = 0; j < steps; j++) {
          var
            hint = group[j],
            last = group[group.length - 1];

          if (last === undefined) {
            last = null;
          }

          this.opt.hints[i][j] = hint === undefined ? last : hint;
        }
      }
    },

    _adjustNumber: function() {
      this.opt.number = methods._between(this.opt.number, 1, this.opt.numberMax);
    },

    _adjustPath: function() {
      this.opt.path = this.opt.path || '';

      if (this.opt.path && this.opt.path.charAt(this.opt.path.length - 1) !== '/') {
        this.opt.path += '/';
      }
    },

    _adjustPrecision: function() {
      this.opt.half = true;
    },

    _adjustStarType: function() {
      var replaces = ['cancelOff', 'cancelOn', 'starHalf', 'starOff', 'starOn'];

      this.opt.path = '';

      for (var i = 0; i < replaces.length; i++) {
        this.opt[replaces[i]] = this.opt[replaces[i]].replace('.', '-');
      }
    },

    _apply: function(score) {
      methods._fill.call(this, score);

      if (score) {
        if (score > 0) {
          this.score.val(score);
        }

        methods._roundStars.call(this, score);
      }
    },

    _between: function(value, min, max) {
      return Math.min(Math.max(parseFloat(value), min), max);
    },

    _binds: function() {
      if (this.cancel) {
        methods._bindOverCancel.call(this);
        methods._bindClickCancel.call(this);
        methods._bindOutCancel.call(this);
      }

      methods._bindOver.call(this);
      methods._bindClick.call(this);
      methods._bindOut.call(this);
    },

    _bindClick: function() {
      var that = this;

      that.stars.on('click.raty', function(evt) {
        var
          execute = true,
          score   = (that.opt.half || that.opt.precision) ? that.self.data('score') : (this.alt || $(this).data('alt'));

        if (that.opt.click) {
          execute = that.opt.click.call(that, +score, evt);
        }

        if (execute || execute === undefined) {
          if (that.opt.half && !that.opt.precision) {
            score = methods._roundHalfScore.call(that, score);
          }

          methods._apply.call(that, score);
        }
      });
    },

    _bindClickCancel: function() {
      var that = this;

      that.cancel.on('click.raty', function(evt) {
        that.score.removeAttr('value');

        if (that.opt.click) {
          that.opt.click.call(that, null, evt);
        }
      });
    },

    _bindOut: function() {
      var that = this;

      that.self.on('mouseleave.raty', function(evt) {
        var score = +that.score.val() || undefined;

        methods._apply.call(that, score);
        methods._target.call(that, score, evt);
        methods._resetTitle.call(that);

        if (that.opt.mouseout) {
          that.opt.mouseout.call(that, score, evt);
        }
      });
    },

    _bindOutCancel: function() {
      var that = this;

      that.cancel.on('mouseleave.raty', function(evt) {
        var icon = that.opt.cancelOff;

        if (that.opt.starType !== 'img') {
          icon = that.opt.cancelClass + ' ' + icon;
        }

        methods._setIcon.call(that, this, icon);

        if (that.opt.mouseout) {
          var score = +that.score.val() || undefined;

          that.opt.mouseout.call(that, score, evt);
        }
      });
    },

    _bindOver: function() {
      var that   = this,
          action = that.opt.half ? 'mousemove.raty' : 'mouseover.raty';

      that.stars.on(action, function(evt) {
        var score = methods._getScoreByPosition.call(that, evt, this);

        methods._fill.call(that, score);

        if (that.opt.half) {
          methods._roundStars.call(that, score, evt);
          methods._setTitle.call(that, score, evt);

          that.self.data('score', score);
        }

        methods._target.call(that, score, evt);

        if (that.opt.mouseover) {
          that.opt.mouseover.call(that, score, evt);
        }
      });
    },

    _bindOverCancel: function() {
      var that = this;

      that.cancel.on('mouseover.raty', function(evt) {
        var
          starOff = that.opt.path + that.opt.starOff,
          icon    = that.opt.cancelOn;

        if (that.opt.starType === 'img') {
          that.stars.attr('src', starOff);
        } else {
          icon = that.opt.cancelClass + ' ' + icon;

          that.stars.attr('class', starOff);
        }

        methods._setIcon.call(that, this, icon);
        methods._target.call(that, null, evt);

        if (that.opt.mouseover) {
          that.opt.mouseover.call(that, null);
        }
      });
    },

    _buildScoreField: function() {
      return $('<input />', { name: this.opt.scoreName, type: 'hidden' }).appendTo(this);
    },

    _createCancel: function() {
      var icon   = this.opt.path + this.opt.cancelOff,
          cancel = $('<' + this.opt.starType + ' />', { title: this.opt.cancelHint, 'class': this.opt.cancelClass });

      if (this.opt.starType === 'img') {
        cancel.attr({ src: icon, alt: 'x' });
      } else {
        // TODO: use $.data
        cancel.attr('data-alt', 'x').addClass(icon);
      }

      if (this.opt.cancelPlace === 'left') {
        this.self.prepend('&#160;').prepend(cancel);
      } else {
        this.self.append('&#160;').append(cancel);
      }

      this.cancel = cancel;
    },

    _createScore: function() {
      var score = $(this.opt.targetScore);

      this.score = score.length ? score : methods._buildScoreField.call(this);
    },

    _createStars: function() {
      for (var i = 1; i <= this.opt.number; i++) {
        var
          name  = methods._nameForIndex.call(this, i),
          attrs = { alt: i, src: this.opt.path + this.opt[name] };

        if (this.opt.starType !== 'img') {
          attrs = { 'data-alt': i, 'class': attrs.src }; // TODO: use $.data.
        }

        attrs.title = methods._getHint.call(this, i);

        $('<' + this.opt.starType + ' />', attrs).appendTo(this);

        if (this.opt.space) {
          this.self.append(i < this.opt.number ? '&#160;' : '');
        }
      }

      this.stars = this.self.children(this.opt.starType);
    },

    _error: function(message) {
      $(this).text(message);

      $.error(message);
    },

    _fill: function(score) {
      var hash = 0;

      for (var i = 1; i <= this.stars.length; i++) {
        var
          icon,
          star   = this.stars[i - 1],
          turnOn = methods._turnOn.call(this, i, score);

        if (this.opt.iconRange && this.opt.iconRange.length > hash) {
          var irange = this.opt.iconRange[hash];

          icon = methods._getRangeIcon.call(this, irange, turnOn);

          if (i <= irange.range) {
            methods._setIcon.call(this, star, icon);
          }

          if (i === irange.range) {
            hash++;
          }
        } else {
          icon = this.opt[turnOn ? 'starOn' : 'starOff'];

          methods._setIcon.call(this, star, icon);
        }
      }
    },

    _getFirstDecimal: function(number) {
      var
        decimal = number.toString().split('.')[1],
        result  = 0;

      if (decimal) {
        result = parseInt(decimal.charAt(0), 10);

        if (decimal.slice(1, 5) === '9999') {
          result++;
        }
      }

      return result;
    },

    _getRangeIcon: function(irange, turnOn) {
      return turnOn ? irange.on || this.opt.starOn : irange.off || this.opt.starOff;
    },

    _getScoreByPosition: function(evt, icon) {
      var score = parseInt(icon.alt || icon.getAttribute('data-alt'), 10);

      if (this.opt.half) {
        var
          size    = methods._getWidth.call(this),
          percent = parseFloat((evt.pageX - $(icon).offset().left) / size);

        score = score - 1 + percent;
      }

      return score;
    },

    _getHint: function(score, evt) {
      if (score !== 0 && !score) {
        return this.opt.noRatedMsg;
      }

      var
        decimal = methods._getFirstDecimal.call(this, score),
        integer = Math.ceil(score),
        group   = this.opt.hints[(integer || 1) - 1],
        hint    = group,
        set     = !evt || this.move;

      if (this.opt.precision) {
        if (set) {
          decimal = decimal === 0 ? 9 : decimal - 1;
        }

        hint = group[decimal];
      } else if (this.opt.halfShow || this.opt.half) {
        decimal = set && decimal === 0 ? 1 : decimal > 5 ? 1 : 0;

        hint = group[decimal];
      }

      return hint === '' ? '' : hint || score;
    },

    _getWidth: function() {
      var width = this.stars[0].width || parseFloat(this.stars.eq(0).css('font-size'));

      if (!width) {
        methods._error.call(this, 'Could not get the icon width!');
      }

      return width;
    },

    _lock: function() {
      var hint = methods._getHint.call(this, this.score.val());

      this.style.cursor = '';
      this.title        = hint;

      this.score.prop('readonly', true);
      this.stars.prop('title', hint);

      if (this.cancel) {
        this.cancel.hide();
      }

      this.self.data('readonly', true);
    },

    _nameForIndex: function(i) {
      return this.opt.score && this.opt.score >= i ? 'starOn' : 'starOff';
    },

    _resetTitle: function(star) {
      for (var i = 0; i < this.opt.number; i++) {
        this.stars[i].title = methods._getHint.call(this, i + 1);
      }
    },

     _roundHalfScore: function(score) {
      var integer = parseInt(score, 10),
          decimal = methods._getFirstDecimal.call(this, score);

      if (decimal !== 0) {
        decimal = decimal > 5 ? 1 : 0.5;
      }

      return integer + decimal;
    },

    _roundStars: function(score, evt) {
      var
        decimal = (score % 1).toFixed(2),
        name    ;

      if (evt || this.move) {
        name = decimal > 0.5 ? 'starOn' : 'starHalf';
      } else if (decimal > this.opt.round.down) {               // Up:   [x.76 .. x.99]
        name = 'starOn';

        if (this.opt.halfShow && decimal < this.opt.round.up) { // Half: [x.26 .. x.75]
          name = 'starHalf';
        } else if (decimal < this.opt.round.full) {             // Down: [x.00 .. x.5]
          name = 'starOff';
        }
      }

      if (name) {
        var
          icon = this.opt[name],
          star = this.stars[Math.ceil(score) - 1];

        methods._setIcon.call(this, star, icon);
      }                                                         // Full down: [x.00 .. x.25]
    },

    _setIcon: function(star, icon) {
      star[this.opt.starType === 'img' ? 'src' : 'className'] = this.opt.path + icon;
    },

    _setTarget: function(target, score) {
      if (score) {
        score = this.opt.targetFormat.toString().replace('{score}', score);
      }

      if (target.is(':input')) {
        target.val(score);
      } else {
        target.html(score);
      }
    },

    _setTitle: function(score, evt) {
      if (score) {
        var
          integer = parseInt(Math.ceil(score), 10),
          star    = this.stars[integer - 1];

        star.title = methods._getHint.call(this, score, evt);
      }
    },

    _target: function(score, evt) {
      if (this.opt.target) {
        var target = $(this.opt.target);

        if (!target.length) {
          methods._error.call(this, 'Target selector invalid or missing!');
        }

        var mouseover = evt && evt.type === 'mouseover';

        if (score === undefined) {
          score = this.opt.targetText;
        } else if (score === null) {
          score = mouseover ? this.opt.cancelHint : this.opt.targetText;
        } else {
          if (this.opt.targetType === 'hint') {
            score = methods._getHint.call(this, score, evt);
          } else if (this.opt.precision) {
            score = parseFloat(score).toFixed(1);
          }

          var mousemove = evt && evt.type === 'mousemove';

          if (!mouseover && !mousemove && !this.opt.targetKeep) {
            score = this.opt.targetText;
          }
        }

        methods._setTarget.call(this, target, score);
      }
    },

    _turnOn: function(i, score) {
      return this.opt.single ? (i === score) : (i <= score);
    },

    _unlock: function() {
      this.style.cursor = 'pointer';
      this.removeAttribute('title');

      this.score.removeAttr('readonly');

      this.self.data('readonly', false);

      for (var i = 0; i < this.opt.number; i++) {
        this.stars[i].title = methods._getHint.call(this, i + 1);
      }

      if (this.cancel) {
        this.cancel.css('display', '');
      }
    },

    cancel: function(click) {
      return this.each(function() {
        var self = $(this);

        if (self.data('readonly') !== true) {
          methods[click ? 'click' : 'score'].call(self, null);

          this.score.removeAttr('value');
        }
      });
    },

    click: function(score) {
      return this.each(function() {
        if ($(this).data('readonly') !== true) {
          score = methods._adjustedScore.call(this, score);

          methods._apply.call(this, score);

          if (this.opt.click) {
            this.opt.click.call(this, score, $.Event('click'));
          }

          methods._target.call(this, score);
        }
      });
    },

    destroy: function() {
      return this.each(function() {
        var self = $(this),
            raw  = self.data('raw');

        if (raw) {
          self.off('.raty').empty().css({ cursor: raw.style.cursor }).removeData('readonly');
        } else {
          self.data('raw', self.clone()[0]);
        }
      });
    },

    getScore: function() {
      var score = [],
          value ;

      this.each(function() {
        value = this.score.val();

        score.push(value ? +value : undefined);
      });

      return (score.length > 1) ? score : score[0];
    },

    move: function(score) {
      return this.each(function() {
        var
          integer  = parseInt(score, 10),
          decimal  = methods._getFirstDecimal.call(this, score);

        if (integer >= this.opt.number) {
          integer = this.opt.number - 1;
          decimal = 10;
        }

        var
          width   = methods._getWidth.call(this),
          steps   = width / 10,
          star    = $(this.stars[integer]),
          percent = star.offset().left + steps * decimal,
          evt     = $.Event('mousemove', { pageX: percent });

        this.move = true;

        star.trigger(evt);

        this.move = false;
      });
    },

    readOnly: function(readonly) {
      return this.each(function() {
        var self = $(this);

        if (self.data('readonly') !== readonly) {
          if (readonly) {
            self.off('.raty').children('img').off('.raty');

            methods._lock.call(this);
          } else {
            methods._binds.call(this);
            methods._unlock.call(this);
          }

          self.data('readonly', readonly);
        }
      });
    },

    reload: function() {
      return methods.set.call(this, {});
    },

    score: function() {
      var self = $(this);

      return arguments.length ? methods.setScore.apply(self, arguments) : methods.getScore.call(self);
    },

    set: function(options) {
      return this.each(function() {
        $(this).raty($.extend({}, this.opt, options));
      });
    },

    setScore: function(score) {
      return this.each(function() {
        if ($(this).data('readonly') !== true) {
          score = methods._adjustedScore.call(this, score);

          methods._apply.call(this, score);
          methods._target.call(this, score);
        }
      });
    }
  };

  $.fn.raty = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist!');
    }
  };

  $.fn.raty.defaults = {
    cancel       : false,
    cancelClass  : 'raty-cancel',
    cancelHint   : 'Cancel this rating!',
    cancelOff    : 'cancel-off.png',
    cancelOn     : 'cancel-on.png',
    cancelPlace  : 'left',
    click        : undefined,
    half         : false,
    halfShow     : true,
    hints        : ['bad', 'poor', 'regular', 'good', 'excellent'],
    iconRange    : undefined,
    mouseout     : undefined,
    mouseover    : undefined,
    noRatedMsg   : 'Not rated yet!',
    number       : 5,
    numberMax    : 20,
    path         : undefined,
    precision    : false,
    readOnly     : false,
    round        : { down: 0.25, full: 0.6, up: 0.76 },
    score        : undefined,
    scoreName    : 'score',
    single       : false,
    space        : true,
    starHalf     : 'star-half.png',
    starOff      : 'star-off.png',
    starOn       : 'star-on.png',
    starType     : 'img',
    target       : undefined,
    targetFormat : '{score}',
    targetKeep   : false,
    targetScore  : undefined,
    targetText   : '',
    targetType   : 'hint'
  };

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * @preserve
 * bootpag - jQuery plugin for dynamic pagination
 *
 * Copyright (c) 2015 botmonster@7items.com
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   http://botmonster.com/jquery-bootpag/
 *
 * Version:  1.0.7
 *
 */
(function($, window) {

    $.fn.bootpag = function(options){

        var $owner = this,
            settings = $.extend({
                total: 0,
                page: 1,
                maxVisible: null,
                leaps: true,
                href: 'javascript:void(0);',
                hrefVariable: '{{number}}',
                next: '&raquo;',
                prev: '&laquo;',
                firstLastUse: false,
                first: '<span aria-hidden="true">&larr;</span>',
                last: '<span aria-hidden="true">&rarr;</span>',
                wrapClass: 'pagination',
                activeClass: 'active',
                disabledClass: 'disabled',
                nextClass: 'next',
                prevClass: 'prev',
                lastClass: 'last',
                firstClass: 'first'
            },
            $owner.data('settings') || {},
            options || {});

        if(settings.total <= 0)
            return this;

          if(!$.isNumeric(settings.maxVisible) && !settings.maxVisible){
            settings.maxVisible = parseInt(settings.total, 10);
        }

        $owner.data('settings', settings);

        function renderPage($bootpag, page){

            page = parseInt(page, 10);
            var lp,
                maxV = settings.maxVisible == 0 ? 1 : settings.maxVisible,
                step = settings.maxVisible == 1 ? 0 : 1,
                vis = Math.floor((page - 1) / maxV) * maxV,
                $page = $bootpag.find('li');
            settings.page = page = page < 0 ? 0 : page > settings.total ? settings.total : page;
            $page.removeClass(settings.activeClass);
            lp = page - 1 < 1 ? 1 :
                settings.leaps && page - 1 >= settings.maxVisible ?
                    Math.floor((page - 1) / maxV) * maxV : page - 1;

            if(settings.firstLastUse) {
                $page
                    .first()
                    .toggleClass(settings.disabledClass, page === 1);
            }

            var lfirst = $page.first();
            if(settings.firstLastUse) {
                lfirst = lfirst.next();
            }

            lfirst
                .toggleClass(settings.disabledClass, page === 1)
                .attr('data-lp', lp)
                .find('a').attr('href', href(lp));

            var step = settings.maxVisible == 1 ? 0 : 1;

            lp = page + 1 > settings.total ? settings.total :
                    settings.leaps && page + 1 < settings.total - settings.maxVisible ?
                        vis + settings.maxVisible + step: page + 1;

            var llast = $page.last();
            if(settings.firstLastUse) {
                llast = llast.prev();
            }

            llast
                .toggleClass(settings.disabledClass, page === settings.total)
                .attr('data-lp', lp)
                .find('a').attr('href', href(lp));

            $page
                .last()
                .toggleClass(settings.disabledClass, page === settings.total);

            var $currPage = $page.filter('[data-lp='+page+']');

            var clist = "." + [settings.nextClass,
                               settings.prevClass,
                               settings.firstClass,
                               settings.lastClass].join(",.");
            if(!$currPage.not(clist).length){
                var d = page <= vis ? -settings.maxVisible : 0;
                $page.not(clist).each(function(index){
                    lp = index + 1 + vis + d;
                    $(this)
                        .attr('data-lp', lp)
                        .toggle(lp <= settings.total)
                        .find('a').html(lp).attr('href', href(lp));
                });
                $currPage = $page.filter('[data-lp='+page+']');
            }
            $currPage.not(clist).addClass(settings.activeClass);
            $owner.data('settings', settings);
        }

        function href(c){

            return settings.href.replace(settings.hrefVariable, c);
        }

        return this.each(function(){

            var $bootpag, lp, me = $(this),
                p = ['<ul class="', settings.wrapClass, ' bootpag">'];

            if(settings.firstLastUse){
                p = p.concat(['<li data-lp="1" class="', settings.firstClass,
                       '"><a href="', href(1), '">', settings.first, '</a></li>']);
            }
            if(settings.prev){
                p = p.concat(['<li data-lp="1" class="', settings.prevClass,
                       '"><a href="', href(1), '">', settings.prev, '</a></li>']);
            }
            for(var c = 1; c <= Math.min(settings.total, settings.maxVisible); c++){
                p = p.concat(['<li data-lp="', c, '"><a href="', href(c), '">', c, '</a></li>']);
            }
            if(settings.next){
                lp = settings.leaps && settings.total > settings.maxVisible
                    ? Math.min(settings.maxVisible + 1, settings.total) : 2;
                p = p.concat(['<li data-lp="', lp, '" class="',
                             settings.nextClass, '"><a href="', href(lp),
                             '">', settings.next, '</a></li>']);
            }
            if(settings.firstLastUse){
                p = p.concat(['<li data-lp="', settings.total, '" class="last"><a href="',
                             href(settings.total),'">', settings.last, '</a></li>']);
            }
            p.push('</ul>');
            me.find('ul.bootpag').remove();
            me.append(p.join(''));
            $bootpag = me.find('ul.bootpag');

            me.find('li').click(function paginationClick(){

                var me = $(this);
                if(me.hasClass(settings.disabledClass) || me.hasClass(settings.activeClass)){
                    return;
                }
                var page = parseInt(me.attr('data-lp'), 10);
                $owner.find('ul.bootpag').each(function(){
                    renderPage($(this), page);
                });

                $owner.trigger('page', page);
            });
            renderPage($bootpag, settings.page);
        });
    }

})(jQuery, window);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */


;(function(window) {
	'use strict';

	var
		count                 = 0,
		logEnabled            = false,
		hiddenCheckEnabled    = false,
		msgHeader             = 'message',
		msgHeaderLen          = msgHeader.length,
		msgId                 = '[iFrameSizer]', //Must match iframe msg ID
		msgIdLen              = msgId.length,
		pagePosition          = null,
		requestAnimationFrame = window.requestAnimationFrame,
		resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
		settings              = {},
		timer                 = null,
		logId                 = 'Host Page',

		defaults              = {
			autoResize                : true,
			bodyBackground            : null,
			bodyMargin                : null,
			bodyMarginV1              : 8,
			bodyPadding               : null,
			checkOrigin               : true,
			inPageLinks               : false,
			enablePublicMethods       : true,
			heightCalculationMethod   : 'bodyOffset',
			id                        : 'iFrameResizer',
			interval                  : 32,
			log                       : false,
			maxHeight                 : Infinity,
			maxWidth                  : Infinity,
			minHeight                 : 0,
			minWidth                  : 0,
			resizeFrom                : 'parent',
			scrolling                 : false,
			sizeHeight                : true,
			sizeWidth                 : false,
			tolerance                 : 0,
			widthCalculationMethod    : 'scroll',
			closedCallback            : function(){},
			initCallback              : function(){},
			messageCallback           : function(){warn('MessageCallback function not defined');},
			resizedCallback           : function(){},
			scrollCallback            : function(){return true;}
		};

	function addEventListener(obj,evt,func){
		/* istanbul ignore else */ // Not testable in PhantonJS
		if ('addEventListener' in window){
			obj.addEventListener(evt,func, false);
		} else if ('attachEvent' in window){//IE
			obj.attachEvent('on'+evt,func);
		}
	}

	function removeEventListener(el,evt,func){
		/* istanbul ignore else */ // Not testable in phantonJS
		if ('removeEventListener' in window){
			el.removeEventListener(evt,func, false);
		} else if ('detachEvent' in window){ //IE
			el.detachEvent('on'+evt,func);
		}
	}

	function setupRequestAnimationFrame(){
		var
			vendors = ['moz', 'webkit', 'o', 'ms'],
			x;

		// Remove vendor prefixing if prefixed and break early if not
		for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
			requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		}

		if (!(requestAnimationFrame)){
			log('setup','RequestAnimationFrame not supported');
		}
	}

	function getMyID(iframeId){
		var retStr = 'Host page: '+iframeId;

		if (window.top!==window.self){
			if (window.parentIFrame && window.parentIFrame.getId){
				retStr = window.parentIFrame.getId()+': '+iframeId;
			} else {
				retStr = 'Nested host page: '+iframeId;
			}
		}

		return retStr;
	}

	function formatLogHeader(iframeId){
		return msgId + '[' + getMyID(iframeId) + ']';
	}

	function isLogEnabled(iframeId){
		return settings[iframeId] ? settings[iframeId].log : logEnabled;
	}

	function log(iframeId,msg){
		output('log',iframeId,msg,isLogEnabled(iframeId));
	}

	function info(iframeId,msg){
		output('info',iframeId,msg,isLogEnabled(iframeId));
	}

	function warn(iframeId,msg){
		output('warn',iframeId,msg,true);
	}

	function output(type,iframeId,msg,enabled){
		if (true === enabled && 'object' === typeof window.console){
			console[type](formatLogHeader(iframeId),msg);
		}
	}

	function iFrameListener(event){
		function resizeIFrame(){
			function resize(){
				setSize(messageData);
				setPagePosition(iframeId);
			}

			ensureInRange('Height');
			ensureInRange('Width');

			syncResize(resize,messageData,'init');
		}

		function processMsg(){
			var data = msg.substr(msgIdLen).split(':');

			return {
				iframe: settings[data[0]].iframe,
				id:     data[0],
				height: data[1],
				width:  data[2],
				type:   data[3]
			};
		}

		function ensureInRange(Dimension){
			var
				max  = Number(settings[iframeId]['max' + Dimension]),
				min  = Number(settings[iframeId]['min' + Dimension]),
				dimension = Dimension.toLowerCase(),
				size = Number(messageData[dimension]);

			log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);

			if (size<min) {
				size=min;
				log(iframeId,'Set ' + dimension + ' to min value');
			}

			if (size>max) {
				size=max;
				log(iframeId,'Set ' + dimension + ' to max value');
			}

			messageData[dimension] = '' + size;
		}


		function isMessageFromIFrame(){
			function checkAllowedOrigin(){
				function checkList(){
					var
						i = 0,
						retCode = false;

					log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);

					for (; i < checkOrigin.length; i++) {
						if (checkOrigin[i] === origin) {
							retCode = true;
							break;
						}
					}
					return retCode;
				}

				function checkSingle(){
					var remoteHost  = settings[iframeId].remoteHost;
					log(iframeId,'Checking connection is from: '+remoteHost);
					return origin === remoteHost;
				}

				return checkOrigin.constructor === Array ? checkList() : checkSingle();
			}

			var
				origin      = event.origin,
				checkOrigin = settings[iframeId].checkOrigin;

			if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
				throw new Error(
					'Unexpected message received from: ' + origin +
					' for ' + messageData.iframe.id +
					'. Message was: ' + event.data +
					'. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
				);
			}

			return true;
		}

		function isMessageForUs(){
			return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
		}

		function isMessageFromMetaParent(){
			//Test if this message is from a parent above us. This is an ugly test, however, updating
			//the message format would break backwards compatibity.
			var retCode = messageData.type in {'true':1,'false':1,'undefined':1};

			if (retCode){
				log(iframeId,'Ignoring init message from meta parent page');
			}

			return retCode;
		}

		function getMsgBody(offset){
			return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
		}

		function forwardMsgFromIFrame(msgBody){
			log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
			callback('messageCallback',{
				iframe: messageData.iframe,
				message: JSON.parse(msgBody)
			});
			log(iframeId,'--');
		}

		function getPageInfo(){
			var
				bodyPosition   = document.body.getBoundingClientRect(),
				iFramePosition = messageData.iframe.getBoundingClientRect();

			return JSON.stringify({
				iframeHeight: iFramePosition.height,
				iframeWidth:  iFramePosition.width,
				clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
				clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
				offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
				offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
				scrollTop:    window.pageYOffset,
				scrollLeft:   window.pageXOffset
			});
		}

		function sendPageInfoToIframe(iframe,iframeId){
			function debouncedTrigger(){
				trigger(
					'Send Page Info',
					'pageInfo:' + getPageInfo(),
					iframe,
					iframeId
				);
			}

			debouce(debouncedTrigger,32);
		}


		function startPageInfoMonitor(){
			function setListener(type,func){
				function sendPageInfo(){
					if (settings[id]){
						sendPageInfoToIframe(settings[id].iframe,id);
					} else {
						stop();
					}
				}

				['scroll','resize'].forEach(function(evt){
					log(id, type +  evt + ' listener for sendPageInfo');
					func(window,evt,sendPageInfo);
				});
			}

			function stop(){
				setListener('Remove ', removeEventListener);
			}

			function start(){
				setListener('Add ', addEventListener);
			}

			var id = iframeId; //Create locally scoped copy of iFrame ID

			start();

			settings[id].stopPageInfo = stop;
		}

		function stopPageInfoMonitor(){
			if (settings[iframeId] && settings[iframeId].stopPageInfo){
				settings[iframeId].stopPageInfo();
				delete settings[iframeId].stopPageInfo;
			}
		}

		function checkIFrameExists(){
			var retBool = true;

			if (null === messageData.iframe) {
				warn(iframeId,'IFrame ('+messageData.id+') not found');
				retBool = false;
			}
			return retBool;
		}

		function getElementPosition(target){
			var iFramePosition = target.getBoundingClientRect();

			getPagePosition(iframeId);

			return {
				x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
				y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
			};
		}

		function scrollRequestFromChild(addOffset){
			/* istanbul ignore next */  //Not testable in Karma
			function reposition(){
				pagePosition = newPosition;
				scrollTo();
				log(iframeId,'--');
			}

			function calcOffset(){
				return {
					x: Number(messageData.width) + offset.x,
					y: Number(messageData.height) + offset.y
				};
			}

			function scrollParent(){
				if (window.parentIFrame){
					window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
				} else {
					warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
				}
			}

			var
				offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
				newPosition = calcOffset();

			log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');

			if(window.top!==window.self){
				scrollParent();
			} else {
				reposition();
			}
		}

		function scrollTo(){
			if (false !== callback('scrollCallback',pagePosition)){
				setPagePosition(iframeId);
			} else {
				unsetPagePosition();
			}
		}

		function findTarget(location){
			function jumpToTarget(){
				var jumpPosition = getElementPosition(target);

				log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
				pagePosition = {
					x: jumpPosition.x,
					y: jumpPosition.y
				};

				scrollTo();
				log(iframeId,'--');
			}

			function jumpToParent(){
				if (window.parentIFrame){
					window.parentIFrame.moveToAnchor(hash);
				} else {
					log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
				}
			}

			var
				hash     = location.split('#')[1] || '',
				hashData = decodeURIComponent(hash),
				target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

			if (target){
				jumpToTarget();
			} else if(window.top!==window.self){
				jumpToParent();
			} else {
				log(iframeId,'In page link #'+hash+' not found');
			}
		}

		function callback(funcName,val){
			return chkCallback(iframeId,funcName,val);
		}

		function actionMsg(){

			if(settings[iframeId].firstRun) firstRun();

			switch(messageData.type){
			case 'close':
				closeIFrame(messageData.iframe);
				break;
			case 'message':
				forwardMsgFromIFrame(getMsgBody(6));
				break;
			case 'scrollTo':
				scrollRequestFromChild(false);
				break;
			case 'scrollToOffset':
				scrollRequestFromChild(true);
				break;
			case 'pageInfo':
				sendPageInfoToIframe(settings[iframeId].iframe,iframeId);
				startPageInfoMonitor();
				break;
			case 'pageInfoStop':
				stopPageInfoMonitor();
				break;
			case 'inPageLink':
				findTarget(getMsgBody(9));
				break;
			case 'reset':
				resetIFrame(messageData);
				break;
			case 'init':
				resizeIFrame();
				callback('initCallback',messageData.iframe);
				callback('resizedCallback',messageData);
				break;
			default:
				resizeIFrame();
				callback('resizedCallback',messageData);
			}
		}

		function hasSettings(iframeId){
			var retBool = true;

			if (!settings[iframeId]){
				retBool = false;
				warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
			}

			return retBool;
		}

		function iFrameReadyMsgReceived(){
			for (var iframeId in settings){
				trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
			}
		}

		function firstRun() {
			settings[iframeId].firstRun = false;
		}

		var
			msg = event.data,
			messageData = {},
			iframeId = null;

		if('[iFrameResizerChild]Ready' === msg){
			iFrameReadyMsgReceived();
		} else if (isMessageForUs()){
			messageData = processMsg();
			iframeId    = logId = messageData.id;

			if (!isMessageFromMetaParent() && hasSettings(iframeId)){
				log(iframeId,'Received: '+msg);

				if ( checkIFrameExists() && isMessageFromIFrame() ){
					actionMsg();
				}
			}
		} else {
			info(iframeId,'Ignored: '+msg);
		}

	}


	function chkCallback(iframeId,funcName,val){
		var
			func = null,
			retVal = null;

		if(settings[iframeId]){
			func = settings[iframeId][funcName];

			if( 'function' === typeof func){
				retVal = func(val);
			} else {
				throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
			}
		}

		return retVal;
	}

	function closeIFrame(iframe){
		var iframeId = iframe.id;

		log(iframeId,'Removing iFrame: '+iframeId);
		iframe.parentNode.removeChild(iframe);
		chkCallback(iframeId,'closedCallback',iframeId);
		log(iframeId,'--');
		delete settings[iframeId];
	}

	function getPagePosition(iframeId){
		if(null === pagePosition){
			pagePosition = {
				x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
				y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
			};
			log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
		}
	}

	function setPagePosition(iframeId){
		if(null !== pagePosition){
			window.scrollTo(pagePosition.x,pagePosition.y);
			log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
			unsetPagePosition();
		}
	}

	function unsetPagePosition(){
		pagePosition = null;
	}

	function resetIFrame(messageData){
		function reset(){
			setSize(messageData);
			trigger('reset','reset',messageData.iframe,messageData.id);
		}

		log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
		getPagePosition(messageData.id);
		syncResize(reset,messageData,'reset');
	}

	function setSize(messageData){
		function setDimension(dimension){
			messageData.iframe.style[dimension] = messageData[dimension] + 'px';
			log(
				messageData.id,
				'IFrame (' + iframeId +
				') ' + dimension +
				' set to ' + messageData[dimension] + 'px'
			);
		}

		function chkZero(dimension){
			//FireFox sets dimension of hidden iFrames to zero.
			//So if we detect that set up an event to check for
			//when iFrame becomes visible.

			/* istanbul ignore next */  //Not testable in PhantomJS
			if (!hiddenCheckEnabled && '0' === messageData[dimension]){
				hiddenCheckEnabled = true;
				log(iframeId,'Hidden iFrame detected, creating visibility listener');
				fixHiddenIFrames();
			}
		}

		function processDimension(dimension){
			setDimension(dimension);
			chkZero(dimension);
		}

		var iframeId = messageData.iframe.id;

		if(settings[iframeId]){
			if( settings[iframeId].sizeHeight) { processDimension('height'); }
			if( settings[iframeId].sizeWidth ) { processDimension('width'); }
		}
	}

	function syncResize(func,messageData,doNotSync){
		/* istanbul ignore if */  //Not testable in PhantomJS
		if(doNotSync!==messageData.type && requestAnimationFrame){
			log(messageData.id,'Requesting animation frame');
			requestAnimationFrame(func);
		} else {
			func();
		}
	}

	function trigger(calleeMsg,msg,iframe,id){
		function postMessageToIFrame(){
			var target = settings[id].targetOrigin;
			log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
			iframe.contentWindow.postMessage( msgId + msg, target );
		}

		function iFrameNotFound(){
			info(id,'[' + calleeMsg + '] IFrame('+id+') not found');
			if(settings[id]) {
				delete settings[id];
			}
		}

		function chkAndSend(){
			if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)){ //Null test for PhantomJS
				postMessageToIFrame();
			} else {
				iFrameNotFound();
			}
		}

		id = id || iframe.id;

		if(settings[id]) {
			chkAndSend();
		}

	}

	function createOutgoingMsg(iframeId){
		return iframeId +
			':' + settings[iframeId].bodyMarginV1 +
			':' + settings[iframeId].sizeWidth +
			':' + settings[iframeId].log +
			':' + settings[iframeId].interval +
			':' + settings[iframeId].enablePublicMethods +
			':' + settings[iframeId].autoResize +
			':' + settings[iframeId].bodyMargin +
			':' + settings[iframeId].heightCalculationMethod +
			':' + settings[iframeId].bodyBackground +
			':' + settings[iframeId].bodyPadding +
			':' + settings[iframeId].tolerance +
			':' + settings[iframeId].inPageLinks +
			':' + settings[iframeId].resizeFrom +
			':' + settings[iframeId].widthCalculationMethod;
	}

	function setupIFrame(iframe,options){
		function setLimits(){
			function addStyle(style){
				if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])){
					iframe.style[style] = settings[iframeId][style] + 'px';
					log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
				}
			}

			function chkMinMax(dimension){
				if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]){
					throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
				}
			}

			chkMinMax('Height');
			chkMinMax('Width');

			addStyle('maxHeight');
			addStyle('minHeight');
			addStyle('maxWidth');
			addStyle('minWidth');
		}

		function newId(){
			var id = ((options && options.id) || defaults.id + count++);
			if  (null!==document.getElementById(id)){
				id = id + count++;
			}
			return id;
		}

		function ensureHasId(iframeId){
			logId=iframeId;
			if (''===iframeId){
				iframe.id = iframeId =  newId();
				logEnabled = (options || {}).log;
				logId=iframeId;
				log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
			}


			return iframeId;
		}

		function setScrolling(){
			log(iframeId,'IFrame scrolling ' + (settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
			iframe.style.overflow = false === settings[iframeId].scrolling ? 'hidden' : 'auto';
			iframe.scrolling      = false === settings[iframeId].scrolling ? 'no' : 'yes';
		}

		//The V1 iFrame script expects an int, where as in V2 expects a CSS
		//string value such as '1px 3em', so if we have an int for V2, set V1=V2
		//and then convert V2 to a string PX value.
		function setupBodyMarginValues(){
			if (('number'===typeof(settings[iframeId].bodyMargin)) || ('0'===settings[iframeId].bodyMargin)){
				settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
				settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
			}
		}

		function checkReset(){
			// Reduce scope of firstRun to function, because IE8's JS execution
			// context stack is borked and this value gets externally
			// changed midway through running this function!!!
			var
				firstRun           = settings[iframeId].firstRun,
				resetRequertMethod = settings[iframeId].heightCalculationMethod in resetRequiredMethods;

			if (!firstRun && resetRequertMethod){
				resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
			}
		}

		function setupIFrameObject(){
			if(Function.prototype.bind){ //Ignore unpolyfilled IE8.
				settings[iframeId].iframe.iFrameResizer = {

					close        : closeIFrame.bind(null,settings[iframeId].iframe),

					resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),

					moveToAnchor : function(anchor){
						trigger('Move to anchor','inPageLink:'+anchor, settings[iframeId].iframe,iframeId);
					},

					sendMessage  : function(message){
						message = JSON.stringify(message);
						trigger('Send Message','message:'+message, settings[iframeId].iframe,iframeId);
					}
				};
			}
		}

		//We have to call trigger twice, as we can not be sure if all
		//iframes have completed loading when this code runs. The
		//event listener also catches the page changing in the iFrame.
		function init(msg){
			function iFrameLoaded(){
				trigger('iFrame.onload',msg,iframe);
				checkReset();
			}

			addEventListener(iframe,'load',iFrameLoaded);
			trigger('init',msg,iframe);
		}

		function checkOptions(options){
			if ('object' !== typeof options){
				throw new TypeError('Options is not an object');
			}
		}

		function copyOptions(options){
			for (var option in defaults) {
				if (defaults.hasOwnProperty(option)){
					settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
				}
			}
		}

		function getTargetOrigin (remoteHost){
			return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
		}

		function processOptions(options){
			options = options || {};
			settings[iframeId] = {
				firstRun	: true,
				iframe		: iframe,
				remoteHost	: iframe.src.split('/').slice(0,3).join('/')
			};

			checkOptions(options);
			copyOptions(options);

			settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
		}

		function beenHere(){
			return (iframeId in settings && 'iFrameResizer' in iframe);
		}

		var iframeId = ensureHasId(iframe.id);

		if (!beenHere()){
			processOptions(options);
			setScrolling();
			setLimits();
			setupBodyMarginValues();
			init(createOutgoingMsg(iframeId));
			setupIFrameObject();
		} else {
			warn(iframeId,'Ignored iFrame, already setup.');
		}
	}

	function debouce(fn,time){
		if (null === timer){
			timer = setTimeout(function(){
				timer = null;
				fn();
			}, time);
		}
	}

	/* istanbul ignore next */  //Not testable in PhantomJS
	function fixHiddenIFrames(){
		function checkIFrames(){
			function checkIFrame(settingId){
				function chkDimension(dimension){
					return '0px' === settings[settingId].iframe.style[dimension];
				}

				function isVisible(el) {
					return (null !== el.offsetParent);
				}

				if (isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))){
					trigger('Visibility change', 'resize', settings[settingId].iframe,settingId);
				}
			}

			for (var settingId in settings){
				checkIFrame(settingId);
			}
		}

		function mutationObserved(mutations){
			log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
			debouce(checkIFrames,16);
		}

		function createMutationObserver(){
			var
				target = document.querySelector('body'),

				config = {
					attributes            : true,
					attributeOldValue     : false,
					characterData         : true,
					characterDataOldValue : false,
					childList             : true,
					subtree               : true
				},

				observer = new MutationObserver(mutationObserved);

			observer.observe(target, config);
		}

		var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

		if (MutationObserver) createMutationObserver();
	}


	function resizeIFrames(event){
		function resize(){
			sendTriggerMsg('Window '+event,'resize');
		}

		log('window','Trigger event: '+event);
		debouce(resize,16);
	}

	/* istanbul ignore next */  //Not testable in PhantomJS
	function tabVisible() {
		function resize(){
			sendTriggerMsg('Tab Visable','resize');
		}

		if('hidden' !== document.visibilityState) {
			log('document','Trigger event: Visiblity change');
			debouce(resize,16);
		}
	}

	function sendTriggerMsg(eventName,event){
		function isIFrameResizeEnabled(iframeId) {
			return	'parent' === settings[iframeId].resizeFrom &&
					settings[iframeId].autoResize &&
					!settings[iframeId].firstRun;
		}

		for (var iframeId in settings){
			if(isIFrameResizeEnabled(iframeId)){
				trigger(eventName,event,document.getElementById(iframeId),iframeId);
			}
		}
	}

	function setupEventListeners(){
		addEventListener(window,'message',iFrameListener);

		addEventListener(window,'resize', function(){resizeIFrames('resize');});

		addEventListener(document,'visibilitychange',tabVisible);
		addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
		addEventListener(window,'focusin',function(){resizeIFrames('focus');}); //IE8-9
		addEventListener(window,'focus',function(){resizeIFrames('focus');});
	}


	function factory(){
		function init(options,element){
			function chkType(){
				if(!element.tagName) {
					throw new TypeError('Object is not a valid DOM element');
				} else if ('IFRAME' !== element.tagName.toUpperCase()) {
					throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
				}
			}

			if(element) {
				chkType();
				setupIFrame(element, options);
				iFrames.push(element);
			}
		}

		var iFrames;

		setupRequestAnimationFrame();
		setupEventListeners();

		return function iFrameResizeF(options,target){
			iFrames = []; //Only return iFrames past in on this call

			switch (typeof(target)){
			case 'undefined':
			case 'string':
				Array.prototype.forEach.call(
					document.querySelectorAll( target || 'iframe' ),
					init.bind(undefined, options)
				);
				break;
			case 'object':
				init(options,target);
				break;
			default:
				throw new TypeError('Unexpected data type ('+typeof(target)+')');
			}

			return iFrames;
		};
	}

	function createJQueryPublicMethod($){
		$.fn.iFrameResize = function $iFrameResizeF(options) {
			return this.filter('iframe').each(function (index, element) {
				setupIFrame(element, options);
			}).end();
		};
	}

	if (window.jQuery) { createJQueryPublicMethod(jQuery); }

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
		module.exports = factory();
	} else {
		window.iFrameResize = window.iFrameResize || factory();
	}

})(window || {});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*
 *   A base class for generating AJAX channels and handling success and
 *   error responses.
 *
 *   This class serves two puroses. The first is to abstract away from the
 *   nitty gritty of the $.ajax method. Simply pass a dictionary to the post
 *   or get methods and it handles the rest.
 *   
 *   The second is to provide a consistent experience to the user in the
 *   (unlikely) case of an error callback. It will display to the user a nice
 *   error message, complete with support contact information. 
 *
 *   This class extends Backbone.Model. Note that we are not using the models
 *   fetch functionality, which is tied to REST concepts. 
 * 
 *   Usage:
 * 
 *      myChannel = new AJAXView({ 
 *        url: '/ajax/myapp/myaction/', 
 *        successCallback: function(response){ 
 *          // Update some visual element 
 *        } 
 *      });
 *      myChannel.post({'foo': 'bar'}); 
 *   
 */
var AJAXView = Backbone.View.extend({
    url: null,

    initialize: function () {
        // Necessary Javascript voodoo
        _.bindAll(this, 
                  'get',
                  'post',
                  'successCallback',
                  'errorCallback'
                  );
    },

    /* 
     *  Submit GET request to url.
     *      params - a dictionary of key/value pairs that will be converted
     *               into a querystring
     *      url - (optional) override of this.url
     */ 
    get: function(params, url){
        alert("Not yet implemented");
        if (typeof url === 'undefined'){
            url = this.options.url;
        }
        // TODO: append params to querystring, being conscious of ? or no
        // TODO: Add stint to prevent IE from caching (e.g. ?noiecache=12345)
    },

    /* 
     *  Post to url, sending contents of post_data. 
     *      post_data - a dictionary of key, value pairs
     *      url - (optional) override of this.url
     */ 
    post: function(postData, url, contentType) {
        url = url || this.options.url;
        contentType = contentType || 'application/x-www-form-urlencoded';
        this._post(postData, url, 'POST', contentType);
    },

    put: function(put_data, url, contentType) {
        url = url || this.options.url;
        contentType = contentType || 'application/x-www-form-urlencoded';
        this._post(put_data, url, 'PUT', contentType);
    },
    
    _post: function(post_data, url, type, contentType) {
        $.ajax({
            type: type,
            url: url,
            data: post_data,
            dataType: 'json',
            contentType: contentType,
            success: this.successCallback,
            error: this.errorCallback
        });
    },

    successCallback: function(result){
        alert("Override me");
    },

    errorCallback: function(data){
        alert("Oops, an error occurred. The Rover.com tech team has been " +
              "alerted and will fix it shortly. If you would like immediate " + 
              "help visit our Help Center at support.rover.com, or call the " +
              "Barkline at 888-453-7889");
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)))

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 *	jQuery dotdotdot 1.6.16
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */

(function( $, undef )
{
	if ( $.fn.dotdotdot )
	{
		return;
	}

	$.fn.dotdotdot = function( o )
	{
		if ( this.length == 0 )
		{
			$.fn.dotdotdot.debug( 'No element found for "' + this.selector + '".' );
			return this;
		}
		if ( this.length > 1 )
		{
			return this.each(
				function()
				{
					$(this).dotdotdot( o );
				}
			);
		}


		var $dot = this;

		if ( $dot.data( 'dotdotdot' ) )
		{
			$dot.trigger( 'destroy.dot' );
		}

		$dot.data( 'dotdotdot-style', $dot.attr( 'style' ) || '' );
		$dot.css( 'word-wrap', 'break-word' );
		if ($dot.css( 'white-space' ) === 'nowrap')
		{
			$dot.css( 'white-space', 'normal' );
		}

		$dot.bind_events = function()
		{
			$dot.bind(
				'update.dot',
				function( e, c )
				{
					e.preventDefault();
					e.stopPropagation();

					opts.maxHeight = ( typeof opts.height == 'number' )
						? opts.height
						: getTrueInnerHeight( $dot );

					opts.maxHeight += opts.tolerance;

					if ( typeof c != 'undefined' )
					{
						if ( typeof c == 'string' || c instanceof HTMLElement )
						{
					 		c = $('<div />').append( c ).contents();
						}
						if ( c instanceof $ )
						{
							orgContent = c;
						}
					}

					$inr = $dot.wrapInner( '<div class="dotdotdot" />' ).children();
					$inr.contents()
						.detach()
						.end()
						.append( orgContent.clone( true ) )
						.find( 'br' )
						.replaceWith( '  <br />  ' )
						.end()
						.css({
							'height'	: 'auto',
							'width'		: 'auto',
							'border'	: 'none',
							'padding'	: 0,
							'margin'	: 0
						});

					var after = false,
						trunc = false;

					if ( conf.afterElement )
					{
						after = conf.afterElement.clone( true );
					    after.show();
						conf.afterElement.detach();
					}

					if ( test( $inr, opts ) )
					{
						if ( opts.wrap == 'children' )
						{
							trunc = children( $inr, opts, after );
						}
						else
						{
							trunc = ellipsis( $inr, $dot, $inr, opts, after );
						}
					}
					$inr.replaceWith( $inr.contents() );
					$inr = null;

					if ( $.isFunction( opts.callback ) )
					{
						opts.callback.call( $dot[ 0 ], trunc, orgContent );
					}

					conf.isTruncated = trunc;
					return trunc;
				}

			).bind(
				'isTruncated.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], conf.isTruncated );
					}
					return conf.isTruncated;
				}

			).bind(
				'originalContent.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], orgContent );
					}
					return orgContent;
				}

			).bind(
				'destroy.dot',
				function( e )
				{
					e.preventDefault();
					e.stopPropagation();

					$dot.unwatch()
						.unbind_events()
						.contents()
						.detach()
						.end()
						.append( orgContent )
						.attr( 'style', $dot.data( 'dotdotdot-style' ) || '' )
						.data( 'dotdotdot', false );
				}
			);
			return $dot;
		};	//	/bind_events

		$dot.unbind_events = function()
		{
			$dot.unbind('.dot');
			return $dot;
		};	//	/unbind_events

		$dot.watch = function()
		{
			$dot.unwatch();
			if ( opts.watch == 'window' )
			{
				var $window = $(window),
					_wWidth = $window.width(),
					_wHeight = $window.height();

				$window.bind(
					'resize.dot' + conf.dotId,
					function()
					{
						if ( _wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix )
						{
							_wWidth = $window.width();
							_wHeight = $window.height();

							if ( watchInt )
							{
								clearInterval( watchInt );
							}
							watchInt = setTimeout(
								function()
								{
									$dot.trigger( 'update.dot' );
								}, 100
							);
						}
					}
				);
			}
			else
			{
				watchOrg = getSizes( $dot );
				watchInt = setInterval(
					function()
					{
						if ( $dot.is( ':visible' ) )
						{
							var watchNew = getSizes( $dot );
							if ( watchOrg.width  != watchNew.width ||
								 watchOrg.height != watchNew.height )
							{
								$dot.trigger( 'update.dot' );
								watchOrg = watchNew;
							}
						}
					}, 500
				);
			}
			return $dot;
		};
		$dot.unwatch = function()
		{
			$(window).unbind( 'resize.dot' + conf.dotId );
			if ( watchInt )
			{
				clearInterval( watchInt );
			}
			return $dot;
		};

		var	orgContent	= $dot.contents(),
			opts 		= $.extend( true, {}, $.fn.dotdotdot.defaults, o ),
			conf		= {},
			watchOrg	= {},
			watchInt	= null,
			$inr		= null;


		if ( !( opts.lastCharacter.remove instanceof Array ) )
		{
			opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
		}
		if ( !( opts.lastCharacter.noEllipsis instanceof Array ) )
		{
			opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
		}


		conf.afterElement	= getElement( opts.after, $dot );
		conf.isTruncated	= false;
		conf.dotId			= dotId++;


		$dot.data( 'dotdotdot', true )
			.bind_events()
			.trigger( 'update.dot' );

		if ( opts.watch )
		{
			$dot.watch();
		}

		return $dot;
	};


	//	public
	$.fn.dotdotdot.defaults = {
		'ellipsis'			: '... ',
		'wrap'				: 'word',
		'fallbackToLetter'	: true,
		'lastCharacter'		: {},
		'tolerance'			: 0,
		'callback'			: null,
		'after'				: null,
		'height'			: null,
		'watch'				: false,
		'windowResizeFix'	: true
	};
	$.fn.dotdotdot.defaultArrays = {
		'lastCharacter'		: {
			'remove'			: [ ' ', '\u3000', ',', ';', '.', '!', '?' ],
			'noEllipsis'		: []
		}
	};
	$.fn.dotdotdot.debug = function( msg ) {};


	//	private
	var dotId = 1;

	function children( $elem, o, after )
	{
		var $elements 	= $elem.children(),
			isTruncated	= false;

		$elem.empty();

		for ( var a = 0, l = $elements.length; a < l; a++ )
		{
			var $e = $elements.eq( a );
			$elem.append( $e );
			if ( after )
			{
				$elem.append( after );
			}
			if ( test( $elem, o ) )
			{
				$e.remove();
				isTruncated = true;
				break;
			}
			else
			{
				if ( after )
				{
					after.detach();
				}
			}
		}
		return isTruncated;
	}
	function ellipsis( $elem, $d, $i, o, after )
	{
		var isTruncated	= false;

		//	Don't put the ellipsis directly inside these elements
		var notx = 'table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';

		//	Don't remove these elements even if they are after the ellipsis
		var noty = 'script, .dotdotdot-keep';

		$elem
			.contents()
			.detach()
			.each(
				function()
				{

					var e	= this,
						$e	= $(e);

					if ( typeof e == 'undefined' || ( e.nodeType == 3 && $.trim( e.data ).length == 0 ) )
					{
						return true;
					}
					else if ( $e.is( noty ) )
					{
						$elem.append( $e );
					}
					else if ( isTruncated )
					{
						return true;
					}
					else
					{
						$elem.append( $e );
						if ( after )
						{
							$elem[ $elem.is( notx ) ? 'after' : 'append' ]( after );
						}
						if ( test( $i, o ) )
						{
							if ( e.nodeType == 3 ) // node is TEXT
							{
								isTruncated = ellipsisElement( $e, $d, $i, o, after );
							}
							else
							{
								isTruncated = ellipsis( $e, $d, $i, o, after );
							}

							if ( !isTruncated )
							{
								$e.detach();
								isTruncated = true;
							}
						}

						if ( !isTruncated )
						{
							if ( after )
							{
								after.detach();
							}
						}
					}
				}
			);

		return isTruncated;
	}
	function ellipsisElement( $e, $d, $i, o, after )
	{
		var e = $e[ 0 ];

		if ( !e )
		{
			return false;
		}

		var txt			= getTextContent( e ),
			space		= ( txt.indexOf(' ') !== -1 ) ? ' ' : '\u3000',
			separator	= ( o.wrap == 'letter' ) ? '' : space,
			textArr		= txt.split( separator ),
			position 	= -1,
			midPos		= -1,
			startPos	= 0,
			endPos		= textArr.length - 1;


		//	Only one word
		if ( o.fallbackToLetter && startPos == 0 && endPos == 0 )
		{
			separator	= '';
			textArr		= txt.split( separator );
			endPos		= textArr.length - 1;
		}

		while ( startPos <= endPos && !( startPos == 0 && endPos == 0 ) )
		{
			var m = Math.floor( ( startPos + endPos ) / 2 );
			if ( m == midPos )
			{
				break;
			}
			midPos = m;

			setTextContent( e, textArr.slice( 0, midPos + 1 ).join( separator ) + o.ellipsis );

			if ( !test( $i, o ) )
			{
				position = midPos;
				startPos = midPos;
			}
			else
			{
				endPos = midPos;

				//	Fallback to letter
				if (o.fallbackToLetter && startPos == 0 && endPos == 0 )
				{
					separator	= '';
					textArr		= textArr[ 0 ].split( separator );
					position	= -1;
					midPos		= -1;
					startPos	= 0;
					endPos		= textArr.length - 1;
				}
			}
		}

		if ( position != -1 && !( textArr.length == 1 && textArr[ 0 ].length == 0 ) )
		{
			txt = addEllipsis( textArr.slice( 0, position + 1 ).join( separator ), o );
			setTextContent( e, txt );
		}
		else
		{
			var $w = $e.parent();
			$e.detach();

			var afterLength = ( after && after.closest($w).length ) ? after.length : 0;

			if ( $w.contents().length > afterLength )
			{
				e = findLastTextNode( $w.contents().eq( -1 - afterLength ), $d );
			}
			else
			{
				e = findLastTextNode( $w, $d, true );
				if ( !afterLength )
				{
					$w.detach();
				}
			}
			if ( e )
			{
				txt = addEllipsis( getTextContent( e ), o );
				setTextContent( e, txt );
				if ( afterLength && after )
				{
					$(e).parent().append( after );
				}
			}
		}

		return true;
	}
	function test( $i, o )
	{
		return $i.innerHeight() > o.maxHeight;
	}
	function addEllipsis( txt, o )
	{
		while( $.inArray( txt.slice( -1 ), o.lastCharacter.remove ) > -1 )
		{
			txt = txt.slice( 0, -1 );
		}
		if ( $.inArray( txt.slice( -1 ), o.lastCharacter.noEllipsis ) < 0 )
		{
			txt += o.ellipsis;
		}
		return txt;
	}
	function getSizes( $d )
	{
		return {
			'width'	: $d.innerWidth(),
			'height': $d.innerHeight()
		};
	}
	function setTextContent( e, content )
	{
		if ( e.innerText )
		{
			e.innerText = content;
		}
		else if ( e.nodeValue )
		{
			e.nodeValue = content;
		}
		else if (e.textContent)
		{
			e.textContent = content;
		}

	}
	function getTextContent( e )
	{
		if ( e.innerText )
		{
			return e.innerText;
		}
		else if ( e.nodeValue )
		{
			return e.nodeValue;
		}
		else if ( e.textContent )
		{
			return e.textContent;
		}
		else
		{
			return "";
		}
	}
	function getPrevNode( n )
	{
		do
		{
			n = n.previousSibling;
		}
		while ( n && n.nodeType !== 1 && n.nodeType !== 3 );

		return n;
	}
	function findLastTextNode( $el, $top, excludeCurrent )
	{
		var e = $el && $el[ 0 ], p;
		if ( e )
		{
			if ( !excludeCurrent )
			{
				if ( e.nodeType === 3 )
				{
					return e;
				}
				if ( $.trim( $el.text() ) )
				{
					return findLastTextNode( $el.contents().last(), $top );
				}
			}
			p = getPrevNode( e );
			while ( !p )
			{
				$el = $el.parent();
				if ( $el.is( $top ) || !$el.length )
				{
					return false;
				}
				p = getPrevNode( $el[0] );
			}
			if ( p )
			{
				return findLastTextNode( $(p), $top );
			}
		}
		return false;
	}
	function getElement( e, $i )
	{
		if ( !e )
		{
			return false;
		}
		if ( typeof e === 'string' )
		{
			e = $(e, $i);
			return ( e.length )
				? e
				: false;
		}
		return !e.jquery
			? false
			: e;
	}
	function getTrueInnerHeight( $el )
	{
		var h = $el.innerHeight(),
			a = [ 'paddingTop', 'paddingBottom' ];

		for ( var z = 0, l = a.length; z < l; z++ )
		{
			var m = parseInt( $el.css( a[ z ] ), 10 );
			if ( isNaN( m ) )
			{
				m = 0;
			}
			h -= m;
		}
		return h;
	}


	//	override jQuery.html
	var _orgHtml = $.fn.html;
	$.fn.html = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			return this.trigger( 'update', [ str ] );
		}
		return _orgHtml.apply( this, arguments );
	};


	//	override jQuery.text
	var _orgText = $.fn.text;
	$.fn.text = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			str = $( '<div />' ).text( str ).html();
			return this.trigger( 'update', [ str ] );
		}
		return _orgText.apply( this, arguments );
	};


})( jQuery );

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var $, cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlashAndSpace, hasTextSelected, luhnCheck, reFormatCVC, reFormatCardNumber, reFormatExpiry, reFormatNumeric, replaceFullWidthChars, restrictCVC, restrictCardNumber, restrictExpiry, restrictNumeric, safeVal, setCardType,
    __slice = [].slice,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  $ = window.jQuery || window.Zepto || window.$;

  $.payment = {};

  $.payment.fn = {};

  $.fn.payment = function() {
    var args, method;
    method = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    return $.payment.fn[method].apply(this, args);
  };

  defaultFormat = /(\d{1,4})/g;

  $.payment.cards = cards = [
    {
      type: 'maestro',
      patterns: [5018, 502, 503, 506, 56, 58, 639, 6220, 67],
      format: defaultFormat,
      length: [12, 13, 14, 15, 16, 17, 18, 19],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'forbrugsforeningen',
      patterns: [600],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'dankort',
      patterns: [5019],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'visa',
      patterns: [4],
      format: defaultFormat,
      length: [13, 16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'mastercard',
      patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'amex',
      patterns: [34, 37],
      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
      length: [15],
      cvcLength: [3, 4],
      luhn: true
    }, {
      type: 'dinersclub',
      patterns: [30, 36, 38, 39],
      format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
      length: [14],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'discover',
      patterns: [60, 64, 65, 622],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }, {
      type: 'unionpay',
      patterns: [62, 88],
      format: defaultFormat,
      length: [16, 17, 18, 19],
      cvcLength: [3],
      luhn: false
    }, {
      type: 'jcb',
      patterns: [35],
      format: defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    }
  ];

  cardFromNumber = function(num) {
    var card, p, pattern, _i, _j, _len, _len1, _ref;
    num = (num + '').replace(/\D/g, '');
    for (_i = 0, _len = cards.length; _i < _len; _i++) {
      card = cards[_i];
      _ref = card.patterns;
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        pattern = _ref[_j];
        p = pattern + '';
        if (num.substr(0, p.length) === p) {
          return card;
        }
      }
    }
  };

  cardFromType = function(type) {
    var card, _i, _len;
    for (_i = 0, _len = cards.length; _i < _len; _i++) {
      card = cards[_i];
      if (card.type === type) {
        return card;
      }
    }
  };

  luhnCheck = function(num) {
    var digit, digits, odd, sum, _i, _len;
    odd = true;
    sum = 0;
    digits = (num + '').split('').reverse();
    for (_i = 0, _len = digits.length; _i < _len; _i++) {
      digit = digits[_i];
      digit = parseInt(digit, 10);
      if ((odd = !odd)) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return sum % 10 === 0;
  };

  hasTextSelected = function($target) {
    var _ref;
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
      return true;
    }
    if ((typeof document !== "undefined" && document !== null ? (_ref = document.selection) != null ? _ref.createRange : void 0 : void 0) != null) {
      if (document.selection.createRange().text) {
        return true;
      }
    }
    return false;
  };

  safeVal = function(value, $target) {
    var currPair, cursor, digit, error, last, prevPair;
    try {
      cursor = $target.prop('selectionStart');
    } catch (_error) {
      error = _error;
      cursor = null;
    }
    last = $target.val();
    $target.val(value);
    if (cursor !== null && $target.is(":focus")) {
      if (cursor === last.length) {
        cursor = value.length;
      }
      if (last !== value) {
        prevPair = last.slice(cursor - 1, +cursor + 1 || 9e9);
        currPair = value.slice(cursor - 1, +cursor + 1 || 9e9);
        digit = value[cursor];
        if (/\d/.test(digit) && prevPair === ("" + digit + " ") && currPair === (" " + digit)) {
          cursor = cursor + 1;
        }
      }
      $target.prop('selectionStart', cursor);
      return $target.prop('selectionEnd', cursor);
    }
  };

  replaceFullWidthChars = function(str) {
    var chars, chr, fullWidth, halfWidth, idx, value, _i, _len;
    if (str == null) {
      str = '';
    }
    fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
    halfWidth = '0123456789';
    value = '';
    chars = str.split('');
    for (_i = 0, _len = chars.length; _i < _len; _i++) {
      chr = chars[_i];
      idx = fullWidth.indexOf(chr);
      if (idx > -1) {
        chr = halfWidth[idx];
      }
      value += chr;
    }
    return value;
  };

  reFormatNumeric = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = value.replace(/\D/g, '');
      return safeVal(value, $target);
    });
  };

  reFormatCardNumber = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = $.payment.formatCardNumber(value);
      return safeVal(value, $target);
    });
  };

  formatCardNumber = function(e) {
    var $target, card, digit, length, re, upperLength, value;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    $target = $(e.currentTarget);
    value = $target.val();
    card = cardFromNumber(value + digit);
    length = (value.replace(/\D/g, '') + digit).length;
    upperLength = 16;
    if (card) {
      upperLength = card.length[card.length.length - 1];
    }
    if (length >= upperLength) {
      return;
    }
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
      return;
    }
    if (card && card.type === 'amex') {
      re = /^(\d{4}|\d{4}\s\d{6})$/;
    } else {
      re = /(?:^|\s)(\d{4})$/;
    }
    if (re.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value + ' ' + digit);
      });
    } else if (re.test(value + digit)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value + digit + ' ');
      });
    }
  };

  formatBackCardNumber = function(e) {
    var $target, value;
    $target = $(e.currentTarget);
    value = $target.val();
    if (e.which !== 8) {
      return;
    }
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
      return;
    }
    if (/\d\s$/.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value.replace(/\d\s$/, ''));
      });
    } else if (/\s\d?$/.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value.replace(/\d$/, ''));
      });
    }
  };

  reFormatExpiry = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = $.payment.formatExpiry(value);
      return safeVal(value, $target);
    });
  };

  formatExpiry = function(e) {
    var $target, digit, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    $target = $(e.currentTarget);
    val = $target.val() + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val("0" + val + " / ");
      });
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      return setTimeout(function() {
        var m1, m2;
        m1 = parseInt(val[0], 10);
        m2 = parseInt(val[1], 10);
        if (m2 > 2 && m1 !== 0) {
          return $target.val("0" + m1 + " / " + m2);
        } else {
          return $target.val("" + val + " / ");
        }
      });
    }
  };

  formatForwardExpiry = function(e) {
    var $target, digit, val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    $target = $(e.currentTarget);
    val = $target.val();
    if (/^\d\d$/.test(val)) {
      return $target.val("" + val + " / ");
    }
  };

  formatForwardSlashAndSpace = function(e) {
    var $target, val, which;
    which = String.fromCharCode(e.which);
    if (!(which === '/' || which === ' ')) {
      return;
    }
    $target = $(e.currentTarget);
    val = $target.val();
    if (/^\d$/.test(val) && val !== '0') {
      return $target.val("0" + val + " / ");
    }
  };

  formatBackExpiry = function(e) {
    var $target, value;
    $target = $(e.currentTarget);
    value = $target.val();
    if (e.which !== 8) {
      return;
    }
    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
      return;
    }
    if (/\d\s\/\s$/.test(value)) {
      e.preventDefault();
      return setTimeout(function() {
        return $target.val(value.replace(/\d\s\/\s$/, ''));
      });
    }
  };

  reFormatCVC = function(e) {
    var $target;
    $target = $(e.currentTarget);
    return setTimeout(function() {
      var value;
      value = $target.val();
      value = replaceFullWidthChars(value);
      value = value.replace(/\D/g, '').slice(0, 4);
      return safeVal(value, $target);
    });
  };

  restrictNumeric = function(e) {
    var input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  };

  restrictCardNumber = function(e) {
    var $target, card, digit, value;
    $target = $(e.currentTarget);
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected($target)) {
      return;
    }
    value = ($target.val() + digit).replace(/\D/g, '');
    card = cardFromNumber(value);
    if (card) {
      return value.length <= card.length[card.length.length - 1];
    } else {
      return value.length <= 16;
    }
  };

  restrictExpiry = function(e) {
    var $target, digit, value;
    $target = $(e.currentTarget);
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected($target)) {
      return;
    }
    value = $target.val() + digit;
    value = value.replace(/\D/g, '');
    if (value.length > 6) {
      return false;
    }
  };

  restrictCVC = function(e) {
    var $target, digit, val;
    $target = $(e.currentTarget);
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit)) {
      return;
    }
    if (hasTextSelected($target)) {
      return;
    }
    val = $target.val() + digit;
    return val.length <= 4;
  };

  setCardType = function(e) {
    var $target, allTypes, card, cardType, val;
    $target = $(e.currentTarget);
    val = $target.val();
    cardType = $.payment.cardType(val) || 'unknown';
    if (!$target.hasClass(cardType)) {
      allTypes = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = cards.length; _i < _len; _i++) {
          card = cards[_i];
          _results.push(card.type);
        }
        return _results;
      })();
      $target.removeClass('unknown');
      $target.removeClass(allTypes.join(' '));
      $target.addClass(cardType);
      $target.toggleClass('identified', cardType !== 'unknown');
      return $target.trigger('payment.cardType', cardType);
    }
  };

  $.payment.fn.formatCardCVC = function() {
    this.on('keypress', restrictNumeric);
    this.on('keypress', restrictCVC);
    this.on('paste', reFormatCVC);
    this.on('change', reFormatCVC);
    this.on('input', reFormatCVC);
    return this;
  };

  $.payment.fn.formatCardExpiry = function() {
    this.on('keypress', restrictNumeric);
    this.on('keypress', restrictExpiry);
    this.on('keypress', formatExpiry);
    this.on('keypress', formatForwardSlashAndSpace);
    this.on('keypress', formatForwardExpiry);
    this.on('keydown', formatBackExpiry);
    this.on('change', reFormatExpiry);
    this.on('input', reFormatExpiry);
    return this;
  };

  $.payment.fn.formatCardNumber = function() {
    this.on('keypress', restrictNumeric);
    this.on('keypress', restrictCardNumber);
    this.on('keypress', formatCardNumber);
    this.on('keydown', formatBackCardNumber);
    this.on('keyup', setCardType);
    this.on('paste', reFormatCardNumber);
    this.on('change', reFormatCardNumber);
    this.on('input', reFormatCardNumber);
    this.on('input', setCardType);
    return this;
  };

  $.payment.fn.restrictNumeric = function() {
    this.on('keypress', restrictNumeric);
    this.on('paste', reFormatNumeric);
    this.on('change', reFormatNumeric);
    this.on('input', reFormatNumeric);
    return this;
  };

  $.payment.fn.cardExpiryVal = function() {
    return $.payment.cardExpiryVal($(this).val());
  };

  $.payment.cardExpiryVal = function(value) {
    var month, prefix, year, _ref;
    _ref = value.split(/[\s\/]+/, 2), month = _ref[0], year = _ref[1];
    if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
      prefix = (new Date).getFullYear();
      prefix = prefix.toString().slice(0, 2);
      year = prefix + year;
    }
    month = parseInt(month, 10);
    year = parseInt(year, 10);
    return {
      month: month,
      year: year
    };
  };

  $.payment.validateCardNumber = function(num) {
    var card, _ref;
    num = (num + '').replace(/\s+|-/g, '');
    if (!/^\d+$/.test(num)) {
      return false;
    }
    card = cardFromNumber(num);
    if (!card) {
      return false;
    }
    return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || luhnCheck(num));
  };

  $.payment.validateCardExpiry = function(month, year) {
    var currentTime, expiry, _ref;
    if (typeof month === 'object' && 'month' in month) {
      _ref = month, month = _ref.month, year = _ref.year;
    }
    if (!(month && year)) {
      return false;
    }
    month = $.trim(month);
    year = $.trim(year);
    if (!/^\d+$/.test(month)) {
      return false;
    }
    if (!/^\d+$/.test(year)) {
      return false;
    }
    if (!((1 <= month && month <= 12))) {
      return false;
    }
    if (year.length === 2) {
      if (year < 70) {
        year = "20" + year;
      } else {
        year = "19" + year;
      }
    }
    if (year.length !== 4) {
      return false;
    }
    expiry = new Date(year, month);
    currentTime = new Date;
    expiry.setMonth(expiry.getMonth() - 1);
    expiry.setMonth(expiry.getMonth() + 1, 1);
    return expiry > currentTime;
  };

  $.payment.validateCardCVC = function(cvc, type) {
    var card, _ref;
    cvc = $.trim(cvc);
    if (!/^\d+$/.test(cvc)) {
      return false;
    }
    card = cardFromType(type);
    if (card != null) {
      return _ref = cvc.length, __indexOf.call(card.cvcLength, _ref) >= 0;
    } else {
      return cvc.length >= 3 && cvc.length <= 4;
    }
  };

  $.payment.cardType = function(num) {
    var _ref;
    if (!num) {
      return null;
    }
    return ((_ref = cardFromNumber(num)) != null ? _ref.type : void 0) || null;
  };

  $.payment.formatCardNumber = function(num) {
    var card, groups, upperLength, _ref;
    num = num.replace(/\D/g, '');
    card = cardFromNumber(num);
    if (!card) {
      return num;
    }
    upperLength = card.length[card.length.length - 1];
    num = num.slice(0, upperLength);
    if (card.format.global) {
      return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
    } else {
      groups = card.format.exec(num);
      if (groups == null) {
        return;
      }
      groups.shift();
      groups = $.grep(groups, function(n) {
        return n;
      });
      return groups.join(' ');
    }
  };

  $.payment.formatExpiry = function(expiry) {
    var mon, parts, sep, year;
    parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
    if (!parts) {
      return '';
    }
    mon = parts[1] || '';
    sep = parts[2] || '';
    year = parts[3] || '';
    if (year.length > 0) {
      sep = ' / ';
    } else if (sep === ' /') {
      mon = mon.substring(0, 1);
      sep = '';
    } else if (mon.length === 2 || sep.length > 0) {
      sep = ' / ';
    } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
      mon = "0" + mon;
      sep = ' / ';
    }
    return mon + sep + year;
  };

}).call(this);


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 * Mailcheck https://github.com/mailcheck/mailcheck
 * Author
 * Derrick Ko (@derrickko)
 *
 * Released under the MIT License.
 *
 * v 1.1.0
 */

var Mailcheck = {
  domainThreshold: 4,
  topLevelThreshold: 3,

  defaultDomains: ["yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com",
    "live.com", "comcast.net", "googlemail.com", "msn.com", "hotmail.co.uk", "yahoo.co.uk",
    "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "gmx.com", "mail.com", "outlook.com", "icloud.com"],

  defaultTopLevelDomains: ["co.jp", "co.uk", "com", "net", "org", "info", "edu", "gov", "mil", "ca"],

  run: function(opts) {
    opts.domains = opts.domains || Mailcheck.defaultDomains;
    opts.topLevelDomains = opts.topLevelDomains || Mailcheck.defaultTopLevelDomains;
    opts.distanceFunction = opts.distanceFunction || Mailcheck.sift3Distance;

    var defaultCallback = function(result){ return result };
    var suggestedCallback = opts.suggested || defaultCallback;
    var emptyCallback = opts.empty || defaultCallback;

    var result = Mailcheck.suggest(Mailcheck.encodeEmail(opts.email), opts.domains, opts.topLevelDomains, opts.distanceFunction);

    return result ? suggestedCallback(result) : emptyCallback()
  },

  suggest: function(email, domains, topLevelDomains, distanceFunction) {
    email = email.toLowerCase();

    var emailParts = this.splitEmail(email);

    var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);

    if (closestDomain) {
      if (closestDomain != emailParts.domain) {
        // The email address closely matches one of the supplied domains; return a suggestion
        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
      }
    } else {
      // The email address does not closely match one of the supplied domains
      var closestTopLevelDomain = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);
      if (emailParts.domain && closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
        // The email address may have a mispelled top-level domain; return a suggestion
        var domain = emailParts.domain;
        closestDomain = domain.substring(0, domain.lastIndexOf(emailParts.topLevelDomain)) + closestTopLevelDomain;
        return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
      }
    }
    /* The email address exactly matches one of the supplied domains, does not closely
     * match any domain and does not appear to simply have a mispelled top-level domain,
     * or is an invalid email address; do not return a suggestion.
     */
    return false;
  },

  findClosestDomain: function(domain, domains, distanceFunction, threshold) {
    threshold = threshold || this.topLevelThreshold;
    var dist;
    var minDist = 99;
    var closestDomain = null;

    if (!domain || !domains) {
      return false;
    }
    if(!distanceFunction) {
      distanceFunction = this.sift3Distance;
    }

    for (var i = 0; i < domains.length; i++) {
      if (domain === domains[i]) {
        return domain;
      }
      dist = distanceFunction(domain, domains[i]);
      if (dist < minDist) {
        minDist = dist;
        closestDomain = domains[i];
      }
    }

    if (minDist <= threshold && closestDomain !== null) {
      return closestDomain;
    } else {
      return false;
    }
  },

  sift3Distance: function(s1, s2) {
    // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
    if (s1 == null || s1.length === 0) {
      if (s2 == null || s2.length === 0) {
        return 0;
      } else {
        return s2.length;
      }
    }

    if (s2 == null || s2.length === 0) {
      return s1.length;
    }

    var c = 0;
    var offset1 = 0;
    var offset2 = 0;
    var lcs = 0;
    var maxOffset = 5;

    while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
      if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
        lcs++;
      } else {
        offset1 = 0;
        offset2 = 0;
        for (var i = 0; i < maxOffset; i++) {
          if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
            offset1 = i;
            break;
          }
          if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
            offset2 = i;
            break;
          }
        }
      }
      c++;
    }
    return (s1.length + s2.length) /2 - lcs;
  },

  splitEmail: function(email) {
    var parts = email.trim().split('@');

    if (parts.length < 2) {
      return false;
    }

    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === '') {
        return false;
      }
    }

    var domain = parts.pop();
    var domainParts = domain.split('.');
    var tld = '';

    if (domainParts.length == 0) {
      // The address does not have a top-level domain
      return false;
    } else if (domainParts.length == 1) {
      // The address has only a top-level domain (valid under RFC)
      tld = domainParts[0];
    } else {
      // The address has a domain and a top-level domain
      for (var i = 1; i < domainParts.length; i++) {
        tld += domainParts[i] + '.';
      }
      if (domainParts.length >= 2) {
        tld = tld.substring(0, tld.length - 1);
      }
    }

    return {
      topLevelDomain: tld,
      domain: domain,
      address: parts.join('@')
    }
  },

  // Encode the email address to prevent XSS but leave in valid
  // characters, following this official spec:
  // http://en.wikipedia.org/wiki/Email_address#Syntax
  encodeEmail: function(email) {
    var result = encodeURI(email);
    result = result.replace('%20', ' ').replace('%25', '%').replace('%5E', '^')
                   .replace('%60', '`').replace('%7B', '{').replace('%7C', '|')
                   .replace('%7D', '}');
    return result;
  }
};

// Export the mailcheck object if we're in a CommonJS env (e.g. Node).
// Modeled off of Underscore.js.
if (typeof module !== 'undefined' && module.exports) {
    module.exports = Mailcheck;
}

if (typeof window !== 'undefined' && window.jQuery) {
  (function($){
    $.fn.mailcheck = function(opts) {
      var self = this;
      if (opts.suggested) {
        var oldSuggested = opts.suggested;
        opts.suggested = function(result) {
          oldSuggested(self, result);
        };
      }

      if (opts.empty) {
        var oldEmpty = opts.empty;
        opts.empty = function() {
          oldEmpty.call(null, self);
        };
      }

      opts.email = this.val();
      Mailcheck.run(opts);
    }
  })(jQuery);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2014 Rico Sta. Cruz
 * MIT Licensed.
 *
 * http://ricostacruz.com/jquery.transit
 * http://github.com/rstacruz/jquery.transit
 */

/* jshint expr: true */

;(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    factory(root.jQuery);
  }

}(this, function($) {

  $.transit = {
    version: "0.9.12",

    // Map of $.css() keys to values for 'transitionProperty'.
    // See https://developer.mozilla.org/en/CSS/CSS_transitions#Properties_that_can_be_animated
    propertyMap: {
      marginLeft    : 'margin',
      marginRight   : 'margin',
      marginBottom  : 'margin',
      marginTop     : 'margin',
      paddingLeft   : 'padding',
      paddingRight  : 'padding',
      paddingBottom : 'padding',
      paddingTop    : 'padding'
    },

    // Will simply transition "instantly" if false
    enabled: true,

    // Set this to false if you don't want to use the transition end property.
    useTransitionEnd: false
  };

  var div = document.createElement('div');
  var support = {};

  // Helper function to get the proper vendor property name.
  // (`transition` => `WebkitTransition`)
  function getVendorPropertyName(prop) {
    // Handle unprefixed versions (FF16+, for example)
    if (prop in div.style) return prop;

    var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
    var prop_ = prop.charAt(0).toUpperCase() + prop.substr(1);

    for (var i=0; i<prefixes.length; ++i) {
      var vendorProp = prefixes[i] + prop_;
      if (vendorProp in div.style) { return vendorProp; }
    }
  }

  // Helper function to check if transform3D is supported.
  // Should return true for Webkits and Firefox 10+.
  function checkTransform3dSupport() {
    div.style[support.transform] = '';
    div.style[support.transform] = 'rotateY(90deg)';
    return div.style[support.transform] !== '';
  }

  var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

  // Check for the browser's transitions support.
  support.transition      = getVendorPropertyName('transition');
  support.transitionDelay = getVendorPropertyName('transitionDelay');
  support.transform       = getVendorPropertyName('transform');
  support.transformOrigin = getVendorPropertyName('transformOrigin');
  support.filter          = getVendorPropertyName('Filter');
  support.transform3d     = checkTransform3dSupport();

  var eventNames = {
    'transition':       'transitionend',
    'MozTransition':    'transitionend',
    'OTransition':      'oTransitionEnd',
    'WebkitTransition': 'webkitTransitionEnd',
    'msTransition':     'MSTransitionEnd'
  };

  // Detect the 'transitionend' event needed.
  var transitionEnd = support.transitionEnd = eventNames[support.transition] || null;

  // Populate jQuery's `$.support` with the vendor prefixes we know.
  // As per [jQuery's cssHooks documentation](http://api.jquery.com/jQuery.cssHooks/),
  // we set $.support.transition to a string of the actual property name used.
  for (var key in support) {
    if (support.hasOwnProperty(key) && typeof $.support[key] === 'undefined') {
      $.support[key] = support[key];
    }
  }

  // Avoid memory leak in IE.
  div = null;

  // ## $.cssEase
  // List of easing aliases that you can use with `$.fn.transition`.
  $.cssEase = {
    '_default':       'ease',
    'in':             'ease-in',
    'out':            'ease-out',
    'in-out':         'ease-in-out',
    'snap':           'cubic-bezier(0,1,.5,1)',
    // Penner equations
    'easeInCubic':    'cubic-bezier(.550,.055,.675,.190)',
    'easeOutCubic':   'cubic-bezier(.215,.61,.355,1)',
    'easeInOutCubic': 'cubic-bezier(.645,.045,.355,1)',
    'easeInCirc':     'cubic-bezier(.6,.04,.98,.335)',
    'easeOutCirc':    'cubic-bezier(.075,.82,.165,1)',
    'easeInOutCirc':  'cubic-bezier(.785,.135,.15,.86)',
    'easeInExpo':     'cubic-bezier(.95,.05,.795,.035)',
    'easeOutExpo':    'cubic-bezier(.19,1,.22,1)',
    'easeInOutExpo':  'cubic-bezier(1,0,0,1)',
    'easeInQuad':     'cubic-bezier(.55,.085,.68,.53)',
    'easeOutQuad':    'cubic-bezier(.25,.46,.45,.94)',
    'easeInOutQuad':  'cubic-bezier(.455,.03,.515,.955)',
    'easeInQuart':    'cubic-bezier(.895,.03,.685,.22)',
    'easeOutQuart':   'cubic-bezier(.165,.84,.44,1)',
    'easeInOutQuart': 'cubic-bezier(.77,0,.175,1)',
    'easeInQuint':    'cubic-bezier(.755,.05,.855,.06)',
    'easeOutQuint':   'cubic-bezier(.23,1,.32,1)',
    'easeInOutQuint': 'cubic-bezier(.86,0,.07,1)',
    'easeInSine':     'cubic-bezier(.47,0,.745,.715)',
    'easeOutSine':    'cubic-bezier(.39,.575,.565,1)',
    'easeInOutSine':  'cubic-bezier(.445,.05,.55,.95)',
    'easeInBack':     'cubic-bezier(.6,-.28,.735,.045)',
    'easeOutBack':    'cubic-bezier(.175, .885,.32,1.275)',
    'easeInOutBack':  'cubic-bezier(.68,-.55,.265,1.55)'
  };

  // ## 'transform' CSS hook
  // Allows you to use the `transform` property in CSS.
  //
  //     $("#hello").css({ transform: "rotate(90deg)" });
  //
  //     $("#hello").css('transform');
  //     //=> { rotate: '90deg' }
  //
  $.cssHooks['transit:transform'] = {
    // The getter returns a `Transform` object.
    get: function(elem) {
      return $(elem).data('transform') || new Transform();
    },

    // The setter accepts a `Transform` object or a string.
    set: function(elem, v) {
      var value = v;

      if (!(value instanceof Transform)) {
        value = new Transform(value);
      }

      // We've seen the 3D version of Scale() not work in Chrome when the
      // element being scaled extends outside of the viewport.  Thus, we're
      // forcing Chrome to not use the 3d transforms as well.  Not sure if
      // translate is affectede, but not risking it.  Detection code from
      // http://davidwalsh.name/detecting-google-chrome-javascript
      if (support.transform === 'WebkitTransform' && !isChrome) {
        elem.style[support.transform] = value.toString(true);
      } else {
        elem.style[support.transform] = value.toString();
      }

      $(elem).data('transform', value);
    }
  };

  // Add a CSS hook for `.css({ transform: '...' })`.
  // In jQuery 1.8+, this will intentionally override the default `transform`
  // CSS hook so it'll play well with Transit. (see issue #62)
  $.cssHooks.transform = {
    set: $.cssHooks['transit:transform'].set
  };

  // ## 'filter' CSS hook
  // Allows you to use the `filter` property in CSS.
  //
  //     $("#hello").css({ filter: 'blur(10px)' });
  //
  $.cssHooks.filter = {
    get: function(elem) {
      return elem.style[support.filter];
    },
    set: function(elem, value) {
      elem.style[support.filter] = value;
    }
  };

  // jQuery 1.8+ supports prefix-free transitions, so these polyfills will not
  // be necessary.
  if ($.fn.jquery < "1.8") {
    // ## 'transformOrigin' CSS hook
    // Allows the use for `transformOrigin` to define where scaling and rotation
    // is pivoted.
    //
    //     $("#hello").css({ transformOrigin: '0 0' });
    //
    $.cssHooks.transformOrigin = {
      get: function(elem) {
        return elem.style[support.transformOrigin];
      },
      set: function(elem, value) {
        elem.style[support.transformOrigin] = value;
      }
    };

    // ## 'transition' CSS hook
    // Allows you to use the `transition` property in CSS.
    //
    //     $("#hello").css({ transition: 'all 0 ease 0' });
    //
    $.cssHooks.transition = {
      get: function(elem) {
        return elem.style[support.transition];
      },
      set: function(elem, value) {
        elem.style[support.transition] = value;
      }
    };
  }

  // ## Other CSS hooks
  // Allows you to rotate, scale and translate.
  registerCssHook('scale');
  registerCssHook('scaleX');
  registerCssHook('scaleY');
  registerCssHook('translate');
  registerCssHook('rotate');
  registerCssHook('rotateX');
  registerCssHook('rotateY');
  registerCssHook('rotate3d');
  registerCssHook('perspective');
  registerCssHook('skewX');
  registerCssHook('skewY');
  registerCssHook('x', true);
  registerCssHook('y', true);

  // ## Transform class
  // This is the main class of a transformation property that powers
  // `$.fn.css({ transform: '...' })`.
  //
  // This is, in essence, a dictionary object with key/values as `-transform`
  // properties.
  //
  //     var t = new Transform("rotate(90) scale(4)");
  //
  //     t.rotate             //=> "90deg"
  //     t.scale              //=> "4,4"
  //
  // Setters are accounted for.
  //
  //     t.set('rotate', 4)
  //     t.rotate             //=> "4deg"
  //
  // Convert it to a CSS string using the `toString()` and `toString(true)` (for WebKit)
  // functions.
  //
  //     t.toString()         //=> "rotate(90deg) scale(4,4)"
  //     t.toString(true)     //=> "rotate(90deg) scale3d(4,4,0)" (WebKit version)
  //
  function Transform(str) {
    if (typeof str === 'string') { this.parse(str); }
    return this;
  }

  Transform.prototype = {
    // ### setFromString()
    // Sets a property from a string.
    //
    //     t.setFromString('scale', '2,4');
    //     // Same as set('scale', '2', '4');
    //
    setFromString: function(prop, val) {
      var args =
        (typeof val === 'string')  ? val.split(',') :
        (val.constructor === Array) ? val :
        [ val ];

      args.unshift(prop);

      Transform.prototype.set.apply(this, args);
    },

    // ### set()
    // Sets a property.
    //
    //     t.set('scale', 2, 4);
    //
    set: function(prop) {
      var args = Array.prototype.slice.apply(arguments, [1]);
      if (this.setter[prop]) {
        this.setter[prop].apply(this, args);
      } else {
        this[prop] = args.join(',');
      }
    },

    get: function(prop) {
      if (this.getter[prop]) {
        return this.getter[prop].apply(this);
      } else {
        return this[prop] || 0;
      }
    },

    setter: {
      // ### rotate
      //
      //     .css({ rotate: 30 })
      //     .css({ rotate: "30" })
      //     .css({ rotate: "30deg" })
      //     .css({ rotate: "30deg" })
      //
      rotate: function(theta) {
        this.rotate = unit(theta, 'deg');
      },

      rotateX: function(theta) {
        this.rotateX = unit(theta, 'deg');
      },

      rotateY: function(theta) {
        this.rotateY = unit(theta, 'deg');
      },

      // ### scale
      //
      //     .css({ scale: 9 })      //=> "scale(9,9)"
      //     .css({ scale: '3,2' })  //=> "scale(3,2)"
      //
      scale: function(x, y) {
        if (y === undefined) { y = x; }
        this.scale = x + "," + y;
      },

      // ### skewX + skewY
      skewX: function(x) {
        this.skewX = unit(x, 'deg');
      },

      skewY: function(y) {
        this.skewY = unit(y, 'deg');
      },

      // ### perspectvie
      perspective: function(dist) {
        this.perspective = unit(dist, 'px');
      },

      // ### x / y
      // Translations. Notice how this keeps the other value.
      //
      //     .css({ x: 4 })       //=> "translate(4px, 0)"
      //     .css({ y: 10 })      //=> "translate(4px, 10px)"
      //
      x: function(x) {
        this.set('translate', x, null);
      },

      y: function(y) {
        this.set('translate', null, y);
      },

      // ### translate
      // Notice how this keeps the other value.
      //
      //     .css({ translate: '2, 5' })    //=> "translate(2px, 5px)"
      //
      translate: function(x, y) {
        if (this._translateX === undefined) { this._translateX = 0; }
        if (this._translateY === undefined) { this._translateY = 0; }

        if (x !== null && x !== undefined) { this._translateX = unit(x, 'px'); }
        if (y !== null && y !== undefined) { this._translateY = unit(y, 'px'); }

        this.translate = this._translateX + "," + this._translateY;
      }
    },

    getter: {
      x: function() {
        return this._translateX || 0;
      },

      y: function() {
        return this._translateY || 0;
      },

      scale: function() {
        var s = (this.scale || "1,1").split(',');
        if (s[0]) { s[0] = parseFloat(s[0]); }
        if (s[1]) { s[1] = parseFloat(s[1]); }

        // "2.5,2.5" => 2.5
        // "2.5,1" => [2.5,1]
        return (s[0] === s[1]) ? s[0] : s;
      },

      rotate3d: function() {
        var s = (this.rotate3d || "0,0,0,0deg").split(',');
        for (var i=0; i<=3; ++i) {
          if (s[i]) { s[i] = parseFloat(s[i]); }
        }
        if (s[3]) { s[3] = unit(s[3], 'deg'); }

        return s;
      }
    },

    // ### parse()
    // Parses from a string. Called on constructor.
    parse: function(str) {
      var self = this;
      str.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function(x, prop, val) {
        self.setFromString(prop, val);
      });
    },

    // ### toString()
    // Converts to a `transition` CSS property string. If `use3d` is given,
    // it converts to a `-webkit-transition` CSS property string instead.
    toString: function(use3d) {
      var re = [];

      for (var i in this) {
        if (this.hasOwnProperty(i)) {
          // Don't use 3D transformations if the browser can't support it.
          if ((!support.transform3d) && (
            (i === 'rotateX') ||
            (i === 'rotateY') ||
            (i === 'perspective') ||
            (i === 'transformOrigin'))) { continue; }

          if (i[0] !== '_') {
            if (use3d && (i === 'scale')) {
              re.push(i + "3d(" + this[i] + ",1)");
            } else if (use3d && (i === 'translate')) {
              re.push(i + "3d(" + this[i] + ",0)");
            } else {
              re.push(i + "(" + this[i] + ")");
            }
          }
        }
      }

      return re.join(" ");
    }
  };

  function callOrQueue(self, queue, fn) {
    if (queue === true) {
      self.queue(fn);
    } else if (queue) {
      self.queue(queue, fn);
    } else {
      self.each(function () {
                fn.call(this);
            });
    }
  }

  // ### getProperties(dict)
  // Returns properties (for `transition-property`) for dictionary `props`. The
  // value of `props` is what you would expect in `$.css(...)`.
  function getProperties(props) {
    var re = [];

    $.each(props, function(key) {
      key = $.camelCase(key); // Convert "text-align" => "textAlign"
      key = $.transit.propertyMap[key] || $.cssProps[key] || key;
      key = uncamel(key); // Convert back to dasherized

      // Get vendor specify propertie
      if (support[key])
        key = uncamel(support[key]);

      if ($.inArray(key, re) === -1) { re.push(key); }
    });

    return re;
  }

  // ### getTransition()
  // Returns the transition string to be used for the `transition` CSS property.
  //
  // Example:
  //
  //     getTransition({ opacity: 1, rotate: 30 }, 500, 'ease');
  //     //=> 'opacity 500ms ease, -webkit-transform 500ms ease'
  //
  function getTransition(properties, duration, easing, delay) {
    // Get the CSS properties needed.
    var props = getProperties(properties);

    // Account for aliases (`in` => `ease-in`).
    if ($.cssEase[easing]) { easing = $.cssEase[easing]; }

    // Build the duration/easing/delay attributes for it.
    var attribs = '' + toMS(duration) + ' ' + easing;
    if (parseInt(delay, 10) > 0) { attribs += ' ' + toMS(delay); }

    // For more properties, add them this way:
    // "margin 200ms ease, padding 200ms ease, ..."
    var transitions = [];
    $.each(props, function(i, name) {
      transitions.push(name + ' ' + attribs);
    });

    return transitions.join(', ');
  }

  // ## $.fn.transition
  // Works like $.fn.animate(), but uses CSS transitions.
  //
  //     $("...").transition({ opacity: 0.1, scale: 0.3 });
  //
  //     // Specific duration
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500);
  //
  //     // With duration and easing
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in');
  //
  //     // With callback
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, function() { ... });
  //
  //     // With everything
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in', function() { ... });
  //
  //     // Alternate syntax
  //     $("...").transition({
  //       opacity: 0.1,
  //       duration: 200,
  //       delay: 40,
  //       easing: 'in',
  //       complete: function() { /* ... */ }
  //      });
  //
  $.fn.transition = $.fn.transit = function(properties, duration, easing, callback) {
    var self  = this;
    var delay = 0;
    var queue = true;

    var theseProperties = $.extend(true, {}, properties);

    // Account for `.transition(properties, callback)`.
    if (typeof duration === 'function') {
      callback = duration;
      duration = undefined;
    }

    // Account for `.transition(properties, options)`.
    if (typeof duration === 'object') {
      easing = duration.easing;
      delay = duration.delay || 0;
      queue = typeof duration.queue === "undefined" ? true : duration.queue;
      callback = duration.complete;
      duration = duration.duration;
    }

    // Account for `.transition(properties, duration, callback)`.
    if (typeof easing === 'function') {
      callback = easing;
      easing = undefined;
    }

    // Alternate syntax.
    if (typeof theseProperties.easing !== 'undefined') {
      easing = theseProperties.easing;
      delete theseProperties.easing;
    }

    if (typeof theseProperties.duration !== 'undefined') {
      duration = theseProperties.duration;
      delete theseProperties.duration;
    }

    if (typeof theseProperties.complete !== 'undefined') {
      callback = theseProperties.complete;
      delete theseProperties.complete;
    }

    if (typeof theseProperties.queue !== 'undefined') {
      queue = theseProperties.queue;
      delete theseProperties.queue;
    }

    if (typeof theseProperties.delay !== 'undefined') {
      delay = theseProperties.delay;
      delete theseProperties.delay;
    }

    // Set defaults. (`400` duration, `ease` easing)
    if (typeof duration === 'undefined') { duration = $.fx.speeds._default; }
    if (typeof easing === 'undefined')   { easing = $.cssEase._default; }

    duration = toMS(duration);

    // Build the `transition` property.
    var transitionValue = getTransition(theseProperties, duration, easing, delay);

    // Compute delay until callback.
    // If this becomes 0, don't bother setting the transition property.
    var work = $.transit.enabled && support.transition;
    var i = work ? (parseInt(duration, 10) + parseInt(delay, 10)) : 0;

    // If there's nothing to do...
    if (i === 0) {
      var fn = function(next) {
        self.css(theseProperties);
        if (callback) { callback.apply(self); }
        if (next) { next(); }
      };

      callOrQueue(self, queue, fn);
      return self;
    }

    // Save the old transitions of each element so we can restore it later.
    var oldTransitions = {};

    var run = function(nextCall) {
      var bound = false;

      // Prepare the callback.
      var cb = function() {
        if (bound) { self.unbind(transitionEnd, cb); }

        if (i > 0) {
          self.each(function() {
            this.style[support.transition] = (oldTransitions[this] || null);
          });
        }

        if (typeof callback === 'function') { callback.apply(self); }
        if (typeof nextCall === 'function') { nextCall(); }
      };

      if ((i > 0) && (transitionEnd) && ($.transit.useTransitionEnd)) {
        // Use the 'transitionend' event if it's available.
        bound = true;
        self.bind(transitionEnd, cb);
      } else {
        // Fallback to timers if the 'transitionend' event isn't supported.
        window.setTimeout(cb, i);
      }

      // Apply transitions.
      self.each(function() {
        if (i > 0) {
          this.style[support.transition] = transitionValue;
        }
        $(this).css(theseProperties);
      });
    };

    // Defer running. This allows the browser to paint any pending CSS it hasn't
    // painted yet before doing the transitions.
    var deferredRun = function(next) {
        this.offsetWidth; // force a repaint
        run(next);
    };

    // Use jQuery's fx queue.
    callOrQueue(self, queue, deferredRun);

    // Chainability.
    return this;
  };

  function registerCssHook(prop, isPixels) {
    // For certain properties, the 'px' should not be implied.
    if (!isPixels) { $.cssNumber[prop] = true; }

    $.transit.propertyMap[prop] = support.transform;

    $.cssHooks[prop] = {
      get: function(elem) {
        var t = $(elem).css('transit:transform');
        return t.get(prop);
      },

      set: function(elem, value) {
        var t = $(elem).css('transit:transform');
        t.setFromString(prop, value);

        $(elem).css({ 'transit:transform': t });
      }
    };

  }

  // ### uncamel(str)
  // Converts a camelcase string to a dasherized string.
  // (`marginLeft` => `margin-left`)
  function uncamel(str) {
    return str.replace(/([A-Z])/g, function(letter) { return '-' + letter.toLowerCase(); });
  }

  // ### unit(number, unit)
  // Ensures that number `number` has a unit. If no unit is found, assume the
  // default is `unit`.
  //
  //     unit(2, 'px')          //=> "2px"
  //     unit("30deg", 'rad')   //=> "30deg"
  //
  function unit(i, units) {
    if ((typeof i === "string") && (!i.match(/^[\-0-9\.]+$/))) {
      return i;
    } else {
      return "" + i + units;
    }
  }

  // ### toMS(duration)
  // Converts given `duration` to a millisecond string.
  //
  // toMS('fast') => $.fx.speeds[i] => "200ms"
  // toMS('normal') //=> $.fx.speeds._default => "400ms"
  // toMS(10) //=> '10ms'
  // toMS('100ms') //=> '100ms'  
  //
  function toMS(duration) {
    var i = duration;

    // Allow string durations like 'fast' and 'slow', without overriding numeric values.
    if (typeof i === 'string' && (!i.match(/^[\-0-9\.]+/))) { i = $.fx.speeds[i] || $.fx.speeds._default; }

    return unit(i, 'ms');
  }

  // Export some functions for testable-ness.
  $.transit.getTransitionValue = getTransition;

  return $;
}));


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function($){
  $.fn.money_field = function(opts) {
    var defaults = { width: null, symbol: '$' };
    var opts     = $.extend(defaults, opts);
    return this.each(function() {
      if(opts.width)
        $(this).css('width', opts.width + 'px');
      $(this).wrap("<div class='input-group'>").before("<span class='input-group-addon'>" + opts.symbol + "</span>");
    });
  };
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.BabySitter
// -------------------
// v0.1.10
//
// Copyright (c)2015 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://github.com/marionettejs/backbone.babysitter

(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(456), __webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
      return factory(Backbone, _);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    var Backbone = require('backbone');
    var _ = require('underscore');
    module.exports = factory(Backbone, _);
  } else {
    factory(root.Backbone, root._);
  }

}(this, function(Backbone, _) {
  'use strict';

  var previousChildViewContainer = Backbone.ChildViewContainer;

  // BabySitter.ChildViewContainer
  // -----------------------------
  //
  // Provide a container to store, retrieve and
  // shut down child views.
  
  Backbone.ChildViewContainer = (function (Backbone, _) {
  
    // Container Constructor
    // ---------------------
  
    var Container = function(views){
      this._views = {};
      this._indexByModel = {};
      this._indexByCustom = {};
      this._updateLength();
  
      _.each(views, this.add, this);
    };
  
    // Container Methods
    // -----------------
  
    _.extend(Container.prototype, {
  
      // Add a view to this container. Stores the view
      // by `cid` and makes it searchable by the model
      // cid (and model itself). Optionally specify
      // a custom key to store an retrieve the view.
      add: function(view, customIndex){
        var viewCid = view.cid;
  
        // store the view
        this._views[viewCid] = view;
  
        // index it by model
        if (view.model){
          this._indexByModel[view.model.cid] = viewCid;
        }
  
        // index by custom
        if (customIndex){
          this._indexByCustom[customIndex] = viewCid;
        }
  
        this._updateLength();
        return this;
      },
  
      // Find a view by the model that was attached to
      // it. Uses the model's `cid` to find it.
      findByModel: function(model){
        return this.findByModelCid(model.cid);
      },
  
      // Find a view by the `cid` of the model that was attached to
      // it. Uses the model's `cid` to find the view `cid` and
      // retrieve the view using it.
      findByModelCid: function(modelCid){
        var viewCid = this._indexByModel[modelCid];
        return this.findByCid(viewCid);
      },
  
      // Find a view by a custom indexer.
      findByCustom: function(index){
        var viewCid = this._indexByCustom[index];
        return this.findByCid(viewCid);
      },
  
      // Find by index. This is not guaranteed to be a
      // stable index.
      findByIndex: function(index){
        return _.values(this._views)[index];
      },
  
      // retrieve a view by its `cid` directly
      findByCid: function(cid){
        return this._views[cid];
      },
  
      // Remove a view
      remove: function(view){
        var viewCid = view.cid;
  
        // delete model index
        if (view.model){
          delete this._indexByModel[view.model.cid];
        }
  
        // delete custom index
        _.any(this._indexByCustom, function(cid, key) {
          if (cid === viewCid) {
            delete this._indexByCustom[key];
            return true;
          }
        }, this);
  
        // remove the view from the container
        delete this._views[viewCid];
  
        // update the length
        this._updateLength();
        return this;
      },
  
      // Call a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.call`.
      call: function(method){
        this.apply(method, _.tail(arguments));
      },
  
      // Apply a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.apply`.
      apply: function(method, args){
        _.each(this._views, function(view){
          if (_.isFunction(view[method])){
            view[method].apply(view, args || []);
          }
        });
      },
  
      // Update the `.length` attribute on this container
      _updateLength: function(){
        this.length = _.size(this._views);
      }
    });
  
    // Borrowing this code from Backbone.Collection:
    // http://backbonejs.org/docs/backbone.html#section-106
    //
    // Mix in methods from Underscore, for iteration, and other
    // collection related features.
    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
      'last', 'without', 'isEmpty', 'pluck', 'reduce'];
  
    _.each(methods, function(method) {
      Container.prototype[method] = function() {
        var views = _.values(this._views);
        var args = [views].concat(_.toArray(arguments));
        return _[method].apply(_, args);
      };
    });
  
    // return the public API
    return Container;
  })(Backbone, _);
  

  Backbone.ChildViewContainer.VERSION = '0.1.10';

  Backbone.ChildViewContainer.noConflict = function () {
    Backbone.ChildViewContainer = previousChildViewContainer;
    return this;
  };

  return Backbone.ChildViewContainer;

}));


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, _) {

var _apiUrl = __webpack_require__(344);

(function (Rover, $) {
  Rover.models.Image = Backbone.Model.extend({
    idAttribute: 'url',
    urlRoot: (0, _apiUrl.apiUrl)('images/'),
    defaults: {
      thumb: null,
      image: null,
      caption: null,
      index: null
    },
    url: function url() {
      if (this.isNew()) return this.urlRoot;
      return this.get('url');
    }
  });

  Rover.models.LegacyImage = Backbone.Model.extend({
    defaults: {
      id: null,
      thumb: null,
      image: null,
      caption: null,
      index: null
    }
  });

  Rover.models.CoverPhoto = Rover.models.Image.extend({
    urlRoot: Rover.urls.personImageCoverPhotoAPI,
    // Replace the current cover photo with
    // a new image from the image resource url
    // and replace this model instance
    replaceWith: function replaceWith(url, opts) {
      var self = this,
          opts = _.extend({}, opts);

      $.ajax({
        url: this.urlRoot,
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          url: url
        }),
        success: function success(data) {
          self.set(data);
          if (opts.success) opts.success(data);
        },

        error: opts.error
      });
    }
  });

  Rover.models.ImageCollection = Backbone.Collection.extend({
    model: Rover.models.Image,
    initialize: function initialize(models, opts) {
      var opts = opts || {};
      this.objectType = opts.objectType || null;
      this.objectOpk = opts.objectOpk || null;

      // Allow specifying the collection URL on instantiation
      if (opts.url) {
        this.url = opts.url;
      }
      return this;
    },
    parse: function parse(resp, options) {
      return resp.results;
    },
    create: function create(opts) {
      var opts = _.extend({
        url: this.url,
        addToCollection: true
      }, opts),
          success = opts.success,
          self = this;

      opts.success = function (model) {
        if (opts.addToCollection) self.add(model);
        if (success) success(model);
      };

      this.uploadS3Image(opts);
    },
    validateFileSize: function validateFileSize(file) {
      if (file.size >= Rover.settings.imageUploadMaxSize) {
        return 'File size too large. Got ' + file.size + '. Maximum is ' + Rover.settings.imageUploadMaxSize + '.';
      }
    },
    uploadS3Image: function uploadS3Image(opts) {
      var self = this,
          opts = _.extend({
        authorizeUrl: Rover.urls.imageUploadAuthorize
      }, opts),
          $input = $('<input>').attr('type', 'file').fileupload(_.extend({}, opts.fileupload)),
          file = opts.file;

      // Handle uploading the file to the signed S3 url
      // and calling a callback on success
      // The original method's opts.error will be called
      // on error
      var uploadToS3 = function uploadToS3(file, url, cb) {
        $input.fileupload('send', {
          url: url,
          files: [file],
          type: 'PUT',
          multipart: false,
          beforeSend: function beforeSend(xhr, data) {
            xhr.setRequestHeader('Content-Type', file.type);
            xhr.setRequestHeader('Content-Disposition', 'inline');
          },
          success: function success(result, textStatus, jqXHR) {
            cb();
          },

          error: opts.error
        });
      };

      // 1. Get a signed s3 url
      // 2. Upload our file to the signed s3 url
      // 3. POST the url to our collection root url to register it
      // 4. Add the created model to this collection and fire success
      $.ajax({
        method: 'POST',
        url: opts.authorizeUrl,
        data: {
          file_name: file.name,
          content_type: file.type,
          object_type: this.objectType,
          object_opk: this.objectOpk
        },
        beforeSend: _.bind(function (xhr) {
          var error = this.validateFileSize(file);
          if (!error) return;
          opts.error(xhr, error, '');
          return false;
        }, this),
        success: function success(authorizeData) {
          var s3Url = authorizeData.upload_url;
          uploadToS3(file, s3Url, function () {
            $.ajax({
              method: 'POST',
              url: self.url,
              data: {
                image_url: s3Url
              },
              success: function success(modelData) {
                var model = new self.model(modelData);
                if (opts.success) opts.success(model);
              },

              error: opts.error
            });
          });
        },

        error: opts.error
      });
    }
  });

  Rover.collections.PersonImageCollection = Rover.models.ImageCollection.extend({
    url: Rover.urls.personImageListAPI + '?page_size=2000'
  });

  Rover.collections.PetImageCollection = Rover.models.ImageCollection.extend({});
})(Rover, jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9), __webpack_require__(31)))

/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Rover.models = Rover.models || {};
(function () {
  Rover.models.Service = Backbone.Model.extend({
    idAttribute: 'url',
    initialize: function initialize(options) {
      this.url = options.url;
    }
  });
})();

Rover.models.ServiceModel = Backbone.Model.extend({
  url: function url() {
    return this.instanceUrl;
  },
  initialize: function initialize(options) {
    this.instanceUrl = options.url;
  }
});

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _conversation = __webpack_require__(284);

var _conversation2 = _interopRequireDefault(_conversation);

var _rover_modal = __webpack_require__(100);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Rover2.default.views.ArchiveModalView = _rover_modal2.default.extend({
  initialize: function initialize(options) {
    _rover_modal2.default.prototype.initialize.call(this, options); // super()
    this.initBindings();
    this.initConversation();
    this.initPrimaryButton();
  },
  initBindings: function initBindings() {
    _.bindAll(this, 'togglePrimaryButton');
    _.bindAll(this, 'toggleNeuter');
    _.bindAll(this, 'toggleSpay');
  },
  initConversation: function initConversation() {
    var self = this;

    this.conversation = new _conversation2.default({
      url: this.options.conversationDetailUrl
    });

    var promise = this.conversation.fetch();

    $.when(promise).then(function () {
      self.serviceType = self.conversation.get('service_type');
      self.initPreferences();
      self.initReasons();
      self.$el.find('.js-requester-short-name').text(self.conversation.get('requester').short_name);
    });
  },
  initReasons: function initReasons() {
    var self = this;
    var $el = this.$el;

    $el.find('.js-archived-reasons').change(function () {
      self.archivedReason = $(this).val();
      var isBadFit = $(this).val() === 'dog_not_good_fit';

      if (isBadFit && !self.isTravelingService()) {
        var isPrimaryEnabled = !self.options.showNeuteredOpts && !self.options.showSpayedOpts;
        self.toggleNeuter(self.options.showNeuteredOpts);
        self.toggleSpay(self.options.showSpayedOpts);
        self.togglePrimaryButton(isPrimaryEnabled);
      } else {
        self.toggleNeuter(false);
        self.toggleSpay(false);
        self.togglePrimaryButton(true);
      }
    });
  },
  initPreferences: function initPreferences() {
    var self = this;
    var options = this.options;

    $.get(_Rover2.default.urls.serviceHostingPreferences, function (data) {
      var acceptsNonNeutered = data.accepts_non_neutered_males;
      var acceptsNonSpayed = data.accepts_unspayed_females;
      var hasNonNeutered = self.hasNonNeuteredMale(self.conversation.get('pets'));
      var hasNonSpayed = self.hasNonSpayedFemale(self.conversation.get('pets'));

      options.showNeuteredOpts = hasNonNeutered && acceptsNonNeutered !== false; // is true or null
      options.showSpayedOpts = hasNonSpayed && acceptsNonSpayed !== false; // is true or null
      self.$el.find('.js-archived-reasons').removeAttr('disabled');
    }).fail(function () {
      options.showNeuteredOpts = false;
      options.showSpayedOpts = false;
      self.$el.find('.js-archived-reasons').removeAttr('disabled');
    });

    $('.js-neuter-options label').click(function () {
      options.shouldAcceptNonNeutered = $(this).find('input').val() === 'yes';

      if (options.showSpayedOpts && options.shouldAcceptNonSpayed !== undefined || !options.showSpayedOpts) {
        self.togglePrimaryButton(true);
      }
    });

    $('.js-spay-options label').click(function () {
      options.shouldAcceptNonSpayed = $(this).find('input').val() === 'yes';

      if (options.showNeuteredOpts && options.shouldAcceptNonNeutered !== undefined || !options.showNeuteredOpts) {
        self.togglePrimaryButton(true);
      }
    });
  },
  initPrimaryButton: function initPrimaryButton() {
    var self = this;

    this.$el.find('.js-modal-primary-action').click(function () {
      self.options.onSave({
        reason: self.archivedReason,
        shouldAcceptNonSpayed: self.options.shouldAcceptNonSpayed,
        shouldAcceptNonNeutered: self.options.shouldAcceptNonNeutered
      });
    });
  },
  hasNonNeuteredMale: function hasNonNeuteredMale(pets) {
    for (var i = 0; i < pets.length; i++) {
      var pet = pets[i];

      if (pet.gender === 'm' && !pet.spayed_neutered) {
        return true;
      }
    }

    return false;
  },
  hasNonSpayedFemale: function hasNonSpayedFemale(pets) {
    for (var i = 0; i < pets.length; i++) {
      var pet = pets[i];

      if (pet.gender === 'f' && !pet.spayed_neutered) {
        return true;
      }
    }

    return false;
  },
  render: function render() {
    _rover_modal2.default.prototype.render.call(this); // super()
    this.$el.find('.js-archive-modal').show();
    this.togglePrimaryButton(false);
    this.renderReasons();
  },
  renderReasons: function renderReasons() {
    var $el = this.$el;
    $el.find('.js-archived-reasons > option:not([disabled])').remove();
    $el.find('.js-archived-reasons > option').prop('selected', true);

    $.get(_Rover2.default.urls.providerArchivedReasons, function (data) {
      data.results.forEach(function (item) {
        var $option = $('<option value="' + item.reason + '">' + item.title + '</option>');
        $el.find('.js-archived-reasons').append($option);
      });
    });
  },
  toggleNeuter: function toggleNeuter(show) {
    this.$el.find('.js-neuter-options').toggle(show);
  },
  toggleSpay: function toggleSpay(show) {
    this.$el.find('.js-spay-options').toggle(show);
  },
  isTravelingService: function isTravelingService() {
    return this.conversation.getServiceType().location !== 'provider_home';
  },
  togglePrimaryButton: function togglePrimaryButton(active) {
    if (active) {
      this.$el.find('.js-modal-primary-action').removeAttr('disabled');
    } else {
      this.$el.find('.js-modal-primary-action').attr('disabled', 'true');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)))

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {
    $.fn.serializeObject = function () {
        var obj = {};
        var data = this.serializeArray();
        $.each(data, function () {
            if (obj.hasOwnProperty(this.name)) {
                if (!obj[this.name].push) {
                    obj[this.name] = [obj[this.name]];
                }
                obj[this.name].push(this.value || '');
            } else {
                obj[this.name] = this.value || '';
            }
        });
        return obj;
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(function () {
    var toggleVisible = function toggleVisible(e) {
        var $currentTarget = $(e.currentTarget),
            toggleOff = $currentTarget.attr('data-toggle-off'),
            toggleOn = $currentTarget.attr('data-toggle-on'),
            $toggleOff = $(toggleOff),
            $toggleOn = $(toggleOn),
            fadedIn = false;

        var showToggleOnElts = function showToggleOnElts() {
            // because the callback is called for each element hidden, we
            // need to keep track and only toggle once
            if (!fadedIn) {
                fadedIn = true;
                if (!$toggleOn.is(':visible')) {
                    $toggleOn.hide().removeClass('hide').fadeIn('fast');
                }
                $(window).trigger('toggle-fired', { on: toggleOn, off: toggleOff });
            }
        };

        if ($toggleOff.length) {
            $toggleOff.fadeOut('fast', function () {
                $(this).addClass('hide');
                showToggleOnElts();
            });
        } else {
            showToggleOnElts();
        }
    };

    $('.js-toggle').on('click', toggleVisible);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(function () {
  var handleCookieableClick = function handleCookieableClick() {
    var $elt = $(this),
        cookieName = $elt.attr('data-cookieable-name'),
        expires = parseInt($elt.attr('data-cookieable-expires'), 10) || 7;

    if (cookieName) {
      $.cookie(cookieName, true, { expires: expires, path: '/' });
    }
  };

  $('body').on('click', '.js-cookieable', handleCookieableClick);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _dataLayer = __webpack_require__(61);

var _dataLayer2 = _interopRequireDefault(_dataLayer);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _utils = __webpack_require__(649);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Facebook hooks
_utils.FacebookUtils.setUpFBAsyncInit();

// Dynamically load social network SDKs
_utils.SocialUtils.loadSocialScripts();

_Rover2.default.facebook = _Rover2.default.facebook || {};
_Rover2.default.googlePlus = _Rover2.default.googlePlus || {};

// A function that will be called by every social action callback
// function with its social network and action. Example
//
// 'facebook', 'share'
//
// Specific pages can implement this function to perform
// page-specific actions
_Rover2.default.trackSocial = function (socialNetwork, action, contentType, objectId) {
  if (objectId && contentType) {
    _jquery2.default.ajax({
      type: 'POST',
      url: _Rover2.default.urls.analyticsTrackShare,
      data: JSON.stringify({
        action: action,
        content_type: contentType || null,
        object_id: objectId || null,
        social_network: socialNetwork
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: function success(data) {},
      failure: function failure(err) {}
    });
  }
};

_Rover2.default.postShareCallback = function (socialNetwork, action, response) {
  _Rover2.default.trackSocial(socialNetwork, action);

  // Allow for page-specific behavior after a share
  // (e.g. scrapsbook.js pops up a "thanks for sharing" modal)
  _Rover2.default.pageSpecificPostShareCallback = _Rover2.default.pageSpecificPostShareCallback || function () {};
  _Rover2.default.pageSpecificPostShareCallback(socialNetwork, action, response);
};

// Callback for plus one events. Has to be global.
_Rover2.default.googlePlus.plusOneClick = function (response) {
  if (response.state === 'on') {
    _Rover2.default.postShareCallback('g_plus', 'share');
  }
};

// Log in via Facebook's FB API, returning Facebook auth credentials
_Rover2.default.facebook.login = function (successCallback, errCallback, scope) {
  _utils.FacebookUtils.isInitialized().then(function (FB) {
    var errorCallback = _jquery2.default.isFunction(errCallback) ? errCallback : _utils.FacebookUtils.defaultFBLoginError;

    FB.login(function (response) {
      if (response.status === 'connected') {
        // Reset any DOM state related to connecting
        (0, _jquery2.default)('.js-need-connect-to-share').addClass('hide');

        _Rover2.default.facebook.connected = true;

        if (_jquery2.default.isFunction(successCallback)) {
          successCallback({
            access_token: response.authResponse.accessToken,
            signed_request: response.authResponse.signedRequest,
            user_id: response.authResponse.userID
          });
        }
      } else {
        if (response.status === 'not_authorized') {
          _dataLayer2.default.push({
            event: 'account-sign-in-facebook',
            submitStatus: 'fail',
            errorMessage: 'not_authorized'
          });
        } else {
          _dataLayer2.default.push({
            event: 'account-sign-in-facebook',
            submitStatus: 'fail',
            errorMessage: 'facebook-login-error'
          });
        }

        errorCallback(response);
      }
    },
    // Specify which permissions we're requesting: email address
    { scope: scope || 'email' });
  });
};

_Rover2.default.facebook.signup = function (successCallback, errCallback) {
  var errorCallback = _jquery2.default.isFunction(errCallback) ? errCallback : _utils.FacebookUtils.defaultFBSignupError;
  var wrappedSuccessCallback = function wrappedSuccessCallback(authData) {
    if (_jquery2.default.isFunction(successCallback)) {
      _dataLayer2.default.push({
        event: 'account-sign-up-facebook-sign-up',
        submitStatus: 'success'
      });
      successCallback(authData);
    }

    var $form = (0, _jquery2.default)('.js-facebook-register');
    (0, _jquery2.default)('[name=access_token]', $form).val(authData.access_token);
    (0, _jquery2.default)('[name=signed_request]', $form).val(authData.signed_request);
    (0, _jquery2.default)('[name=facebook_id]', $form).val(authData.user_id);
    $form.attr('href', (0, _jquery2.default)('input[name=next]').first().val());
    $form.submit();
  };

  _Rover2.default.facebook.login(wrappedSuccessCallback, errorCallback);
};

// UI element click/submit bindings
// Facebook connect/signup/share
(0, _jquery2.default)(document).on('click', '.FBui', _utils.FacebookUtils.clickHandlers.handleFBuiClick);
(0, _jquery2.default)(document).on('click', '.js-connect-facebook', _utils.FacebookUtils.clickHandlers.handleConnectButtonClick);
(0, _jquery2.default)(document).on('click', '.js-signup-with-facebook', _utils.FacebookUtils.clickHandlers.handleSignupButtonClick);

// Pinterest - open a popup window
(0, _jquery2.default)(document).on('click', '.pin-it-button', _utils.SocialUtils.handlePinItClick);

// Photo sharing
(0, _jquery2.default)(document).on('click', '.js-social-share-photo-button', _utils.SocialUtils.handleSocialSharePhoto);
(0, _jquery2.default)(document).on('submit', '.js-share-photo-to-facebook-form', _utils.FacebookUtils.clickHandlers.validatePermissionsAndShareOnFacebook);

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Handle popovers like we used to, but using new bootstrap
// http://stackoverflow.com/questions/7703878/how-can-i-hold-twitter-bootstrap-popover-open-until-my-mouse-moves-into-it
_Rover2.default.popoverTemplate = '\n    <div class="popover" onmouseover="clearTimeout(Rover.timeoutObj);$(this).mouseleave(function() {$(this).hide();});">\n        <div class="arrow"></div>\n        <div class="popover-inner">\n            <h3 class="popover-title"></h3>\n            <div class="popover-content">\n                <p></p>\n            </div>\n        </div>\n    </div>';

_Rover2.default.timeoutObj = false;
_Rover2.default.stickyPopover = function (selector, option) {
  var $elts = (0, _jquery2.default)(selector);
  if (!$elts.length) {
    return;
  }

  var options = _jquery2.default.extend({
    template: _Rover2.default.popoverTemplate,
    html: true,
    container: '.js-popover-container',
    trigger: 'manual'
  }, option);

  var onBodyClicked = function onBodyClicked(e) {
    var $target = (0, _jquery2.default)(e.target);
    (0, _jquery2.default)('.popover').not($target.parent()).not($target).popover('hide');
  };

  (0, _jquery2.default)(selector).each(function () {
    var self = this;
    var $popover = (0, _jquery2.default)(this).popover('destroy').popover(options);

    var touched = false;
    var showing = false;
    var showPopover = function showPopover() {
      (0, _jquery2.default)(self).popover('show');
      showing = true;
    };
    var hidePopover = function hidePopover() {
      (0, _jquery2.default)(self).popover('hide');
      showing = false;
    };

    $popover.off('touchstart').on('touchstart', function (e) {
      // prevents double open/flash
      touched = true;
      setTimeout(function () {
        touched = false;
      }, 150);

      showing ? hidePopover() : showPopover();
    }).off('mouseenter').on('mouseenter', function (e) {
      // prevents double open/flash
      if (touched) return;
      showPopover();
    }).off('mouseleave').on('mouseleave', function (e) {
      _Rover2.default.timeoutObj = setTimeout(hidePopover, 50);
    });

    $popover.off('shown.bs.popover').on('shown.bs.popover', function () {
      (0, _jquery2.default)('body').on('click', onBodyClicked);

      (0, _jquery2.default)(self).off('hide.bs.popover').on('hide.bs.popover', function () {
        (0, _jquery2.default)('body').off('click', onBodyClicked);
        (0, _jquery2.default)(self).off('hide.bs.popover');
      });
    });
  });
};

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(function () {
  var hidePhoto = function hidePhoto(e) {
    var $hideButton = $(e.currentTarget);
    $hideButton.btn('loading');

    $.ajax({
      url: Rover.urls.hidePhotoUrl,
      type: 'POST',
      data: {
        image_id: $hideButton.attr('data-object-id')
      },
      success: function success() {
        toggleHiddenPhotoOnPage($hideButton.attr('data-hidden') === 'false', $hideButton);
      },
      error: function error() {
        alert('Failed to perform operation. Please refresh the page and try again.');
        $hideButton.btn($hideButton.attr('data-hidden') === 'false' ? 'hide' : 'unhide');
      }
    });
  };

  var toggleHiddenPhotoOnPage = function toggleHiddenPhotoOnPage(wasHidden, $buttonClicked) {
    var $photoOnPage = $('.js-shareable-image[data-object-id=' + $buttonClicked.attr('data-object-id') + ']');

    if (wasHidden) {
      $buttonClicked.attr('data-hidden', 'true').btn('unhide');
      $photoOnPage.addClass('hidden-photo').attr('data-hidden', 'true').find('.js-hidden-photo').removeClass('hide');
    } else {
      $buttonClicked.attr('data-hidden', 'false').btn('hide');
      $photoOnPage.removeClass('hidden-photo').attr('data-hidden', 'false').find('.js-hidden-photo').addClass('hide');
    }
  };

  var addBindings = function addBindings() {
    $(document).on('click', '.js-hide-photo', hidePhoto);
  };

  var init = function init() {
    addBindings();
  };

  init();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

var _Alerts = __webpack_require__(25);

var _Alerts2 = _interopRequireDefault(_Alerts);

var _apiUrl = __webpack_require__(344);

var _service_button_group_view = __webpack_require__(1261);

var _service_button_group_view2 = _interopRequireDefault(_service_button_group_view);

var _service_button_group_collection = __webpack_require__(1270);

var _service_button_group_collection2 = _interopRequireDefault(_service_button_group_collection);

var _service_button_group_model = __webpack_require__(652);

var _service_button_group_model2 = _interopRequireDefault(_service_button_group_model);

var _currentUser = __webpack_require__(262);

var _currentUser2 = _interopRequireDefault(_currentUser);

var _intl_tel_input = __webpack_require__(308);

__webpack_require__(1275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

Rover.views = Rover.views || {};

Rover.views.RebookDialogView = Backbone.View.extend({
  /*
     *  Class variables
     */
  userPets: null,
  template: Mustache.template('js/app/stays/rebook'),
  $form: null,
  sender: null,
  receiver: null,
  service_url: null,
  person: _currentUser2.default,
  isSubmitting: false,

  /*
     *  Initialization functions
     */

  initialize: function initialize(options) {
    _.bindAll(this, 'preRenderSetup', 'render', 'getContext', '_fetchUserPets', 'cancel', 'submit', 'conversationCreated');

    var browsable_services = options.services.filter(function (s) {
      return s.service_type.browsable;
    });

    this.services = new _service_button_group_collection2.default(browsable_services.map(function (s) {
      return new _service_button_group_model2.default(s);
    }));

    this.userPets = new Rover.collections.DogCollection();

    // Pre-setup
    var that = this;
    this.options = options;
    this.url = options.url;
    this.selected_service = options.selected_service;
    this.sender = options.sender;
    this.receiver = options.receiver;
    this.provider = options.provider;
    this.requester = options.requester;
    this.service_url = options.service_url;
    this.extraContext = options.extraContext;
    this.preRenderSetup().done(function () {
      that.render();
    });
  },
  initServiceButtonGroupView: function initServiceButtonGroupView() {
    return new _service_button_group_view2.default({
      services: {
        el: this.$('.js-service-selection')
      },
      dates: {
        el: this.$('.stay-duration'),
        disableStart: !!this.getContext().startDate,
        startDate: this.getContext().startDate
      },
      collection: this.services
    }).render();
  },
  preRenderSetup: function preRenderSetup() {
    var _$;

    var petRequests = this._fetchUserPets();
    return (_$ = $).when.apply(_$, _toConsumableArray(petRequests));
  },
  postRenderSetup: function postRenderSetup() {
    this.$form = this.$el.find('.js-rebook-form');
    this.$form.validate({
      ignore: ':hidden:not(.js-validate-element),' + '.js-service-dates-spec.hidden input'
    });

    var context = this.getContext();
    if (context.needsPhoneNumber) {
      var $intlTelInput = (0, _intl_tel_input.initIntlTelInput)(this.$el.find('.js-phone-number-input'));
      $intlTelInput.each(_intl_tel_input.updateCleaveForInputs);
      $intlTelInput.on('countrychange', _intl_tel_input.updateCleaveForInputs);
    }
  },
  _fetchUserPets: function _fetchUserPets() {
    var that = this;
    _.each(this.requester.pets, function (pet) {
      if (pet.active) {
        that.userPets.add(new Rover.models.Dog(pet));
      }
    });
    return [];
  },
  render: function render() {
    var context = this.getContext();
    this.$el.html(this.template.render(context));
    this.postRenderSetup();
    $('.modal-backdrop').remove();
    $(this.el).find('.js-rebook-modal').modal();
    this.serviceView = this.initServiceButtonGroupView({
      startDate: context.startDate
    });

    if (this.services.getBySlug(this.selected_service)) {
      this.services.setSelected(this.selected_service);
    } else {
      this.services.setSelected(this.services.at(0).get('slug'));
    }
  },
  getContext: function getContext() {
    var pets = this.userPets.toJSON();
    pets[pets.length - 1].last = true;
    var context = {
      provider: this.provider,
      requester: this.requester,
      sender: this.sender,
      receiver: this.receiver,
      pets: pets,
      service_url: this.service_url,
      action: this.url || (0, _apiUrl.apiUrl)('conversations/'),
      needsPhoneNumber: this.sender.private.has_phone_number === 'False'
    };

    var services = this.services.toJSON();
    if (services.length > 1) {
      context.services = services;
      this.setServiceColWidth(context);
    }
    _.each(services, function (service) {
      var p = service.service_type.name.split(/\s+/);
      service.top_name = p[0];
      p.splice(0, 1);
      service.bottom_name = p.join(' ');
    });
    $.extend(context, this.extraContext || {});
    return context;
  },
  setServiceColWidth: function setServiceColWidth(context) {
    context.col_sm = Math.floor(12 / this.services.length);
    if (context.col_sm === 2) {
      context.col_sm = 15;
    }
  },
  cancel: function cancel() {
    $(this.el).find('.js-rebook-modal').modal('hide');
  },
  submit: function submit() {
    // logic to prevent the rare case of double submission
    if (this.isSubmitting) {
      return false;
    }
    this.isSubmitting = true;
    try {
      this._ajaxSubmit();
    } catch (err) {
      // TODO - Consider sending this to Sentry
      this.isSubmitting = false;
      console.log(err);
      _Alerts2.default.showAlert('extending your stay');
    } finally {
      // We need to always prevent form submission since it will be done
      // by the browser and will return an error page from the
      // Browseable API (due to missing CSRF, which is required if you
      // send the request as application/x-www-form-urlencoded)
      return false;
    }
  },
  getPostData: function getPostData() {
    var context = this.getContext();
    var formData = this.$form.serializeObject(),
        data = {};
    data.pets = formData.pets || [];
    if (!data.pets.push) {
      data.pets = [data.pets];
    }
    data.content = formData.content;
    data.provider = formData.provider;
    data.requester = formData.requester;
    data.sender = formData.sender;
    data.source = 'web';
    data.service = this.services.getSelected().get('url');
    if (context.needsPhoneNumber) {
      data.phone_number = formData.phone_number;
    }
    data = _.extend(data, this.serviceView.getDatesData());
    return data;
  },
  _ajaxSubmit: function _ajaxSubmit() {
    var data = this.getPostData(),
        that = this;
    this.$('.js-submit-rebook-request').btn('loading');

    $.ajax({
      url: this.serviceView.getContactUrl(),
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: that.conversationCreated,
      error: function error(xhr) {
        var validator = that.$form.validate({
          ignore: [':hidden:not(.js-validate-element)'],
          errorPlacement: function errorPlacement($error, $element) {
            if ($element.hasClass('js-form-group-error-placement')) {
              $element = $element.closest('.form-group');
            }
            $.validator.defaults.errorPlacement($error, $element);
          }
        });
        validator.showErrors(xhr.responseJSON.error);
        that.$('.js-submit-rebook-request').btn('reset');
      }
    });
  },
  conversationCreated: function conversationCreated(conversation) {
    this.isSubmitting = false;
    window.location = conversation.web_url + '?is_rebook';
  },


  events: {
    'click .js-cancel': 'cancel',
    'submit .js-rebook-form': 'submit'
  }
});

Rover.views.ExtendDialogView = Rover.views.RebookDialogView.extend({
  template: Mustache.template('js/app/stays/extend'),
  getPostData: function getPostData() {
    var data = Rover.views.RebookDialogView.prototype.getPostData.call(this),
        formData = this.$form.serializeObject();
    data.extended_stay_conversation = 1;
    data.original_conversation = formData.original_conversation;
    return data;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(9)))

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(function () {
  if (!$('body').hasClass('account-payments')) {
    return;
  }
  var setUpPaymentMethodSelectionTable = function setUpPaymentMethodSelectionTable() {
    $('.js-method-specific').addClass('disabled');
    $('.js-method-specific').on('click', function () {
      var $this = $(this);
      var $radio = $this.closest('.js-nested-selection-wdiget').find('.js-method-select');
      if ($this.length > 0) {
        $radio.prop('checked', true);
      }
      $radio.trigger('change');
    });
    $('.js-method-select').on('change', function () {
      $('.js-method-select').each(function (i, radio) {
        var $radio = $(this);
        var $select = $radio.closest('.js-nested-selection-widget').find('.js-method-specific');
        var $submit = $('.js-withdrawal-submit');
        if ($radio.prop('checked')) {
          var needs_w9 = $radio.attr('id') === 'check-select' && $radio.attr('data-w9-submitted') === 'false';
          var $w9_warning = $('#w9-warning');

          $select.removeClass('disabled');
          $submit.val('Withdraw via ' + $radio.val());
          if (needs_w9) {
            $submit.addClass('disabled');
            $w9_warning.show();
          } else {
            $submit.removeClass('disabled');
            $w9_warning.hide();
          }
        } else {
          $select.addClass('disabled');
        }
      });
    });
    $('.js-method-select').trigger('change');
  };
  // Make this available inside autopay.js
  Rover.setUpPaymentMethodSelectionTable = setUpPaymentMethodSelectionTable;

  var displayActiveFlatNav = function displayActiveFlatNav(id) {
    $('.js-payments-table').hide();
    $(id).show();
  };

  var displayHashedView = function displayHashedView(defaultHash) {
    var hash = window.location.hash || defaultHash;
    if (hash) {
      $('a[href="' + hash + '"]').trigger('click');
    }
  };

  var addBindings = function addBindings() {
    $('.js-payments-nav').on('click', function (e) {
      var $this = $(this);
      var href = $this.attr('href');
      displayActiveFlatNav(href);
      if (history && history.replaceState) {
        history.replaceState({}, '', href);
      }
      $('.js-payments-nav').closest('li').removeClass('active');
      $this.closest('li').addClass('active');
      e.preventDefault();
    });
    $('.js-gus-tip-dismiss').on('click', function () {
      var $gusTip = $(this).closest('.js-gus-tip');
      $.cookie($gusTip.data('gus-tip-cookie'), 'dismissed', { expires: 180 });
      $gusTip.hide();
    });
    $('.currencywidget').money_field({
      symbol: $('.before_text').text()
    });
  };

  var init = function init() {
    Rover.stickyPopover('[data-toggle="sticky-popover"]', {
      container: 'body',
      placement: 'top'
    });

    // Ensure that we don't allow double click on redeeming funds Submit button
    var $redeem_button = $('.js-redeem-button');
    var $redeem_form = $('.js-redeem-form');

    $redeem_button.removeAttr('disabled');
    $redeem_form.on('submit', function () {
      $redeem_button.attr('disabled', 'disabled');

      // Fix a chrome bug: http://code.google.com/p/chromium/issues/detail?id=37402
      if ($redeem_form.attr('data-submitted') !== 'true') {
        $redeem_form.attr('data-submitted', 'true');
        return true;
      } else if ($redeem_form.attr('data-submitted') === 'true') {
        return false;
      }
    });

    // Set up payment methods table - clicking anywhere on a row selects that row, and
    // the method select for each row is disabled until that row is selected.
    setUpPaymentMethodSelectionTable('#redemption-table');

    addBindings();

    displayHashedView('#payments-earnings');
  };

  init();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Rover.models.Phone = Backbone.Model.extend({
  initialize: function initialize() {
    return this;
  },

  defaults: {
    id: null,
    phone_number: '',
    is_verified: null,
    verify_method: null,
    verify_token: null,
    error_message: null,
    opt_in: false,
    errorMessages: null
  },
  url: function url() {
    return Rover.urls.phoneVerify;
  },
  validate: function validate(attributes) {
    var phone = attributes.phone_number.replace(/[^0-9]/g, ''),
        msg = '* Phone number must be in XXX-XXX-XXXX format';
    if (phone.length != 10) {
      this.set('errorMessages', msg);
      return msg;
    }
  },
  isVerified: function isVerified() {
    return !!this.get('is_verified');
  },
  verify: function verify(token, cb) {
    this.save({ verify_token: token }, {
      success: function success(model, resp) {
        if (_.isFunction(cb)) {
          cb(!resp.is_verified, model, resp);
        }
      },
      error: function error(model, resp) {
        if (_.isFunction(cb)) {
          cb(true, model, resp);
        }
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postalCodeValidator = undefined;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datetime = __webpack_require__(26);

var _datetime2 = _interopRequireDefault(_datetime);

var _Rover = __webpack_require__(3);

var _Rover2 = _interopRequireDefault(_Rover);

var _moment = __webpack_require__(174);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Rover2.default.ValidationUtils = _Rover2.default.ValidationUtils || {};

function PostalCodesRegex(postal) {
  //  Any supported country should have the postal code regex added there
  //  Source of GB Regex: https://roverdotcom.atlassian.net/browse/DEV-20164
  var regexRules = {
    usRegex: /^\d{5}-\d{4}$|^\d{5}$/,
    caRegex: /^[A-Z][0-9][A-Z][-\s]?[0-9][A-Z][0-9]$/,
    gbRegex: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$/
  };
  return {
    valid: function validate() {
      return Object.values(regexRules).some(function (rule) {
        return rule.test(postal);
      });
    }
  };
}

_jquery2.default.validator.addMethod('min_words', function (value, element, n) {
  return (0, _jquery2.default)(element).wordCount() >= n;
}, _jquery2.default.validator.format('Please write at least {0} words.'));

var postalCodeValidator = exports.postalCodeValidator = function postalCodeValidator(postal, element) {
  var optionalCheck = (0, _jquery2.default)(element).validate().optional(element);
  return optionalCheck || PostalCodesRegex(postal).valid();
};

(function () {
  var filters = null;
  var contact = '';

  function initFilters() {
    if (filters) return;
    var emailDefinite = [/[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/];
    var urlDefinite = [/(http:\/\/|https:\/\/)?([a-zA-Z0-9]{2,4}\.)?[a-zA-Z0-9]+\.(com|org|gov|biz|cat|coop|info|int|jobs|mobi|museum|name|net|pro|tel|travel|co\.uk|COM|ORG|GOV|BIZ|CAT|COOP|INFO|INT|JOBS|MOBI|MUSEUM|NAME|NET|PRO|TEL|TRAVEL|CO\.UK)(\/[-a-zA-Z0-9\/]+)?/];
    var phoneDefinite = [/(1[- \.])?\(?\d{3}\)?[- \.]?\d{3}[- \.]?\d{4}/, /\d{3}[- \.]?\d{4}/];
    filters = emailDefinite.concat(urlDefinite).concat(phoneDefinite);
  }

  function runFilters(text) {
    var matches = _.map(filters, function (filter) {
      return text.match(filter);
    });
    matches = _.filter(matches, function (match) {
      return !!match && !match[0].match(/rover.com/i);
    });
    return matches;
  }

  function onContactsFound(contacts) {
    contact = contacts[0][0];
  }

  _jquery2.default.validator.addMethod('disallow_contact', function (value, element) {
    initFilters();
    var contacts = runFilters((0, _jquery2.default)(element).val());
    contacts.length && onContactsFound(contacts);
    return contacts.length == 0;
  }, function () {
    return 'For your security, please remove "' + contact + '" from your description. Owners' + ' will contact you through Rover, and you must book all stays through' + ' the site. It\'s safe and easy - plus, the stay will be covered by' + ' premium insurance and 24/7 emergency support.';
  });

  _jquery2.default.validator.addMethod('zippostalValidate', postalCodeValidator, _jquery2.default.validator.format('Please specify a valid ZIP/postal/postcode.'));

  _jquery2.default.validator.addMethod('js-cc-address-zipcode', postalCodeValidator, _jquery2.default.validator.format('Please specify a valid ZIP/postal/postcode.'));

  _jquery2.default.validator.addMethod('l10ndate', function (value, element) {
    return (0, _moment2.default)(value, _datetime2.default.DATE_SHORT).isValid();
  }, 'Please enter a valid date.');
})();

(function (o) {
  /**
   * $ validation plugin does not play well with
   * bootstrap's button plugin. In particular when a button
   * is clicked, the event is not caught by the $
   * validation plugin becasue the event target is bootstrap's
   * div wrapper, not the input element.
   *
   * This click handler refires a click event from the
   * input element when there is an error pop-over over
   * the element.
   */
  var namespace = '.hideValidationErrorOnButtonClick';
  o.hideValidationErrorOnButtonClick = function () {
    (0, _jquery2.default)('[data-toggle^="button"]').off(namespace).on('click' + namespace, function (evt) {
      var $target = (0, _jquery2.default)(evt.target).closest('[data-toggle^="button"]');
      var $errorPopover = (0, _jquery2.default)('.error-popover', $target);
      $target.off(namespace);
      if (!$errorPopover.size()) return;
      (0, _jquery2.default)('input[aria-describedby="' + $errorPopover.attr('id') + '"]', $target).click();
      evt.stopImmediatePropagation();
    });
  };
})(_Rover2.default.ValidationUtils);

exports.default = postalCodeValidator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1254]);


// WEBPACK FOOTER //
// common.b9955a449196bca7.js